/**
 * EgiftShippingApp
 * eGift配送設定ページのメインアプリケーション
 * shipping-app.jsとは独立したファイル（マルチアドレス不要のシンプル構成）
 */

var EgiftShippingApp = (function () {

  // ---------------------------------------------------------------------------
  // Constants
  // ---------------------------------------------------------------------------

  var DEFAULT_SHIPPING_VARIANT_IDS = {
    ambient: 53026172240237,  // 常温・冷蔵便
    frozen:  53026172273005,  // 冷凍便
    mail:    53026172305773   // メール便
  };

  function toShippingVariantId(value) {
    if (value === undefined || value === null || value === '') return null;
    if (typeof value === 'object') {
      if (value.id !== undefined && value.id !== null) return toShippingVariantId(value.id);
      if (value.shopifyProductVariantId !== undefined && value.shopifyProductVariantId !== null) {
        return toShippingVariantId(value.shopifyProductVariantId);
      }
      return null;
    }
    var text = String(value);
    var num = parseInt(text, 10);
    if (!isFinite(num) || num <= 0) {
      var match = text.match(/(\d+)(?!.*\d)/);
      if (match) num = parseInt(match[1], 10);
    }
    return isFinite(num) && num > 0 ? num : null;
  }

  function resolveShippingVariantIds(config) {
    var source = config || {};
    return {
      ambient: toShippingVariantId(source.ambient) || DEFAULT_SHIPPING_VARIANT_IDS.ambient,
      frozen: toShippingVariantId(source.frozen) || DEFAULT_SHIPPING_VARIANT_IDS.frozen,
      mail: toShippingVariantId(source.mail) || DEFAULT_SHIPPING_VARIANT_IDS.mail
    };
  }

  var SHIPPING_VARIANT_IDS = resolveShippingVariantIds(window.shippingVariantIds);

  var SHIPPING_METHOD_TITLES = {
    ambient: '常温・冷蔵便',
    frozen:  '冷凍便',
    mail:    'メール便'
  };
  var SHIPPING_RATE_API_ENDPOINT = '/apps/ping/shipping/rates/calculate';
  var DEFAULT_NICKNAME_MAX_LENGTH = 20;
  var DESTINATION_NAME_MAX_LENGTH = 20;
  var DESTINATION_NAME_FALLBACK_FOR_API = 'お相手さま';
  var SENDER_STORAGE_KEY = 'egift_sender_info';
  var ORDERER_STORAGE_KEY = 'egift_orderer_info';
  var BAG_SETTINGS_STORAGE_KEY = 'egift_bag_settings';
  var PAID_BAG_MAX_QTY = 500;

  function normalizePaidHandbagMasterVariants(rawVariants) {
    if (!Array.isArray(rawVariants)) return [];

    var normalized = [];
    rawVariants.forEach(function (raw) {
      if (!raw) return;

      var variantId = raw.shopifyProductVariantId !== undefined && raw.shopifyProductVariantId !== null
        ? String(raw.shopifyProductVariantId)
        : '';
      if (!variantId) return;

      var price = parseInt(raw.price, 10);
      if (!isFinite(price) || price <= 0) return;

      normalized.push({
        shopifyProductVariantId: variantId,
        title: raw.title ? String(raw.title) : '手提げ袋（紙）',
        price: String(price),
        image: raw.image ? String(raw.image) : '',
        priority: parseInt(raw.priority, 10) || 0,
        isRecommended: raw.isRecommended === true
      });
    });

    normalized.sort(function (a, b) {
      return (a.priority || 0) - (b.priority || 0);
    });

    return normalized;
  }

  function normalizeFreeHandbagVariant(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var variantId = raw.shopifyProductVariantId !== undefined && raw.shopifyProductVariantId !== null
      ? String(raw.shopifyProductVariantId)
      : '';
    if (!variantId) return null;

    return {
      shopifyProductVariantId: variantId,
      title: raw.name ? String(raw.name) : (raw.title ? String(raw.title) : '無料手提げ袋'),
      price: '0',
      image: raw.image ? String(raw.image) : '',
      priority: -1
    };
  }

  function hasPaidCustomerNumber(address) {
    var address2 = address && address.address2;
    return String(address2 || '').indexOf('顧客番号：') !== -1;
  }

  var DEFAULT_PAID_HANDBAG_VARIANTS = [
    { shopifyProductVariantId: '53026172010861', title: '手提げ袋（紙） - 特小', price: '22', image: 'https://cdn.shopify.com/s/files/1/0942/6301/7837/files/paper_bag-20250801_png.webp?v=1771058426', priority: 10 },
    { shopifyProductVariantId: '53026172043629', title: '手提げ袋（紙） - 小', price: '33', image: 'https://cdn.shopify.com/s/files/1/0942/6301/7837/files/paper_bag-20250801_png.webp?v=1771058426', priority: 20 },
    { shopifyProductVariantId: '53026172076397', title: '手提げ袋（紙） - 中', price: '44', image: 'https://cdn.shopify.com/s/files/1/0942/6301/7837/files/paper_bag-20250801_png.webp?v=1771058426', priority: 30 }
  ];
  var masterPaidHandbagVariants = normalizePaidHandbagMasterVariants(window.bagAttachmentMasterVariants);
  var PAID_HANDBAG_VARIANTS = masterPaidHandbagVariants.length ? masterPaidHandbagVariants : DEFAULT_PAID_HANDBAG_VARIANTS;

  var YOKUMOKU_SENDER = {
    lastName:     'ヨックモック公式オンラインショップ',
    firstName:    '',
    zip:          '1070062',
    prefecture:   '東京都',
    prefectureCode: 'JP-13',
    countryCode:  'JP',
    city:         '港区',
    address1:     '南青山5-3-3',
    address2:     '',
    phone:        '0120220727'
  };

  // ---------------------------------------------------------------------------
  // State
  // ---------------------------------------------------------------------------

  var state = {
    cart:             null,
    giftConfig:       null,
    messageCards:     [],
    nicknameMaxLength: DEFAULT_NICKNAME_MAX_LENGTH,
    wrapImage:        '',
    paidBagImage:     '',
    noshiImage:       '',
    ribbonImage:      '',
    bagSettings:      {},   // { itemKey: { bags: {variantId: qty}, freeBagEnabled: bool, paidBagEnabled: bool } }
    noshiSettings:    {},   // { itemKey: { gid, name, mode, texts, ... } }
    stickerSettings:  {},   // { itemKey: { gid, name, category, ... } }
    wrapOnlyItems:    {},   // { itemKey: true }
    noWrapItems:      {},   // { itemKey: true }
    singleSplitLines: {},   // { itemKey: { lines: [{ id, qty, settings }] } }
    deliverySettings: {},   // { shipmentKey: { date, time } }
    sender:           null,
    shippingTotal:    null,
    shippingRateInfo: null,   // { price: string, title: string } — first item shippingLine data
    shippingLoading:  false,
    currentBagItemKey: null,
    currentBagVariantId: null,
    modalScrollTop:   0,
    initialized:      false
  };

  // ---------------------------------------------------------------------------
  // Public API
  // ---------------------------------------------------------------------------

  var app = {
    currentNoshiItemKey: null,
    currentNoshiSplitLineKey: null,
    currentStickerSplitLineKey: null,
    selectedNoshiEntry: null,
    currentNoshiMode: null,
    _currentNoshiFiltered: [],

    /**
     * Entry point — called from DOMContentLoaded
     */
    init: function () {
      if (!window.isEgiftMode) return;
      this.config();
    },

    /**
     * Load cart + AllInGift SDK, then render UI
     */
    config: function () {
      var self = this;
      // Clean login_redirect param from URL if present (legacy param, kept for compatibility)
      if (new URLSearchParams(window.location.search).get('login_redirect') === '1') {
        var cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('login_redirect');
        history.replaceState(null, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
      }

      // Snapshot per-line prices to detect any discount change after POST.
      // total_price comparison misses cases where Automatic Discount replaces another promotion
      // (total may stay the same or increase while line discounts change).
      var priceSnapshot = function (c) {
        var lines = c.items.map(function (item) {
          return { key: item.key, original_price: item.original_price, final_price: item.final_price, quantity: item.quantity };
        });
        lines.sort(function (a, b) { return String(a.key).localeCompare(String(b.key)); });
        return JSON.stringify(lines);
      };

      // Automatic Discounts only recalculate on cart WRITE. For any logged-in customer,
      // check API eligibility and Applies to scope before writing — Customer Tags are no
      // longer consulted.
      var initialCart = window.initialCart;
      var needsDiscountRefresh = !this._discountCheckDone &&
        !!(window.shippingCustomer && window.shippingCustomer.id) && !!initialCart &&
        !!(initialCart.items && initialCart.items.length > 0);
      var preSnapshot = needsDiscountRefresh ? priceSnapshot(initialCart) : null;

      if (needsDiscountRefresh) {
        this._discountCheckDone = true;
        var updates = {};
        initialCart.items.forEach(function (item) {
          updates[item.key] = item.quantity;
        });
        // Collect applied titles and cart facts to pass to the API.
        // Both should_refresh_cart and needs_discount_recalculation are evaluated server-side.
        var _egAppliedMap = {};
        (initialCart.cart_level_discount_applications || []).forEach(function(app) {
          if (app && app.title) _egAppliedMap[app.title] = true;
        });
        (initialCart.items || []).forEach(function(item) {
          (item.line_level_discount_allocations || []).forEach(function(alloc) {
            var app = alloc.discount_application;
            if (app && app.title) _egAppliedMap[app.title] = true;
          });
        });
        var _egAppliedTitles = Object.keys(_egAppliedMap);
        // Read the stored eligibility fingerprint so the API can detect eligibility changes.
        var _egFpKey = 'yk_dfp_' + (window.shippingCustomer && window.shippingCustomer.id || '');
        var _egStoredFp = '';
        try { _egStoredFp = localStorage.getItem(_egFpKey) || ''; } catch (e) {}
        // Use flat JSON scalar params instead of bracket notation to preserve App Proxy HMAC
        // signature compatibility (Shopify signs the original key names; bracket keys are
        // parsed by Express into arrays/objects, causing signature verification to fail).
        var _egAjaxData = {
          discount_titles_json: JSON.stringify(_egAppliedTitles),
          cart_subtotal: initialCart.total_price || 0,
          cart_items_json: JSON.stringify((initialCart.items || []).map(function(item) {
            return {
              variant_id: String(item.variant_id),
              product_id: String(item.product_id),
              quantity: item.quantity
            };
          }))
        };
        if (_egStoredFp) { _egAjaxData.eligibility_fingerprint = _egStoredFp; }
        // Check API before writing; fail open when API is unavailable.
        $.ajax({
          url: '/apps/ping/discounts/automatic-rates',
          type: 'GET',
          dataType: 'json',
          traditional: false,
          data: _egAjaxData
        }).then(function (responseData) {
          return {
            should_refresh_cart: !!(responseData && responseData.should_refresh_cart),
            needs_discount_recalculation: !!(responseData && responseData.needs_discount_recalculation),
            eligibility_fingerprint: (responseData && responseData.eligibility_fingerprint) || null
          };
        }, function () { return { should_refresh_cart: true, needs_discount_recalculation: true, eligibility_fingerprint: null }; }) // API error → fail open
          .then(function (result) {
            // Hold the fingerprint in memory; commit only after we know no WRITE is required,
            // or after a WRITE succeeds. A failed WRITE must leave the old fingerprint so the
            // next page load retries recalculation.
            var _egPendingFp = result.eligibility_fingerprint != null
              ? String(result.eligibility_fingerprint)
              : null;
            // Skip WRITE when API confirms no stale discount AND no eligible rule with met minimum is absent.
            // No WRITE required → safe to commit the fingerprint immediately.
            if (!result.should_refresh_cart && !result.needs_discount_recalculation) {
              if (_egPendingFp !== null) { try { localStorage.setItem(_egFpKey, _egPendingFp); } catch (e) {} }
              window.initialCart = initialCart;
              self.config();
              return;
            }
            $.ajax({
              url: window.routes.cart_update_url + '.js',
              type: 'POST',
              contentType: 'application/json',
              dataType: 'json',
              data: JSON.stringify({ updates: updates })
            }).done(function (updatedCart) {
              // WRITE succeeded → commit the fingerprint so the next request does not retry unnecessarily.
              if (_egPendingFp !== null) { try { localStorage.setItem(_egFpKey, _egPendingFp); } catch (e) {} }
              if (priceSnapshot(updatedCart) !== preSnapshot) {
                window.location.reload();
              } else {
                // Prices unchanged → no new discount → use fresh response as source of truth
                window.initialCart = updatedCart;
                self.config();
              }
            }).fail(function () {
              // Continue with the existing cart rather than blocking the eGift page.
              // Fingerprint is NOT committed on failure; the next load will retry.
              self.config();
            });
          });
        return;
      }

      // Guest path: API-driven stale-discount detection.
      var isGuestWithCart = !this._discountCheckDone && !!initialCart &&
        !!(initialCart.items && initialCart.items.length > 0);
      if (isGuestWithCart) {
        this._discountCheckDone = true;
        var guestPreSnapshot = priceSnapshot(initialCart);
        // Collect titles from cart-level and line-level fields (discount_applications is not
        // in the Ajax cart response).
        var _tSeen = {};
        (initialCart.cart_level_discount_applications || []).forEach(function(app) {
          if (app && app.title) _tSeen[app.title] = true;
        });
        (initialCart.items || []).forEach(function(item) {
          (item.line_level_discount_allocations || []).forEach(function(alloc) {
            var app = alloc.discount_application;
            if (app && app.title) _tSeen[app.title] = true;
          });
        });
        var discountTitlesArr = Object.keys(_tSeen);
        if (!discountTitlesArr.length) {
          // No discounts in cart — skip API check and proceed normally.
          state.cart = initialCart;
          self.config();
          return;
        }
        $.ajax({
          url: '/apps/ping/discounts/automatic-rates',
          type: 'GET',
          dataType: 'json',
          data: { discount_titles_json: JSON.stringify(discountTitlesArr) }
        }).then(function(data) {
          if (!data || !data.should_refresh_cart) {
            state.cart = initialCart;
            self.config();
            return;
          }
          var guestUpdates = {};
          initialCart.items.forEach(function (item) { guestUpdates[item.key] = item.quantity; });
          $.ajax({
            url: window.routes.cart_update_url + '.js',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify({ updates: guestUpdates })
          }).done(function (updatedCart) {
            if (priceSnapshot(updatedCart) !== guestPreSnapshot) {
              window.location.reload();
            } else {
              window.initialCart = updatedCart;
              self.config();
            }
          }).fail(function () {
            self.config();
          });
        }, function() {
          // API error → skip refresh, proceed normally.
          state.cart = initialCart;
          self.config();
        });
        return;
      }

      // Cart already available via Liquid
      state.cart = window.initialCart || null;
      if (!state.cart || !state.cart.items || state.cart.items.length === 0) {
        this._clearAllEgiftData();
        window.location.replace('/cart');
        return;
      }
      if (!this.isAllEgift()) {
        alert('eギフト対象外の商品、または複数温度帯の商品が含まれているためeギフトをご利用いただけません。');
        window.location.replace('/cart');
        return;
      }

      this._loadData();
      this._loadAssetImages();
      this._bindOrdererEvents();
      this._bindSenderEvents();
      this._renderOrderer();
      this._setNicknameMaxLength(DEFAULT_NICKNAME_MAX_LENGTH);

      // Auto-open orderer modal when orderer info is missing
      if (!state.orderer || !state.orderer.lastName || !state.orderer.firstName) {
        this.openModal('modalEgiftAddOrderer');
        $('#modalEgiftAddOrderer').addClass('no-outside-close');
      }
      this._restoreEgiftForm();
      this._renderMessageCardLoading();
      this._calculateEgiftShippingRate();
      this._renderGiftOptionsForAllItems();
      this._bindEgiftFormEvents();
      this._bindPreviewButton();
      this._bindCheckoutButton();
      this._updatePreviewButtonState();
      this._updateCheckoutButtonState();

      this.waitForAllInGift().then(function () {
        window.AllInGift.config().then(function (giftConfig) {
          state.giftConfig = giftConfig;
          self._setNicknameMaxLength(self._resolveNicknameMaxLength(giftConfig));
          self._applyMessageCardsFromConfig(giftConfig);
          self._renderGiftOptionsForAllItems();
          self._updatePreviewButtonState();
          self._updateCheckoutButtonState();
        }).catch(function () {
          self._setNicknameMaxLength(DEFAULT_NICKNAME_MAX_LENGTH);
          self._applyMessageCardsFromConfig(null);
          self._renderGiftOptionsForAllItems();
          self._updatePreviewButtonState();
          self._updateCheckoutButtonState();
        });
      }).catch(function () {
        self._setNicknameMaxLength(DEFAULT_NICKNAME_MAX_LENGTH);
        self._applyMessageCardsFromConfig(null);
        self._renderGiftOptionsForAllItems();
        self._updatePreviewButtonState();
        self._updateCheckoutButtonState();
      });
    },

    // ---------------------------------------------------------------------------
    // eGift eligibility
    // ---------------------------------------------------------------------------

    isAllEgift: function () {
      var items = (state.cart && state.cart.items) || [];
      if (!items.length) return false;

      var zoneMap = {};
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var meta = (window.cartItemsMetafields || {})[item.key] || {};
        if (!this._toBoolean(meta.flags_is_social_gift_available)) {
          return false;
        }

        zoneMap[this.getItemShippingType(item)] = true;
      }

      return Object.keys(zoneMap).length === 1;
    },

    // ---------------------------------------------------------------------------
    // Orderer / Sender rendering
    // ---------------------------------------------------------------------------

    _renderOrderer: function () {
      var $el = $('[data-orderer-info]');
      if (!$el.length) return;
      this._ordererAddressFieldErrors = {};
      $('[data-orderer-validation-errors]').remove();

      var o = state.orderer;
      if (!o || !o.lastName) {
        $el.html(
          '<p class="c-text-muted">お客様の情報が登録されていません。</p>' +
          '<button type="button" class="c-btn c-btn--outline u-mt-8" data-egift-open-orderer-modal>' +
          'お客様の情報を登録してください</button>'
        );
        $('[data-orderer-change-btn]').hide();
        return;
      }

      var fullName = $.trim((o.lastName || '') + ' ' + (o.firstName || ''));
      var address = '〒' + this._escapeHtml(this._formatZipDisplay(o.zip) || '---') + '<br>' +
                    this._escapeHtml((o.prefecture || '') + (o.city || '') + (o.address1 || ''));
      if (o.address2) {
        address += '<br>' + this._escapeHtml(o.address2);
      }
      if (o.company) {
        address += '<br>' + this._escapeHtml(o.company);
      }
      address += '<br>TEL: ' + this._escapeHtml(o.phone ? this._formatPhoneDisplay(o.phone) : '---');

      $el.html(
        '<p class="p-address__name">' + this._escapeHtml(fullName) + ' 様</p>' +
        '<p class="p-address__detail">' + address + '</p>'
      );
      $('[data-orderer-change-btn]').show();
    },

    _defaultSender: function () {
      return $.extend({}, YOKUMOKU_SENDER);
    },

    _PROVINCE_MAP: {
      'JP-01': '北海道', 'JP-02': '青森県', 'JP-03': '岩手県', 'JP-04': '宮城県',
      'JP-05': '秋田県', 'JP-06': '山形県', 'JP-07': '福島県', 'JP-08': '茨城県',
      'JP-09': '栃木県', 'JP-10': '群馬県', 'JP-11': '埼玉県', 'JP-12': '千葉県',
      'JP-13': '東京都', 'JP-14': '神奈川県', 'JP-15': '新潟県', 'JP-16': '富山県',
      'JP-17': '石川県', 'JP-18': '福井県', 'JP-19': '山梨県', 'JP-20': '長野県',
      'JP-21': '岐阜県', 'JP-22': '静岡県', 'JP-23': '愛知県', 'JP-24': '三重県',
      'JP-25': '滋賀県', 'JP-26': '京都府', 'JP-27': '大阪府', 'JP-28': '兵庫県',
      'JP-29': '奈良県', 'JP-30': '和歌山県', 'JP-31': '鳥取県', 'JP-32': '島根県',
      'JP-33': '岡山県', 'JP-34': '広島県', 'JP-35': '山口県', 'JP-36': '徳島県',
      'JP-37': '香川県', 'JP-38': '愛媛県', 'JP-39': '高知県', 'JP-40': '福岡県',
      'JP-41': '佐賀県', 'JP-42': '長崎県', 'JP-43': '熊本県', 'JP-44': '大分県',
      'JP-45': '宮崎県', 'JP-46': '鹿児島県', 'JP-47': '沖縄県'
    },

    _getPrefectureNameByCode: function (code) {
      return this._PROVINCE_MAP[code] || code || '';
    },

    // ---------------------------------------------------------------------------
    // Address utility functions (shared with shipping-app.js logic)
    // ---------------------------------------------------------------------------

    _normalizeHalfWidthDigits: function (value) {
      return String(value || '').replace(/[０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 65248);
      });
    },

    _normalizeZipInput: function (value) {
      return this._normalizeHalfWidthDigits(value).replace(/\D/g, '');
    },

    _getGiftSettingCountMax: function ($input) {
      var $container = $input.closest('[data-noshi-count], [data-sticker-count]');
      var max = parseInt($container.find('[data-noshi-count-total], [data-sticker-count-total]').first().text(), 10);
      return Math.max(1, max || 1);
    },

    _normalizeGiftSettingCountValue: function (value, max, fallbackValue) {
      var limit = Math.max(1, parseInt(max, 10) || 1);
      var fallback = Math.max(1, Math.min(parseInt(fallbackValue, 10) || limit, limit));
      var digits = this._normalizeHalfWidthDigits(value).replace(/\D/g, '');
      var parsed = parseInt(digits, 10);
      if (isNaN(parsed)) parsed = fallback;
      return Math.max(1, Math.min(parsed, limit));
    },

    syncGiftSettingCountControl: function ($input, fallbackValue) {
      if (!$input || !$input.length) return 1;
      var max = this._getGiftSettingCountMax($input);
      var normalized = this._normalizeGiftSettingCountValue($input.val(), max, fallbackValue == null ? max : fallbackValue);
      var isLocked = $input.prop('disabled');
      var $qty = $input.closest('.qty');
      var disableMinus = isLocked || normalized <= 1;
      var disablePlus = isLocked || normalized >= max;

      $input.val(normalized);
      $qty.find('[data-step="-1"]').prop('disabled', disableMinus).toggleClass('is-disabled', disableMinus);
      $qty.find('[data-step="1"]').prop('disabled', disablePlus).toggleClass('is-disabled', disablePlus);

      return normalized;
    },


    _normalizePhoneInput: function (value) {
      var digits = this._normalizeHalfWidthDigits(value).replace(/\D/g, '');
      if (digits.indexOf('81') === 0) {
        var local = digits.slice(2);
        if (local && local.charAt(0) !== '0') {
          local = '0' + local;
        }
        digits = local;
      }
      return digits;
    },

    _formatZipDisplay: function (zip) {
      if (!zip) return zip;
      var d = String(zip).replace(/\D/g, '');
      if (d.length === 7) return d.slice(0, 3) + '-' + d.slice(3);
      return d || zip;
    },

    _formatPhoneDisplay: function (phone) {
      if (!phone) return phone;
      var d = String(phone).replace(/\D/g, '');
      if (!d) return phone;
      // Use libphonenumber-js for accurate Japanese area code formatting
      if (typeof libphonenumber !== 'undefined' && libphonenumber.parsePhoneNumberFromString) {
        try {
          var parsed = libphonenumber.parsePhoneNumberFromString(d, 'JP');
          if (parsed && parsed.isValid()) {
            return parsed.formatNational();
          }
        } catch (e) {}
      }
      // Fallback: basic formatting
      if (d.length === 11) {
        return d.slice(0, 3) + '-' + d.slice(3, 7) + '-' + d.slice(7);
      }
      if (d.length === 10) {
        if (d.slice(0, 2) === '03' || d.slice(0, 2) === '06') {
          return d.slice(0, 2) + '-' + d.slice(2, 6) + '-' + d.slice(6);
        }
        return d.slice(0, 3) + '-' + d.slice(3, 6) + '-' + d.slice(6);
      }
      return d || phone;
    },

    _normalizeAddressText: function (value) {
      return String(value || '').replace(/\r?\n/g, ' ').trim();
    },

    _normalizeAddressPayload: function (addr) {
      var n = $.extend({}, addr || {});
      n.lastName      = this._normalizeAddressText(n.lastName);
      n.firstName     = this._normalizeAddressText(n.firstName);
      n.zip           = this._normalizeZipInput(n.zip);
      n.prefecture    = this._normalizeAddressText(n.prefecture);
      n.prefectureCode = String(n.prefectureCode || '').trim();
      n.city          = this._normalizeAddressText(n.city);
      n.address1      = this._normalizeAddressText(n.address1);
      n.address2      = this._normalizeAddressText(n.address2);
      n.company       = this._normalizeAddressText(n.company);
      n.phone         = this._normalizePhoneInput(n.phone);
      n.personType    = n.personType === 'corporate' ? 'corporate' : 'individual';
      if (n.personType !== 'corporate') { n.company = ''; }
      return n;
    },

    _getAddressPersonType: function (prefix) {
      var val = $('input[name="' + prefix + '-personType"]:checked').val();
      return val === 'corporate' ? 'corporate' : 'individual';
    },

    _setAddressPersonType: function (prefix, personType) {
      var type = personType === 'corporate' ? 'corporate' : 'individual';
      $('input[name="' + prefix + '-personType"][value="' + type + '"]').prop('checked', true);
      this._toggleAddressCompanyField(prefix, type === 'corporate');
    },

    _toggleAddressCompanyField: function (prefix, show) {
      var $row = $('#' + prefix + '-company-row');
      var $company = $('#' + prefix + '-company');
      if (!$row.length) return;
      $row.toggle(!!show);
      if (!show) {
        $company.val('');
        $row.find('.p-row-item').removeClass('is-error');
        $row.find('.p-form-error-txt').remove();
      }
    },

    /**
     * Validate address fields — matches shipping-app.js validateAddressFields logic
     * @param {Object} addr - Address object (will be normalized in-place)
     * @param {string} prefix - DOM ID prefix (e.g. 'egift-orderer')
     * @returns {boolean}
     */
    _validateAddressFields: function (addr, prefix) {
      var errors = {};
      var extraErrorFields = [];
      var combinedNameError = null;
      var normalized = this._normalizeAddressPayload(addr);
      var charError = function(value, scope) {
        if (!value || !window.CharValidator) return null;
        return window.CharValidator.validate(value, scope);
      };

      // 姓
      var lastNameCharError = charError(normalized.lastName, 'name');
      if (!normalized.lastName) {
        errors.lastName = '姓を入力してください。';
      } else if (lastNameCharError) {
        errors.lastName = lastNameCharError;
      }

      // 名
      var firstNameCharError = charError(normalized.firstName, 'name');
      if (!normalized.firstName) {
        errors.firstName = '名を入力してください。';
      } else if (firstNameCharError) {
        errors.firstName = firstNameCharError;
      }
      // 姓名合計 ≤ 36 全角
      if (normalized.lastName && normalized.firstName && !errors.lastName && !errors.firstName) {
        var nameCombined = countJaChars(normalized.lastName + normalized.firstName);
        if (nameCombined > 36) {
          var nameExcess = Math.ceil(nameCombined - 36);
          combinedNameError = 'お名前は「36文字以内」となるようご入力ください。（' + nameExcess + '文字超過しています。）';
          extraErrorFields.push('lastName', 'firstName');
        }
      }
      // 郵便番号
      if (!normalized.zip) {
        errors.zip = '郵便番号を入力してください。';
      } else if (!/^\d{7}$/.test(normalized.zip)) {
        errors.zip = '郵便番号は半角数字7桁で入力してください。';
      }
      // 都道府県
      if (!normalized.prefectureCode) {
        if (!errors.zip && normalized.zip) {
          errors.zip = '郵便番号から住所が見つかりませんでした。';
        } else {
          errors.prefecture = '都道府県を選択してください。';
        }
      }
      // 市区町村
      var cityCharError = charError(normalized.city, 'global');
      if (!normalized.city) {
        errors.city = '市区町村を入力してください。';
      } else if (normalized.city.length > 100) {
        errors.city = '市区町村は100文字以内で入力してください。';
      } else if (cityCharError) {
        errors.city = cityCharError;
      }

      // 住所
      var address1CharError = charError(normalized.address1, 'address');
      if (!normalized.address1) {
        errors.address1 = '住所を入力してください。';
      } else if (normalized.address1.length > 200) {
        errors.address1 = '住所は200文字以内で入力してください。';
      } else if (address1CharError) {
        errors.address1 = address1CharError;
      }

      // 建物名
      var address2CharError = charError(normalized.address2, 'address');
      if (normalized.address2) {
        if (normalized.address2.length > 200) {
          errors.address2 = '建物名は200文字以内で入力してください。';
        } else if (address2CharError) {
          errors.address2 = address2CharError;
        }
      }

      // 会社名
      var companyCharError = charError(normalized.company, 'address');
      if (normalized.personType === 'corporate') {
        if (!normalized.company) {
          errors.company = '会社名を入力してください。';
        } else if (normalized.company.length > 200) {
          errors.company = '会社名は200文字以内で入力してください。';
        } else if (companyCharError) {
          errors.company = companyCharError;
        }
      }
      // 住所合計 ≤ 89 全角（個人）
      // ※ エラーメッセージは「全角」表記なし（文字数は通常カウント表示）
      if (normalized.personType !== 'corporate' && normalized.prefecture && normalized.city && normalized.address1 &&
          !errors.prefecture && !errors.city && !errors.address1 && !errors.address2) {
        var combinedAddr = normalized.prefecture + normalized.city + normalized.address1 + (normalized.address2 || '');
        if (countJaChars(combinedAddr) > 89) {
          var addrExcess = Math.ceil(countJaChars(combinedAddr) - 89);
          errors.address2 = '「住所」は「89文字以内」となるようご入力ください。（' + addrExcess + '文字超過しています。）';
          extraErrorFields.push('prefecture', 'city', 'address1');
        }
      }
      // 住所＋会社名合計 ≤ 89 全角（法人）
      // ※ エラーメッセージは「全角」表記なし（文字数は通常カウント表示）
      if (normalized.personType === 'corporate' && normalized.company && normalized.prefecture && normalized.city && normalized.address1 &&
          !errors.company && !errors.prefecture && !errors.city && !errors.address1 && !errors.address2) {
        var combinedCorpAddr = normalized.company + ' ' + normalized.prefecture + normalized.city + normalized.address1 + (normalized.address2 || '');
        if (countJaChars(combinedCorpAddr) > 89) {
          var corpExcess = Math.ceil(countJaChars(combinedCorpAddr) - 89);
          errors.address2 = '「住所＋会社名」の合計が「89文字以内」となるようご入力ください。（' + corpExcess + '文字超過しています。）';
          extraErrorFields.push('company', 'prefecture', 'city', 'address1');
        }
      }
      // 電話番号
      if (!normalized.phone) {
        errors.phone = '電話番号を入力してください。';
      } else if (!/^(0[5789]0\d{8}|0[1-9]\d{8}|0120\d{6}|0800\d{7})$/.test(normalized.phone)) {
        errors.phone = '正しい電話番号を入力してください。';
      } else if (/0{8}$/.test(normalized.phone)) {
        errors.phone = '正しい電話番号を入力してください。';
      }

      // DOM field ID mapping
      var fieldIdMap = {
        lastName: prefix + '-lastName', firstName: prefix + '-firstName',
        zip: prefix + '-zipCode', prefecture: prefix + '-prefecture',
        city: prefix + '-city', address1: prefix + '-address1-num',
        address2: prefix + '-address2', company: prefix + '-company',
        phone: prefix + '-phone'
      };

      // Apply normalized values back to form
      var valueMap = {
        lastName: normalized.lastName, firstName: normalized.firstName,
        zip: normalized.zip, city: normalized.city,
        address1: normalized.address1, address2: normalized.address2,
        company: normalized.company, phone: normalized.phone
      };
      Object.keys(valueMap).forEach(function (field) {
        var $el = $('#' + fieldIdMap[field]);
        if ($el.length) $el.val(valueMap[field]);
      });
      // address1-num は town+num の合算値が書き戻されるため、town prefix を除去する
      var $numField = $('#' + fieldIdMap.address1);
      var $townField = $('#' + prefix + '-address1-town');
      if ($numField.length && $townField.length) {
        var town = $townField.val() || '';
        var combined = $numField.val() || '';
        if (town && combined.indexOf(town) === 0) {
          $numField.val(combined.slice(town.length));
        }
      }

      // Write back to caller
      Object.keys(normalized).forEach(function (key) { addr[key] = normalized[key]; });

      // Clear previous errors
      Object.keys(fieldIdMap).forEach(function (field) {
        var $el = $('#' + fieldIdMap[field]);
        if (!$el.length) return;
        $el.closest('.p-row-item').removeClass('is-error');
        $el.closest('.p-row-item').find('.p-form-error-txt').remove();
      });
      // Hide inline zip-lookup-error so it doesn't double up with the validation error
      $('#' + fieldIdMap.zip).siblings('.zip-lookup-error').hide();
      $('#' + fieldIdMap.lastName).closest('.p-row').next('.p-combined-error').remove();

      // Apply errors
      var hasErrors = Object.keys(errors).length > 0 || combinedNameError !== null;
      if (hasErrors) {
        Object.keys(errors).forEach(function (field) {
          var $el = $('#' + fieldIdMap[field]);
          if (!$el.length) return;
          var $rowItem = $el.closest('.p-row-item');
          $rowItem.addClass('is-error');
          $rowItem.append('<p class="p-form-error-txt">' + errors[field] + '</p>');
        });
        extraErrorFields.forEach(function (field) {
          if (errors[field]) return;
          var $el = $('#' + fieldIdMap[field]);
          if (!$el.length) return;
          $el.closest('.p-row-item').addClass('is-error');
        });
        if (combinedNameError) {
          var $nameRow = $('#' + fieldIdMap.lastName).closest('.p-row');
          if ($nameRow.length) {
            $nameRow.after('<p class="p-form-error-txt p-combined-error">' + combinedNameError + '</p>');
          }
        }
        // Scroll to first error
        var firstErrorField = Object.keys(errors)[0];
        var $firstError = firstErrorField ? $('#' + fieldIdMap[firstErrorField]) : $('#' + fieldIdMap.lastName);
        var $modal = $firstError.closest('.p-modal-content');
        if ($modal.length) {
          var scrollTo = $firstError.closest('.p-row').get(0);
          if (scrollTo) scrollTo.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      return !hasErrors;
    },

    // ---------------------------------------------------------------------------
    // Orderer registration / editing
    // ---------------------------------------------------------------------------

    _bindOrdererEvents: function () {
      var self = this;

      $(document).off('click.egiftOrderer', '[data-egift-open-orderer-modal]').on('click.egiftOrderer', '[data-egift-open-orderer-modal]', function (e) {
        e.preventDefault();
        self._fillOrdererModal(state.orderer);
        self.openModal('modalEgiftAddOrderer');
        if (state.orderer && self._ordererAddressFieldErrors && Object.keys(self._ordererAddressFieldErrors).length) {
          var fieldErrors = self._ordererAddressFieldErrors;
          if (fieldErrors.zip) {
            self._showOrdererFieldError('egift-orderer-zipCode', fieldErrors.zip);
          }
          if (fieldErrors.phone) {
            self._showOrdererFieldError('egift-orderer-phone', fieldErrors.phone);
          }
        }
      });

      $(document).off('click.egiftOrderer', '[data-egift-add-orderer]').on('click.egiftOrderer', '[data-egift-add-orderer]', function (e) {
        e.preventDefault();
        self._addOrdererInfo();
      });

      // Zip code normalization + auto-lookup with dedup guards
      $(document).off('input.egiftOrderer change.egiftOrderer blur.egiftOrderer', '#egift-orderer-zipCode')
        .on('input.egiftOrderer change.egiftOrderer blur.egiftOrderer', '#egift-orderer-zipCode', function () {
          var $el = $(this);
          var $errorEl = $el.siblings('.zip-lookup-error');
          var normalized = self._normalizeZipInput($el.val());
          if (normalized !== $el.val()) $el.val(normalized);

          var lastZip = $el.data('lastLookupZip') || '';

          // Impossible length → hide error, clear stale autofill once, no fetch.
          if (normalized.length !== 7) {
            if ($errorEl.length) $errorEl.hide();
            if (lastZip) {
              $('#egift-orderer-prefecture').val('');
              $('#egift-orderer-city').val('');
              $('#egift-orderer-address1-town').val('');
              $el.data('lastLookupZip', '');
            }
            return;
          }
          // No change since last dispatch → skip.
          if (lastZip === normalized) {
            if ($errorEl.length) $errorEl.hide();
            return;
          }
          $el.data('lastLookupZip', normalized);
          if ($errorEl.length) $errorEl.hide();

          var req = self._lookupZipcode(normalized, $('#egift-orderer-prefecture'), $('#egift-orderer-city'), $('#egift-orderer-address1-town'), $errorEl, $el);
          if (req) {
            self._beginOrdererZipLookup();
            req.always(function () { self._endOrdererZipLookup(); });
          }
        });
      // Lock prefecture select: only changeable via zip autofill
      $(document).on('mousedown', '#egift-orderer-prefecture', function(e) { e.preventDefault(); this.blur(); });
      $(document).on('keydown', '#egift-orderer-prefecture', function(e) { if (e.key !== 'Tab') e.preventDefault(); });
      // Lock address1-town: only changeable via zip autofill
      $(document).on('mousedown', '#egift-orderer-address1-town', function(e) { e.preventDefault(); this.blur(); });
      $(document).on('keydown', '#egift-orderer-address1-town', function(e) { if (e.key !== 'Tab') e.preventDefault(); });

      // Lock sender prefecture: only changeable via zip autofill
      $(document).on('mousedown', '#sender-prefecture', function(e) { e.preventDefault(); this.blur(); });
      $(document).on('keydown', '#sender-prefecture', function(e) { if (e.key !== 'Tab') e.preventDefault(); });

      // Phone normalization
      $(document).off('input.egiftOrderer change.egiftOrderer blur.egiftOrderer', '#egift-orderer-phone')
        .on('input.egiftOrderer change.egiftOrderer blur.egiftOrderer', '#egift-orderer-phone', function () {
          var normalized = self._normalizePhoneInput($(this).val());
          if (normalized !== $(this).val()) $(this).val(normalized);
        });

      // Person type toggle (個人/法人)
      $(document).off('change.egiftOrderer', 'input[name="egift-orderer-personType"]')
        .on('change.egiftOrderer', 'input[name="egift-orderer-personType"]', function () {
          self._toggleAddressCompanyField('egift-orderer', $(this).val() === 'corporate');
        });
    },

    _fillOrdererModal: function (orderer) {
      $('#modalEgiftAddOrderer [data-egift-add-orderer]').prop('disabled', false);
      if (!orderer) {
        this._clearOrdererForm();
        return;
      }
      var self = this;

      // Sync fill from stored data
      $('#egift-orderer-lastName').val(orderer.lastName || '');
      $('#egift-orderer-firstName').val(orderer.firstName || '');
      $('#egift-orderer-zipCode').val(orderer.zip || '');
      $('#egift-orderer-prefecture').val(orderer.prefectureCode || '');
      $('#egift-orderer-city').val(orderer.city || '');
      $('#egift-orderer-address2').val(orderer.address2 || '');
      $('#egift-orderer-company').val(orderer.company || '');
      $('#egift-orderer-phone').val(orderer.phone || '');
      this._setAddressPersonType('egift-orderer', orderer.personType || 'individual');

      // Town/num: use cached split if we have one, otherwise full address1 into num.
      var hasCachedSplit = typeof orderer.address1Town === 'string' || typeof orderer.address1Num === 'string';
      $('#egift-orderer-address1-town').val(hasCachedSplit ? (orderer.address1Town || '') : '');
      $('#egift-orderer-address1-num').val(hasCachedSplit ? (orderer.address1Num || '') : (orderer.address1 || ''));
      this._updateTownWidth($('#egift-orderer-address1-town'));

      // 顧客番号が含まれるフィールドのみ編集不可にする（shipping-app.js と同パターン）
      var lockedStyle = { background: '#f5f5f5', color: '#888', cursor: 'not-allowed' };
      var unlockedStyle = { background: '', color: '', cursor: '' };
      var lockedNotice = '<p class="js-egift-orderer-locked-notice" style="margin-top:6px;font-size:1.2rem;color:#666;">Paidサービスをご利用のお客様は編集できません。カスタマーサポートまでお問い合わせください。</p>';
      var $modal = $('#modalEgiftAddOrderer');
      $modal.find('.js-egift-orderer-locked-notice').remove();

      var $oAddr1 = $modal.find('#egift-orderer-address1-num');
      var $oAddr2 = $modal.find('#egift-orderer-address2');
      if ((orderer.address1 || '').indexOf('顧客番号') !== -1) {
        $oAddr1.prop('readonly', true).css(lockedStyle).data('lockedValue', orderer.address1);
        $oAddr1.closest('.p-row-item').append(lockedNotice);
      } else {
        $oAddr1.prop('readonly', false).css(unlockedStyle).removeData('lockedValue');
      }
      if ((orderer.address2 || '').indexOf('顧客番号') !== -1) {
        $oAddr2.prop('readonly', true).css(lockedStyle).data('lockedValue', orderer.address2);
        $oAddr2.closest('.p-row-item').append(lockedNotice);
      } else {
        $oAddr2.prop('readonly', false).css(unlockedStyle).removeData('lockedValue');
      }

      // Clear previous errors (validation + inline + cached lookup)
      ['lastName', 'firstName', 'zipCode', 'prefecture', 'city', 'address1-num', 'address2', 'company', 'phone'].forEach(function (f) {
        var $el = $('#egift-orderer-' + f);
        $el.closest('.p-row-item').removeClass('is-error');
        $el.closest('.p-row-item').find('.p-form-error-txt').remove();
      });
      $('#egift-orderer-lastName').closest('.p-row').next('.p-combined-error').remove();
      $('#modalEgiftAddOrderer .zip-lookup-error').hide();
      $('#egift-orderer-zipCode').removeData('lastLookupZip');

      // Single consolidated API call only when we're missing data.
      var normalizedZip = String(orderer.zip || '').replace(/\D/g, '');
      var hasValidZip = /^\d{7}$/.test(normalizedZip);
      var needsPrefRecovery = hasValidZip && !orderer.prefectureCode;
      var needsAddressSplit = hasValidZip && !hasCachedSplit && !!orderer.address1;

      if (!needsPrefRecovery && !needsAddressSplit) return;

      this._beginOrdererZipLookup();
      var pmap = this._PROVINCE_MAP || {};
      $.ajax({
        url: '/apps/ping/postal-codes/search',
        dataType: 'jsonp',
        data: { zipcode: normalizedZip },
        timeout: 3000
      }).then(function (res) {
        if (!(res && res.status === 200 && res.results && res.results.length > 0)) return;

        var matched = null;
        if (needsAddressSplit && orderer.address1) {
          for (var i = 0; i < res.results.length; i++) {
            var a3 = res.results[i].address3 || '';
            if (a3 && orderer.address1.indexOf(a3) === 0) { matched = res.results[i]; break; }
          }
        }

        var applyResult = function (r) {
          if (needsPrefRecovery) {
            var code = '';
            Object.keys(pmap).some(function (c) {
              if (pmap[c] === r.address1) { code = c; return true; }
              return false;
            });
            if (code && !$('#egift-orderer-prefecture').val()) {
              $('#egift-orderer-prefecture').val(code);
            }
            if (!$('#egift-orderer-city').val()) $('#egift-orderer-city').val(r.address2 || '');
          }
          if (needsAddressSplit) {
            var town = r.address3 || '';
            if (town && orderer.address1.indexOf(town) === 0) {
              $('#egift-orderer-address1-town').val(town);
              $('#egift-orderer-address1-num').val(orderer.address1.slice(town.length));
            } else {
              $('#egift-orderer-address1-town').val(town);
              $('#egift-orderer-address1-num').val(orderer.address1);
            }
            self._updateTownWidth($('#egift-orderer-address1-town'));
          }
        };

        if (matched) {
          applyResult(matched);
        } else if (res.results.length > 1) {
          self._showZipCandidatePicker(res.results, applyResult);
        } else {
          applyResult(res.results[0]);
        }
      }).always(function () {
        self._endOrdererZipLookup();
      });
    },

    _clearOrdererForm: function () {
      $('#egift-orderer-lastName, #egift-orderer-firstName, #egift-orderer-zipCode, #egift-orderer-city, #egift-orderer-address1-town, #egift-orderer-address1-num, #egift-orderer-address2, #egift-orderer-company, #egift-orderer-phone').val('');
      $('#egift-orderer-prefecture').val('');
      this._setAddressPersonType('egift-orderer', 'individual');
    },

    _addOrdererInfo: function () {
      // 顧客番号ロックされたフィールドは元の値を使う（shipping-app.js と同パターン）
      var townVal = $('#egift-orderer-address1-town').val() || '';
      var numVal = $('#egift-orderer-address1-num').val() || '';
      var lockedAddr1 = $('#egift-orderer-address1-num').data('lockedValue');
      var addr1Val = lockedAddr1 || (townVal + numVal).trim();
      var addr2Val = $('#egift-orderer-address2').data('lockedValue') || $('#egift-orderer-address2').val();

      var newAddr = this._normalizeAddressPayload({
        lastName:       $('#egift-orderer-lastName').val(),
        firstName:      $('#egift-orderer-firstName').val(),
        zip:            $('#egift-orderer-zipCode').val(),
        prefecture:     $('#egift-orderer-prefecture option:selected').text(),
        prefectureCode: $('#egift-orderer-prefecture').val(),
        city:           $('#egift-orderer-city').val(),
        address1:       addr1Val,
        address1Town:   lockedAddr1 ? '' : townVal,
        address1Num:    lockedAddr1 ? '' : numVal,
        address2:       addr2Val,
        company:        $('#egift-orderer-company').val(),
        personType:     this._getAddressPersonType('egift-orderer'),
        phone:          $('#egift-orderer-phone').val(),
        countryCode:    'JP'
      });

      if (!this._validateAddressFields(newAddr, 'egift-orderer')) {
        return;
      }

      // Logged-in: save to Shopify as default address via API
      if (window.shippingCustomer) {
        var self = this;
        var $btn = $('#modalEgiftAddOrderer [data-egift-add-orderer]');
        $btn.prop('disabled', true);

        var payload = {
          lastName:  newAddr.lastName,
          firstName: newAddr.firstName,
          company:   newAddr.company || '',
          zip:       newAddr.zip,
          province:  newAddr.prefecture,
          city:      newAddr.city,
          address1:  newAddr.address1,
          address2:  newAddr.address2 || '',
          phone:     newAddr.phone || '',
          setAsDefault: true
        };

        var existingId = state.orderer && state.orderer.addressId;
        var apiUrl, apiMethod;
        if (existingId) {
          var match = String(existingId).match(/MailingAddress\/(\d+)/);
          var numericId = match ? match[1] : existingId;
          apiUrl = '/apps/ping/customers/addresses/' + numericId + window.location.search;
          apiMethod = 'PUT';
        } else {
          apiUrl = '/apps/ping/customers/addresses' + window.location.search;
          apiMethod = 'POST';
        }

        $.ajax({
          url: apiUrl,
          method: apiMethod,
          contentType: 'application/json',
          data: JSON.stringify(payload),
          xhrFields: { withCredentials: true }
        }).then(function (data) {
          var savedId = (data && data.address && data.address.id) ? data.address.id : (existingId || '');
          self._clearOrdererForm();
          self._completeOrdererRegistration(newAddr, savedId);
        }).fail(function (xhr) {
          var json = xhr.responseJSON;
          var errMsg = '住所の登録に失敗しました。しばらくしてから再度お試しください。';
          if (json && json.errors && json.errors.length > 0) {
            errMsg = json.errors.map(function (e) { return e.message || JSON.stringify(e); }).join('\n');
          } else if (json && json.message) {
            errMsg = json.message;
          }
          if (errMsg === 'Address already exists') {
            errMsg = '「会員様ご住所」または、「アドレス帳」にすでに同じ情報が登録されています。重複登録はできません。';
          }
          alert(errMsg);
          $btn.prop('disabled', false);
        });
        return;
      }

      // Guest: save locally only
      this._clearOrdererForm();
      this._completeOrdererRegistration(newAddr);
    },

    _completeOrdererRegistration: function (newAddr, addressId) {
      if (!newAddr.prefectureCode) {
      }
      state.orderer = {
        addressId:      addressId || '',
        lastName:       newAddr.lastName || '',
        firstName:      newAddr.firstName || '',
        zip:            newAddr.zip || '',
        prefecture:     newAddr.prefecture || '',
        prefectureCode: newAddr.prefectureCode || '',
        city:           newAddr.city || '',
        address1:       newAddr.address1 || '',
        address1Town:   newAddr.address1Town || '',
        address1Num:    newAddr.address1Num || '',
        address2:       newAddr.address2 || '',
        company:        newAddr.company || '',
        personType:     newAddr.personType || 'individual',
        phone:          newAddr.phone || '',
        countryCode:    'JP'
      };
      localStorage.setItem(ORDERER_STORAGE_KEY, JSON.stringify(state.orderer));

      this.closeModal('modalEgiftAddOrderer');
      this._renderOrderer();
      this._updateCheckoutButtonState();
    },

    _normalizeDomesticPhone: function (value) {
      var digits = String(value || '').replace(/[０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 65248);
      }).replace(/\D/g, '').slice(0, 20);

      if (digits.indexOf('81') === 0) {
        var local = digits.slice(2);
        if (local && local.charAt(0) !== '0') {
          local = '0' + local;
        }
        digits = local;
      }

      return digits.slice(0, 11);
    },

    _normalizeSender: function (sender) {
      var merged = $.extend({}, this._defaultSender(), sender || {});
      merged.lastName = $.trim(String(merged.lastName || ''));
      merged.firstName = $.trim(String(merged.firstName || ''));
      merged.zip = String(merged.zip || '').replace(/\D/g, '').slice(0, 7);
      merged.city = $.trim(String(merged.city || ''));
      merged.address1 = $.trim(String(merged.address1 || ''));
      merged.address2 = $.trim(String(merged.address2 || ''));
      merged.phone = this._normalizeDomesticPhone(merged.phone || '');
      merged.countryCode = merged.countryCode || 'JP';
      if (!merged.prefectureCode && merged.provinceCode) {
        merged.prefectureCode = merged.provinceCode;
      }
      if (!merged.prefectureCode) {
        merged.prefectureCode = YOKUMOKU_SENDER.prefectureCode;
      }
      if (!merged.prefecture) {
        merged.prefecture = this._resolvePrefectureName(merged.prefectureCode) || YOKUMOKU_SENDER.prefecture;
      }
      if (!merged.lastName) {
        merged.lastName = YOKUMOKU_SENDER.lastName;
      }
      if (!merged.zip) {
        merged.zip = YOKUMOKU_SENDER.zip;
      }
      if (!merged.city) {
        merged.city = YOKUMOKU_SENDER.city;
      }
      if (!merged.address1) {
        merged.address1 = YOKUMOKU_SENDER.address1;
      }
      if (!merged.phone) {
        merged.phone = YOKUMOKU_SENDER.phone;
      }
      return merged;
    },

    _fillSenderModal: function (sender) {
      $('#sender-lastName').val(sender.lastName || '');
      $('#sender-firstName').val(sender.firstName || '');
      $('#sender-zipCode').val(sender.zip || '');
      $('#sender-prefecture').val(sender.prefectureCode || '');
      $('#sender-city').val(sender.city || '');
      $('#sender-address1').val(sender.address1 || '').removeAttr('data-address1-town');
      $('#sender-address2').val(sender.address2 || '');
      $('#sender-phone').val(sender.phone || '');
      this._clearSenderFieldErrors();
      this._prefillSenderAddress1Town(sender.zip);
    },

    _prefillSenderAddress1Town: function (zip) {
      var cleanZip = (zip || '').replace(/\D/g, '');
      if (cleanZip.length !== 7) return;
      $.ajax({
        url: '/apps/ping/postal-codes/search',
        dataType: 'jsonp',
        data: { zipcode: cleanZip },
        timeout: 3000,
        success: function (res) {
          if (!res || res.status !== 200 || !res.results || !res.results.length) return;
          var town = res.results[0].address3 || '';
          if (town) $('#sender-address1').attr('data-address1-town', town);
        }
      });
    },

    _bindSenderEvents: function () {
      var self = this;

      $(document).off('click.egiftSender', '[data-change-sender]').on('click.egiftSender', '[data-change-sender]', function (e) {
        e.preventDefault();
        var normalizedSender = self._normalizeSender(state.sender);
        if (self._isDefaultSender(normalizedSender)) {
          self._resetSenderModalForm();
        } else {
          self._fillSenderModal(normalizedSender);
        }
        self.openModal('modalEditSender');
      });

      $(document).off('click.egiftSender', '[data-save-sender]').on('click.egiftSender', '[data-save-sender]', function (e) {
        e.preventDefault();
        self._saveSenderInfo();
      });

      $(document).off('input.egiftSender change.egiftSender', '#sender-zipCode').on('input.egiftSender change.egiftSender', '#sender-zipCode', function () {
        var $el = $(this);
        var $errorEl = $el.siblings('.zip-lookup-error');
        var zipcode = String($el.val() || '').replace(/\D/g, '').slice(0, 7);
        if (zipcode !== $el.val()) {
          $el.val(zipcode);
        }
        var lastZip = $el.data('lastLookupZip') || '';
        if (zipcode.length !== 7) {
          if ($errorEl.length) $errorEl.hide();
          if (lastZip) {
            $('#sender-prefecture').val('');
            $('#sender-city').val('');
            $('#sender-address1').val('').removeAttr('data-address1-town');
            $el.data('lastLookupZip', '');
          }
          return;
        }
        if (lastZip === zipcode) {
          if ($errorEl.length) $errorEl.hide();
          return;
        }
        $el.data('lastLookupZip', zipcode);
        if ($errorEl.length) $errorEl.hide();
        self._lookupZipcode(zipcode, $('#sender-prefecture'), $('#sender-city'), $('#sender-address1'), $errorEl, $el);
      });

      $(document).off('input.egiftSender', '#sender-phone').on('input.egiftSender', '#sender-phone', function () {
        var phone = String($(this).val() || '').replace(/\D/g, '').slice(0, 11);
        if (phone !== $(this).val()) {
          $(this).val(phone);
        }
      });
    },

    _lookupZipcode: function (zipcode, $prefecture, $city, $address1, $errorEl, $zipInput) {
      var self = this;

      // Clear any autofilled values — zip edits must invalidate stale prefecture/city/address1.
      if ($prefecture && $prefecture.length) $prefecture.val('');
      if ($city && $city.length) $city.val('');
      if ($address1 && $address1.length) {
        $address1.val('');
        $address1.removeAttr('data-address1-town');
      }
      if ($errorEl && $errorEl.length) $errorEl.hide();

      var cleanZip = (zipcode || '').replace(/\D/g, '');
      if (cleanZip.length !== 7) return null;

      var applyResult = function (result) {
        var prefName = result.address1 || '';
        var city = result.address2 || '';
        var town = result.address3 || '';
        var matched = false;
        $prefecture.find('option').each(function () {
          if ($(this).text() === prefName) {
            $prefecture.val($(this).val());
            matched = true;
            return false;
          }
        });
        if (!matched) $prefecture.val('');
        if (city) $city.val(city);
        if ($address1 && $address1.length && town) {
          $address1.val(town);
          $address1.attr('data-address1-town', town);
          self._updateTownWidth($address1);
        }
      };

      return $.ajax({
        url: '/apps/ping/postal-codes/search',
        dataType: 'jsonp',
        data: { zipcode: cleanZip },
        timeout: 3000,
        success: function (res) {
          if (!res || res.status !== 200 || !res.results || !res.results.length) {
            if ($errorEl && $errorEl.length &&
                !$errorEl.closest('.p-row-item').find('.p-form-error-txt').length) {
              $errorEl.show();
            }
            return;
          }
          if ($errorEl && $errorEl.length) $errorEl.hide();
          if (res.results.length === 1) {
            applyResult(res.results[0]);
          } else {
            self._showZipCandidatePicker(res.results, applyResult);
          }
        },
        error: function () {
          // Timeout or network failure — fail open (do not block conversion).
        }
      });
    },

    /**
     * Mobile-only: expand the town textarea to full width + auto-grow height.
     * Desktop: restore default single-line look.
     */
    _updateTownWidth: function ($townInput) {
      if (!$townInput || !$townInput.length) return;
      var el = $townInput[0];
      if (!el) return;
      var isMobile = window.innerWidth < 768;
      if (!isMobile) {
        $townInput.removeClass('is-full-width');
        if (el.tagName === 'TEXTAREA') el.style.height = '';
        return;
      }
      var val = String($townInput.val() || '');
      $townInput.toggleClass('is-full-width', val.length >= 12);
      if (el.tagName === 'TEXTAREA') {
        el.style.height = 'auto';
        el.style.height = el.scrollHeight + 'px';
      }
    },

    /**
     * Render the zip-candidate picker modal when a postal code maps to
     * multiple towns. Calls onSelect(result) when the user confirms.
     */
    _showZipCandidatePicker: function (results, onSelect) {
      var $modal = $('#modalEgiftZipCandidatePicker');
      if (!$modal.length) {
        onSelect(results[0]);
        return;
      }
      var self = this;
      var $list = $modal.find('[data-egift-zip-candidate-list]');
      var $confirm = $modal.find('[data-egift-zip-candidate-confirm]');

      $list.empty();
      $confirm.prop('disabled', true);

      results.forEach(function (r, i) {
        var label = (r.address2 || '') + (r.address3 || '');
        var $item = $(
          '<label class="p-zip-candidate__item">' +
            '<input type="radio" name="egift-zip-candidate" value="' + i + '">' +
            '<span class="p-zip-candidate__label">' + self._escapeHtml(label) + '</span>' +
          '</label>'
        );
        $list.append($item);
      });

      $list.off('change.egiftZipPicker').on('change.egiftZipPicker', 'input[name="egift-zip-candidate"]', function () {
        $list.find('.p-zip-candidate__item').removeClass('is-selected');
        $(this).closest('.p-zip-candidate__item').addClass('is-selected');
        $confirm.prop('disabled', false);
      });

      $confirm.off('click.egiftZipPicker').on('click.egiftZipPicker', function (e) {
        e.preventDefault();
        var idx = parseInt($list.find('input[name="egift-zip-candidate"]:checked').val(), 10);
        if (isNaN(idx) || !results[idx]) return;
        $modal.removeClass('active');
        onSelect(results[idx]);
      });

      this.openModal('modalEgiftZipCandidatePicker');
    },

    /**
     * Track in-flight zip lookups for the egift orderer modal and toggle the
     * submit button between loading and idle state.
     */
    _ordererZipLookupCount: 0,
    _beginOrdererZipLookup: function () {
      this._ordererZipLookupCount = (this._ordererZipLookupCount || 0) + 1;
      if (this._ordererZipLookupCount === 1) this._setOrdererSubmitLoading(true);
    },
    _endOrdererZipLookup: function () {
      this._ordererZipLookupCount = Math.max(0, (this._ordererZipLookupCount || 0) - 1);
      if (this._ordererZipLookupCount === 0) this._setOrdererSubmitLoading(false);
    },
    _setOrdererSubmitLoading: function (loading) {
      var $modal = $('#modalEgiftAddOrderer');
      var $btn = $modal.find('[data-egift-add-orderer]');
      if (!$btn.length) return;
      if (loading) {
        $modal.addClass('is-zip-loading');
        if (!$btn.data('original-html')) {
          $btn.data('original-html', $btn.html());
        }
        $btn.prop('disabled', true).addClass('is-loading').html(
          '<span class="c-btn-big__loading">' +
            '<span class="c-btn-spinner" aria-hidden="true"></span>' +
            '<span class="c-btn-big__loading-text">読み込み中…</span>' +
          '</span>'
        );
      } else {
        $modal.removeClass('is-zip-loading');
        $btn.prop('disabled', false).removeClass('is-loading');
        var origHtml = $btn.data('original-html');
        if (origHtml) {
          $btn.html(origHtml);
          $btn.removeData('original-html');
        }
      }
    },

    _prefillAddress1Split: function (zip, address1, townId, numId) {
      var cleanZip = (zip || '').replace(/\D/g, '');
      var addr1 = address1 || '';

      function applyFallback() {
        $('#' + townId).val('');
        $('#' + numId).val(addr1);
      }

      if (cleanZip.length !== 7) { applyFallback(); return null; }

      $('#' + townId).val('');
      $('#' + numId).val('');

      return $.ajax({
        url: '/apps/ping/postal-codes/search',
        dataType: 'jsonp',
        data: { zipcode: cleanZip },
        timeout: 3000,
        success: function (res) {
          if (res && res.status === 200 && res.results && res.results.length > 0) {
            var town = res.results[0].address3 || '';
            if (town && addr1.indexOf(town) === 0) {
              $('#' + townId).val(town);
              $('#' + numId).val(addr1.slice(town.length));
            } else {
              $('#' + townId).val(town);
              $('#' + numId).val(addr1);
            }
          } else {
            applyFallback();
          }
        },
        error: function () { applyFallback(); }
      });
    },

    _saveSenderInfo: function () {
      var sender = {
        lastName: $.trim($('#sender-lastName').val()),
        firstName: $.trim($('#sender-firstName').val()),
        zip: String($('#sender-zipCode').val() || '').replace(/\D/g, '').slice(0, 7),
        prefectureCode: $('#sender-prefecture').val() || '',
        prefecture: $('#sender-prefecture option:selected').text() || '',
        city: $.trim($('#sender-city').val()),
        address1: $.trim($('#sender-address1').val()),
        address2: $.trim($('#sender-address2').val()),
        phone: String($('#sender-phone').val() || '').replace(/\D/g, '').slice(0, 11),
        countryCode: 'JP'
      };

      if (!this._validateSenderFields(sender)) {
        return;
      }

      state.sender = this._normalizeSender(sender);
      this._saveData();
      this.closeModal('modalEditSender');
    },

    _validateSenderFields: function (sender) {
      var errors = {};
      var extraErrorFields = [];
      var charError = function(value, scope) {
        if (!value || !window.CharValidator) return null;
        return window.CharValidator.validate(value, scope);
      };

      var lastNameCharError = charError(sender.lastName, 'name');
      if (!sender.lastName) {
        errors.lastName = '姓を入力してください。';
      } else if (lastNameCharError) {
        errors.lastName = lastNameCharError;
      }

      var firstNameCharError = charError(sender.firstName, 'name');
      if (!sender.firstName) {
        errors.firstName = '名を入力してください。';
      } else if (firstNameCharError) {
        errors.firstName = firstNameCharError;
      }

      // --- お名前 combined ≤ 36 全角 ---
      var combinedNameError = null;
      if (sender.lastName && sender.firstName && !errors.lastName && !errors.firstName) {
        var nameCombined = countJaChars(sender.lastName + sender.firstName);
        if (nameCombined > 36) {
          var nameExcess = Math.ceil(nameCombined - 36);
          combinedNameError = 'お名前は「36文字以内」となるようご入力ください。（' + nameExcess + '文字超過しています。）';
          extraErrorFields.push('lastName', 'firstName');
        }
      }

      if (!sender.zip) {
        errors.zip = '郵便番号を入力してください。';
      } else if (!/^\d{7}$/.test(sender.zip)) {
        errors.zip = '郵便番号は半角数字7桁で入力してください。';
      }

      if (!sender.prefectureCode) {
        errors.prefecture = '都道府県を選択してください。';
      }

      var cityCharError = charError(sender.city, 'global');
      if (!sender.city) {
        errors.city = '市区町村を入力してください。';
      } else if (cityCharError) {
        errors.city = cityCharError;
      }

      var address1CharError = charError(sender.address1, 'address');
      if (!sender.address1) {
        errors.address1 = '住所を入力してください。';
      } else if (sender.address1.length > 200) {
        errors.address1 = '住所は200文字以内で入力してください。';
      } else if (address1CharError) {
        errors.address1 = address1CharError;
      }

      var address2CharError = charError(sender.address2, 'address');
      if (sender.address2) {
        if (sender.address2.length > 200) {
          errors.address2 = '建物名は200文字以内で入力してください。';
        } else if (address2CharError) {
          errors.address2 = address2CharError;
        }
      }

      if (!sender.phone) {
        errors.phone = '電話番号を入力してください。';
      } else if (!/^(0[5789]0\d{8}|0[1-9]\d{8}|0120\d{6}|0800\d{7})$/.test(sender.phone)) {
        errors.phone = '正しい電話番号を入力してください。';
      } else if (/0{8}$/.test(sender.phone)) {
        errors.phone = '正しい電話番号を入力してください。';
      }

      // --- 住所 combined ≤ 89 全角 ---
      if (sender.prefectureCode && sender.city && sender.address1 &&
          !errors.prefecture && !errors.city && !errors.address1 && !errors.address2) {
        var combinedAddr = (sender.prefecture || '') + sender.city + sender.address1 + (sender.address2 || '');
        if (countJaChars(combinedAddr) > 89) {
          var addrExcess = Math.ceil(countJaChars(combinedAddr) - 89);
          errors.address2 = '「住所」は「89文字以内」となるようご入力ください。（' + addrExcess + '文字超過しています。）';
          extraErrorFields.push('prefecture', 'city', 'address1');
        }
      }

      this._clearSenderFieldErrors();

      var fieldIdMap = {
        lastName: 'sender-lastName',
        firstName: 'sender-firstName',
        zip: 'sender-zipCode',
        prefecture: 'sender-prefecture',
        city: 'sender-city',
        address1: 'sender-address1',
        address2: 'sender-address2',
        phone: 'sender-phone'
      };

      var hasErrors = Object.keys(errors).length > 0 || combinedNameError !== null;
      if (hasErrors) {
        Object.keys(errors).forEach(function (field) {
          var $field = $('#' + fieldIdMap[field]);
          var $rowItem = $field.closest('.p-row-item');
          if (!$rowItem.length) return;
          $rowItem.addClass('is-error');
          $rowItem.find('.p-form-error-txt').remove();
          $rowItem.append('<p class="p-form-error-txt">' + errors[field] + '</p>');
        });

        // Apply extra error highlights (is-error without message, for combined field groups)
        extraErrorFields.forEach(function (field) {
          if (errors[field]) return; // already handled with message
          var $field = $('#' + fieldIdMap[field]);
          var $rowItem = $field.closest('.p-row-item');
          if (!$rowItem.length) return;
          $rowItem.addClass('is-error');
        });

        // Apply combined name error after the .p-row containing both name fields
        if (combinedNameError) {
          var $nameRow = $('#' + fieldIdMap.lastName).closest('.p-row');
          if ($nameRow.length) {
            $nameRow.after('<p class="p-form-error-txt p-combined-error">' + combinedNameError + '</p>');
          }
        }

        var firstField = Object.keys(errors)[0];
        var $firstInput = firstField
          ? $('#' + fieldIdMap[firstField])
          : $('#' + fieldIdMap.lastName);
        if ($firstInput.length && $firstInput.get(0).scrollIntoView) {
          $firstInput.get(0).scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      return !hasErrors;
    },

    _clearSenderFieldErrors: function () {
      $('#modalEditSender .p-row-item').each(function () {
        $(this).removeClass('is-error');
        $(this).find('.p-form-error-txt').remove();
      });
      // Clear combined name error placed after .p-row
      $('#modalEditSender .p-combined-error').remove();
    },

    _resetSenderModalForm: function () {
      $('#sender-lastName').val('');
      $('#sender-firstName').val('');
      $('#sender-zipCode').val('');
      $('#sender-prefecture').val('');
      $('#sender-city').val('');
      $('#sender-address1').val('');
      $('#sender-address2').val('');
      $('#sender-phone').val('');
      this._clearSenderFieldErrors();
    },

    _isDefaultSender: function (sender) {
      var normalized = this._normalizeSender(sender);
      var defaultSender = this._normalizeSender(this._defaultSender());

      return normalized.lastName === defaultSender.lastName &&
        normalized.firstName === defaultSender.firstName &&
        normalized.zip === defaultSender.zip &&
        normalized.prefectureCode === defaultSender.prefectureCode &&
        normalized.city === defaultSender.city &&
        normalized.address1 === defaultSender.address1 &&
        normalized.address2 === defaultSender.address2 &&
        normalized.phone === defaultSender.phone;
    },

    _resolvePrefectureName: function (prefectureCode) {
      return this._getPrefectureNameByCode(prefectureCode);
    },

    _getOrdererAddress: function (customer) {
      var defaultAddress = customer && customer.defaultAddress;
      if (!defaultAddress || (!defaultAddress.lastName && !defaultAddress.address1)) {
        return null;
      }

      return {
        lastName: $.trim(String(defaultAddress.lastName || '')),
        firstName: $.trim(String(defaultAddress.firstName || '')),
        zip: String(defaultAddress.zip || '').replace(/\D/g, '').slice(0, 7),
        countryCode: defaultAddress.countryCode || 'JP',
        prefectureCode: defaultAddress.province || '',
        prefecture: this._resolvePrefectureName(defaultAddress.province) || '',
        city: $.trim(String(defaultAddress.city || '')),
        address1: $.trim(String(defaultAddress.address1 || '')),
        address2: $.trim(String(defaultAddress.address2 || '')),
        phone: this._normalizeDomesticPhone(defaultAddress.phone || '')
      };
    },

    _getCheckoutSender: function (customer, sender) {
      var normalizedSender = this._normalizeSender(sender);
      var ordererAddress = this._getOrdererAddress(customer);

      if (ordererAddress && this._isDefaultSender(normalizedSender)) {
        return ordererAddress;
      }

      return normalizedSender;
    },

    _getCheckoutOrdererName: function (customer, sender) {
      var ordererAddress = this._getOrdererAddress(customer);
      var source = ordererAddress || this._normalizeSender(sender);
      return $.trim((source.lastName || '') + ' ' + (source.firstName || ''));
    },

    _buildSenderBillingAddress: function (customer, sender) {
      var normalized = this._getCheckoutSender(customer, sender);
      var billingAddress = {
        lastName: normalized.lastName || '',
        firstName: normalized.firstName || '',
        zip: normalized.zip || '',
        countryCode: normalized.countryCode || 'JP',
        provinceCode: normalized.prefectureCode || '',
        city: normalized.city || '',
        address1: normalized.address1 || '',
        address2: normalized.address2 || ''
      };
      if (normalized.phone) {
        billingAddress.phone = normalized.phone;
      }
      return billingAddress;
    },

    // ---------------------------------------------------------------------------
    // eGift form
    // ---------------------------------------------------------------------------

    _renderMessageCardLoading: function () {
      var $list = $('[data-egift-card-list]');
      if (!$list.length) return;
      $list.html('<p class="egift-card-list__empty">メッセージカードを読み込み中です。</p>');
    },

    _bindEgiftFormEvents: function () {
      var self = this;

      $('#egift-destination-name').off('input.egift').on('input.egift', function () {
        var normalizedDestinationName = self._normalizeDestinationName($(this).val());
        if (normalizedDestinationName !== $(this).val()) {
          $(this).val(normalizedDestinationName);
        }
        self._updateDestinationNameCounter();
        self._clearFieldError('destinationName');
        self._updatePreviewButtonState();
        self._updateCheckoutButtonState();
        self._saveEgiftForm();
      });

      $('#egift-message').off('input.egift').on('input.egift', function () {
        var normalized = self._normalizeMessage($(this).val());
        if (normalized !== $(this).val()) {
          $(this).val(normalized);
        }

        self._updateMessageCounter();
        self._clearFieldError('message');
        self._syncEgiftFormState();
        self._updatePreviewButtonState();
        self._updateCheckoutButtonState();
        self._saveEgiftForm();
      });

      $('#egift-nickname').off('input.egift').on('input.egift', function () {
        var normalizedNickname = self._normalizeNickname($(this).val());
        if (normalizedNickname !== $(this).val()) {
          $(this).val(normalizedNickname);
        }
        self._updateNicknameCounter();
        self._clearFieldError('nickname');
        self._updatePreviewButtonState();
        self._updateCheckoutButtonState();
        self._saveEgiftForm();
      });

      this._updateDestinationNameCounter();
      this._updateMessageCounter();
      this._updateNicknameCounter();
      this._syncEgiftFormState();

      // Remove item button (×)
      // Split card: removes only that split line, reduces cart qty by that line's qty.
      //   If only 1 split line remains after removal, reverts to non-split and preserves its settings (B1).
      // Non-split card: removes entire item from cart (original behavior).
      $(document).off('click.egiftRemove', '.js-removeItem').on('click.egiftRemove', '.js-removeItem', function (e) {
        e.preventDefault();
        var $btn = $(this);
        var $wrapper = $btn.closest('[data-item-key]');
        var splitLineKey = $wrapper.attr('data-item-key');
        var sourceItemKey = $wrapper.attr('data-source-item-key');
        var itemKey = sourceItemKey || splitLineKey;
        if (!itemKey) return;

        // Split card: delete only this split line
        var isSplitCard = sourceItemKey && self.isSplitLineKey(String(splitLineKey));
        if (isSplitCard) {
          var parsed = self.parseSplitLineKey(String(splitLineKey));
          if (!parsed) return;
          var cfg = state.singleSplitLines[sourceItemKey];
          if (!cfg || !Array.isArray(cfg.lines)) return;
          var lineToRemove = cfg.lines.find(function (l) { return String(l.id) === String(parsed.lineId); });
          if (!lineToRemove) return;

          var removeQty = Math.max(1, parseInt(lineToRemove.qty, 10) || 1);
          var cartItem = self._getCartItemByKey(sourceItemKey);
          if (!cartItem) return;
          var newQty = (parseInt(cartItem.quantity, 10) || 0) - removeQty;

          // Reject concurrent deletes for the same source item to prevent stale quantity overwrites
          if (!self._splitDeleteLock) self._splitDeleteLock = {};
          if (self._splitDeleteLock[sourceItemKey]) return;
          self._splitDeleteLock[sourceItemKey] = true;

          // Cancel pending debounced qty update and invalidate any in-flight request by bumping
          // the sequence counter — mirrors the pattern used in shipping-app.js.
          if (self._quantityTimers && self._quantityTimers[sourceItemKey]) {
            clearTimeout(self._quantityTimers[sourceItemKey]);
            delete self._quantityTimers[sourceItemKey];
          }
          if (self._qtyIntent) delete self._qtyIntent[sourceItemKey];
          if (!self._quantitySeq) self._quantitySeq = {};
          self._quantitySeq[sourceItemKey] = (self._quantitySeq[sourceItemKey] || 0) + 1;

          // Disable all split cards for this source item while the delete is in flight
          $('[data-source-item-key="' + sourceItemKey + '"]').addClass('is-loading').find('.js-removeItem').prop('disabled', true).addClass('is-disabled');

          var _egiftSplitDeleteAjax = $.ajax({
            url: '/cart/change.js',
            type: 'POST',
            dataType: 'json',
            data: { id: sourceItemKey, quantity: Math.max(0, newQty) }
          });
          if (!self._pendingMutation) self._pendingMutation = {};
          self._pendingMutation[sourceItemKey] = _egiftSplitDeleteAjax;
          _egiftSplitDeleteAjax.always(function() {
            if (self._pendingMutation && self._pendingMutation[sourceItemKey] === _egiftSplitDeleteAjax) {
              delete self._pendingMutation[sourceItemKey];
            }
          });
          _egiftSplitDeleteAjax.done(function (cart) {
            delete self._splitDeleteLock[sourceItemKey];
            state.cart = cart;

            if (newQty <= 0) {
              // Full cleanup and redirect to cart
              self._clearAllEgiftData();
              window.location.replace('/cart');
              return;
            }

            // Re-key detection: automatic discount may change the cart line key on a quantity write.
            // Migrate all state/DOM before mutating the remaining split config.
            var _sdReturnedItem = (cart.items || []).find(function(i) { return i.key === sourceItemKey; });
            if (!_sdReturnedItem) {
              var _sdVid = cartItem.variant_id;
              var _sdProps = cartItem.properties || {};
              var _sdSpId = cartItem.selling_plan_allocation ? cartItem.selling_plan_allocation.selling_plan.id : null;
              var _sdPKeys = Object.keys(_sdProps);
              var _sdReKeyed = (cart.items || []).find(function(i) {
                if (i.key === sourceItemKey || i.variant_id !== _sdVid) return false;
                var ip = i.properties || {};
                if (_sdPKeys.length !== Object.keys(ip).length) return false;
                for (var k = 0; k < _sdPKeys.length; k++) { if (ip[_sdPKeys[k]] !== _sdProps[_sdPKeys[k]]) return false; }
                var isp = i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : null;
                return isp === _sdSpId;
              });
              if (_sdReKeyed) {
                var _sdOldKey = sourceItemKey;
                self._migrateItemKey(_sdOldKey, _sdReKeyed.key);
                sourceItemKey = _sdReKeyed.key;
                splitLineKey = self.makeSplitLineKey(sourceItemKey, parsed.lineId);
                cfg = state.singleSplitLines[sourceItemKey];
                if (self._pendingMutation && self._pendingMutation[_sdOldKey] === _egiftSplitDeleteAjax) {
                  self._pendingMutation[sourceItemKey] = _egiftSplitDeleteAjax;
                  delete self._pendingMutation[_sdOldKey];
                }
              }
            }

            // Remove this split line from config
            var remainingLines = cfg ? cfg.lines.filter(function (l) { return String(l.id) !== String(parsed.lineId); }) : [];

            // Always clean up bag settings for the deleted split-line key
            delete state.bagSettings[splitLineKey];

            if (remainingLines.length <= 1) {
              // B1: revert to non-split, migrate remaining line's settings to item-level
              if (remainingLines.length === 1) {
                var remaining = remainingLines[0];
                var settings = remaining.settings || {};
                if (settings.noshi) state.noshiSettings[sourceItemKey] = settings.noshi;
                else delete state.noshiSettings[sourceItemKey];
                if (settings.ribbon) state.stickerSettings[sourceItemKey] = settings.ribbon;
                else delete state.stickerSettings[sourceItemKey];
                if (settings.wrapOnly) state.wrapOnlyItems[sourceItemKey] = true;
                else delete state.wrapOnlyItems[sourceItemKey];
                if (settings.noWrap) state.noWrapItems[sourceItemKey] = true;
                else delete state.noWrapItems[sourceItemKey];
                // Migrate remaining split-line bag settings to source item key
                var remainingSplitKey = self.makeSplitLineKey(sourceItemKey, remaining.id);
                if (state.bagSettings[remainingSplitKey]) {
                  state.bagSettings[sourceItemKey] = JSON.parse(JSON.stringify(state.bagSettings[remainingSplitKey]));
                }
                delete state.bagSettings[remainingSplitKey];
              }
              delete state.singleSplitLines[sourceItemKey];
            } else {
              cfg.lines = remainingLines;
            }

            self._saveData();
            self._renderGiftOptionsForAllItems();
            self._updateOrderSummary();
            self._calculateEgiftShippingRate();
          })
          _egiftSplitDeleteAjax.fail(function () {
            console.error('Failed to remove egift split line');
            delete self._splitDeleteLock[sourceItemKey];
            $('[data-source-item-key="' + sourceItemKey + '"]').removeClass('is-loading').find('.js-removeItem').prop('disabled', false).removeClass('is-disabled');
          });
          return;
        }

        // Non-split card: remove entire item (original behavior)
        self._updateCartQuantity(itemKey, 0);
      });

      // Quantity +/- buttons for cart items
      $(document).off('click.egiftQty', '.js-qtyBtn').on('click.egiftQty', '.js-qtyBtn', function () {
        var $btn = $(this);
        if ($btn.hasClass('js-bagQtyBtn')) return;
        if ($btn.prop('disabled') || $btn.hasClass('is-disabled')) return;
        var $wrapper = $btn.closest('[data-item-key]');
        var itemKey = $wrapper.attr('data-item-key');
        if (!itemKey) return;
        var $input = $wrapper.find('.qty__input').not('.js-bagQtyInput').first();
        var step = parseInt($btn.attr('data-step'), 10) || 0;
        var currentVal = parseInt($input.val(), 10) || 1;
        var newVal = Math.max(1, currentVal + step);
        var suggestMax = self._getCartSuggestMaxQty(itemKey);
        var inventoryMax = parseInt($wrapper.data('max-qty'), 10);
        var effectiveMax = suggestMax;
        if (isFinite(inventoryMax) && inventoryMax > 0) {
          effectiveMax = (effectiveMax === null) ? inventoryMax : Math.min(effectiveMax, inventoryMax);
        }
        // yokumoku.max-cart-pcs (商品単位カート上限)
        var mcpRemain = self._getMaxCartPcsRemainingForItem(itemKey);
        var mcpHit = false;
        if (mcpRemain !== null) {
          if (effectiveMax === null || mcpRemain < effectiveMax) {
            effectiveMax = mcpRemain;
            mcpHit = true;
          }
        }
        if (effectiveMax !== null && newVal > effectiveMax) {
          newVal = effectiveMax;
          if (mcpHit && newVal === mcpRemain) {
            var _mcpItem1 = (state.cart && state.cart.items || []).find(function(i) { return i.key === itemKey; });
            var _mcpLimit1 = (_mcpItem1 && window.MaxCartPcs && window.MaxCartPcs.getLimit) ? window.MaxCartPcs.getLimit(_mcpItem1.product_id) : null;
            window.alert(_mcpLimit1 != null
              ? 'この商品は' + _mcpLimit1 + '個までご購入いただけます。数量を' + _mcpLimit1 + '個以下に変更してください。'
              : 'この商品はこれ以上カートに入れられません。');
          } else {
            window.alert('こちらの商品は' + effectiveMax + '点までご注文いただけます');
          }
        }
        $input.val(newVal);
        self._updateCartItemUI(itemKey, newVal);
        self._debouncedUpdateCartQuantity(itemKey, newVal);
      });

      // Quantity input change for cart items (excluding bag qty inputs)
      $(document).off('change.egiftQty', '.qty__input').on('change.egiftQty', '.qty__input', function () {
        var $input = $(this);
        if ($input.hasClass('js-bagQtyInput') || $input.is('[data-bag-qty-input]')) return;
        var $wrapper = $input.closest('[data-item-key]');
        var itemKey = $wrapper.attr('data-item-key');
        if (!itemKey) return;
        var rawEgiftVal = String($input.val() || '').trim();
        if (rawEgiftVal === '' || parseInt(rawEgiftVal, 10) <= 0) {
          var cartItemEgift = (state.cart && state.cart.items || []).find(function(i) { return i.key === itemKey; });
          var prevEgiftQty = (cartItemEgift && cartItemEgift.quantity) || parseInt($input.attr('value'), 10) || 1;
          $input.val(prevEgiftQty);
          var $cartItemBottomEgift = $input.closest('.cart-item__bottom');
          $cartItemBottomEgift.next('.js-qty-error').remove();
          var errorMsgEgift = rawEgiftVal === '' ? 'このアイテムは、1の増分でのみ追加できます' : 'このアイテムの最小値は1です';
          $cartItemBottomEgift.after('<p class="p-form-error-txt js-qty-error" role="alert">' + errorMsgEgift + '</p>');
          return;
        }
        $input.closest('.cart-item__bottom').next('.js-qty-error').remove();
        var newVal = Math.max(1, parseInt($input.val(), 10) || 1);
        var suggestMax = self._getCartSuggestMaxQty(itemKey);
        var inventoryMax = parseInt($wrapper.data('max-qty'), 10);
        var effectiveMax = suggestMax;
        if (isFinite(inventoryMax) && inventoryMax > 0) {
          effectiveMax = (effectiveMax === null) ? inventoryMax : Math.min(effectiveMax, inventoryMax);
        }
        // yokumoku.max-cart-pcs (商品単位カート上限)
        var mcpRemain = self._getMaxCartPcsRemainingForItem(itemKey);
        var mcpHit = false;
        if (mcpRemain !== null) {
          if (effectiveMax === null || mcpRemain < effectiveMax) {
            effectiveMax = mcpRemain;
            mcpHit = true;
          }
        }
        if (effectiveMax !== null && newVal > effectiveMax) {
          newVal = effectiveMax;
          if (mcpHit && newVal === mcpRemain) {
            var _mcpItem2 = (state.cart && state.cart.items || []).find(function(i) { return i.key === itemKey; });
            var _mcpLimit2 = (_mcpItem2 && window.MaxCartPcs && window.MaxCartPcs.getLimit) ? window.MaxCartPcs.getLimit(_mcpItem2.product_id) : null;
            window.alert(_mcpLimit2 != null
              ? 'この商品は' + _mcpLimit2 + '個までご購入いただけます。数量を' + _mcpLimit2 + '個以下に変更してください。'
              : 'この商品はこれ以上カートに入れられません。');
          } else {
            window.alert('こちらの商品は' + effectiveMax + '点までご注文いただけます');
          }
        }
        $input.val(newVal);
        self._updateCartItemUI(itemKey, newVal);
        self._debouncedUpdateCartQuantity(itemKey, newVal);
      });

      // Flush pending cart qty updates before navigating away
      $(window).off('pagehide.egiftQty').on('pagehide.egiftQty', function () {
        self._flushPendingQtyUpdates();
      });
    },

    _bindPreviewButton: function () {
      var self = this;
      var $btn = $('[data-egift-preview-btn]');
      if (!$btn.length) return;

      $btn.off('click.egift').on('click.egift', function () {
        if ($(this).prop('disabled') || $(this).hasClass('is-disabled')) return;
        self.openEgiftPreview();
      });
    },

    _applyMessageCardsFromConfig: function (giftConfig) {
      var cards = [];

      if (giftConfig && Array.isArray(giftConfig.displayMessageCards)) {
        cards = giftConfig.displayMessageCards.filter(function (card) {
          return !!(card && card.imagePath);
        });
      }

      state.messageCards = cards;

      var currentCardUrl = $.trim($('#egift-card-url').val());
      var hasCurrentCard = cards.some(function (card) {
        return card.imagePath === currentCardUrl;
      });

      // cards が空（SDK 取得失敗・タイミング問題等）のときは判定材料がないので保存値を消さない。
      // 実際にカードが取得できているのに URL が一致しないときだけクリアする。
      if (currentCardUrl && cards.length > 0 && !hasCurrentCard) {
        console.warn('[egift] cardUrl mismatch — stored URL not found in config cards, clearing selection. hasStoredCardUrl:', !!currentCardUrl, ', availableCards:', cards.length);
        $('#egift-card-url').val('');
        this._saveEgiftForm();
      }

      this._renderMessageCards();
      this._syncEgiftFormState();
    },

    _renderMessageCards: function () {
      var self = this;
      var $list = $('[data-egift-card-list]');
      if (!$list.length) return;

      var selected = $.trim($('#egift-card-url').val());
      var cards = state.messageCards || [];

      if (!cards.length) {
        $list.html('<p class="egift-card-list__empty">メッセージカードを取得できませんでした。ページを再読み込みしてください。</p>');
        this._showFieldError('cardUrl', 'メッセージカードを選択してください');
        this._updatePreviewButtonState();
        this._updateCheckoutButtonState();
        return;
      }

      var html = '<div class="egift-card-list__grid">';
      cards.forEach(function (card, index) {
        var imagePath = card.imagePath;
        var id = card.id || ('card_' + index);
        var checked = selected === imagePath;
        html +=
          '<label class="egift-card-option' + (checked ? ' is-selected' : '') + '">' +
            '<span class="egift-card-option__frame">' +
              '<img src="' + self._escapeAttr(imagePath) + '" alt="メッセージカード">' +
            '</span>' +
            '<input class="egift-card-option__input" type="radio" name="egift_digital_card" value="' + self._escapeAttr(imagePath) + '"' + (checked ? ' checked' : '') + ' data-card-id="' + self._escapeAttr(id) + '">' +
          '</label>';
      });
      html += '</div>';
      $list.html(html);

      $list.off('change.egiftCard').on('change.egiftCard', 'input[name="egift_digital_card"]', function () {
        var $input = $(this);
        var value = $.trim($input.val());
        $('#egift-card-url').val(value);
        $list.find('.egift-card-option').removeClass('is-selected');
        $input.closest('.egift-card-option').addClass('is-selected');
        self._clearFieldError('cardUrl');
        self._syncEgiftFormState();
        self._updatePreviewButtonState();
        self._updateCheckoutButtonState();
        self._saveEgiftForm();
      });

      if (selected) {
        this._clearFieldError('cardUrl');
      }

      this._updatePreviewButtonState();
      this._updateCheckoutButtonState();
    },

    _restoreEgiftForm: function () {
      try {
        var saved = localStorage.getItem('egift_form_data');
        if (!saved) return;
        var data = JSON.parse(saved);
        if (typeof data.destinationName === 'string') {
          var restoredDestinationName = $.trim(data.destinationName);
          if (restoredDestinationName === 'お相手さま') {
            restoredDestinationName = '';
          }
          $('#egift-destination-name').val(this._normalizeDestinationName(restoredDestinationName));
        }
        if (data.nickname) $('#egift-nickname').val(this._normalizeNickname(data.nickname));
        if (data.cardUrl) $('#egift-card-url').val(data.cardUrl);
        if (typeof data.message === 'string') {
          $('#egift-message').val(this._normalizeMessage(data.message));
        }
      } catch (e) {}
      this._updateDestinationNameCounter();
      this._updateMessageCounter();
      this._updateNicknameCounter();
    },

    _getEgiftFormData: function () {
      return {
        destinationName: $.trim(this._normalizeDestinationName($('#egift-destination-name').val())),
        nickname: this._normalizeNickname($.trim($('#egift-nickname').val())),
        cardUrl: $.trim($('#egift-card-url').val()),
        message: this._normalizeMessage($('#egift-message').val()).replace(/\n+$/, '')
      };
    },

    _saveEgiftForm: function () {
      try {
        localStorage.setItem('egift_form_data', JSON.stringify(this._getEgiftFormData()));
      } catch (e) {}
    },

    _updateDestinationNameCounter: function () {
      var destinationName = this._normalizeDestinationName($('#egift-destination-name').val());
      if (destinationName !== $('#egift-destination-name').val()) {
        $('#egift-destination-name').val(destinationName);
      }
      $('#egift-destination-name-count').text(destinationName.length);
      $('#egift-destination-name').attr('maxlength', DESTINATION_NAME_MAX_LENGTH);
    },

    _updateMessageCounter: function () {
      var message = $('#egift-message').val() || '';
      var charCount = this._countMessageChars(message);
      $('#egift-message-count').text(charCount);
      $('#egift-message').removeAttr('maxlength');
    },

    _updateNicknameCounter: function () {
      var nickname = $('#egift-nickname').val() || '';
      $('#egift-nickname-count').text(nickname.length);
      $('#egift-nickname').attr('maxlength', state.nicknameMaxLength);
    },

    _resolveNicknameMaxLength: function (giftConfig) {
      if (!giftConfig || typeof giftConfig !== 'object') {
        return DEFAULT_NICKNAME_MAX_LENGTH;
      }

      var candidates = [
        giftConfig.nicknameMaxLength,
        giftConfig.maxNicknameLength,
        giftConfig.nicknameLimit,
        giftConfig.digitalMessageNicknameMaxLength
      ];

      for (var i = 0; i < candidates.length; i++) {
        var parsed = parseInt(candidates[i], 10);
        if (!isNaN(parsed) && parsed > 0) {
          return parsed;
        }
      }

      return DEFAULT_NICKNAME_MAX_LENGTH;
    },

    _setNicknameMaxLength: function (maxLength) {
      var parsed = parseInt(maxLength, 10);
      state.nicknameMaxLength = (!isNaN(parsed) && parsed > 0) ? parsed : DEFAULT_NICKNAME_MAX_LENGTH;
      var currentValue = $('#egift-nickname').val() || '';
      var normalized = this._normalizeNickname(currentValue);
      if (normalized !== currentValue) {
        $('#egift-nickname').val(normalized);
      }
      this._updateNicknameCounter();
    },

    _normalizeNickname: function (value) {
      var nickname = String(value || '');
      if (nickname.length > state.nicknameMaxLength) {
        nickname = nickname.slice(0, state.nicknameMaxLength);
      }
      return nickname;
    },

    _normalizeDestinationName: function (value) {
      var destinationName = String(value || '').replace(/\r\n?/g, '\n').replace(/\n/g, '');
      if (destinationName.length > DESTINATION_NAME_MAX_LENGTH) {
        destinationName = destinationName.slice(0, DESTINATION_NAME_MAX_LENGTH);
      }
      return destinationName;
    },

   _normalizeMessage: function (value) {
  var message = String(value || '')
    .replace(/\r\n?/g, '\n')
    .replace(/\n[ \t]*\n+/g, '\n');

  // Strip leading newlines
  message = message.replace(/^\n+/, '');

  // Keep only the first newline; collapse subsequent newlines into nothing
  var firstIdx = message.indexOf('\n');
  if (firstIdx !== -1) {
    var before = message.slice(0, firstIdx + 1);
    var after = message.slice(firstIdx + 1).replace(/\n/g, '');
    message = before + after;
  }

  while (this._countMessageChars(message) > 40) {
    message = message.slice(0, -1);
  }

  return message;
},

    _countMessageChars: function (message) {
       return String(message || '').replace(/\n/g, '').length;
    },

    _composeCardMessage: function (form) {
      return form.destinationName
        ? form.destinationName + 'へ\n' + form.message
        : form.message;
    },

    _syncEgiftFormState: function () {
      var hasCard = !!$.trim($('#egift-card-url').val());
      var $form = $('[data-egift-form]');
      if (!$form.length) return;

      if (hasCard) {
        $form.addClass('is-card-selected');
      } else {
        $form.removeClass('is-card-selected');
      }
    },

    _updateOrderSummary: function () {
      var cart = state.cart || {};
      var subtotalCents = 0;
      if (Array.isArray(cart.items) && cart.items.length) {
        cart.items.forEach(function (item) {
          subtotalCents += parseInt(item.line_price, 10) || 0;
        });
      }
      if (subtotalCents <= 0) {
        subtotalCents = parseInt(cart.total_price, 10) || 0;
      }

      var subtotal = Math.max(0, Math.round(subtotalCents / 100));
      var bagTotals = this._calculateBagTotals();
      var bagTotal = bagTotals.totalPrice;
      var hasShippingTotal = typeof state.shippingTotal === 'number' && !isNaN(state.shippingTotal);
      var shippingTotal = hasShippingTotal ? Math.max(0, Math.round(state.shippingTotal)) : 0;
      var total = subtotal + bagTotal + shippingTotal;

      // Subtotal includes bag cost; bag row removed from summary
      $('[data-subtotal]').text(this._formatMoneyYen(subtotal + bagTotal));
      if (state.shippingLoading && !hasShippingTotal) {
        $('[data-shipping-total]').text('計算中...');
      } else {
        $('[data-shipping-total]').text(this._formatMoneyYen(shippingTotal));
      }
      $('[data-total]').text(this._formatMoneyYen(total));
    },

    _calculateEgiftShippingRate: function () {
      var self = this;
      var cart = state.cart || {};
      var items = Array.isArray(cart.items) ? cart.items : [];

      var lineItems = items.map(function (item) {
        return {
          variantId: 'gid://shopify/ProductVariant/' + item.variant_id,
          quantity: parseInt(item.quantity, 10) || 0
        };
      }).filter(function (item) {
        return item.variantId && item.quantity > 0;
      });

      if (!lineItems.length) {
        state.shippingLoading = false;
        state.shippingTotal = 0;
        this._updateOrderSummary();
        return;
      }

      var customerTags = (window.shippingCustomer && Array.isArray(window.shippingCustomer.tags))
        ? window.shippingCustomer.tags
        : [];
      var payload = {
        lineItems: lineItems,
        customer: {
          tags: customerTags
        },
        freeShipping: false
      };
      if (window.shippingCustomer && window.shippingCustomer.id) {
        payload.customer.id = window.shippingCustomer.id;
      }

      state.shippingLoading = true;
      state.shippingTotal = null;
      this._updateOrderSummary();

      $.ajax({
        url: SHIPPING_RATE_API_ENDPOINT,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(payload),
        success: function (data) {
          state.shippingLoading = false;
          state.shippingTotal = self._extractShippingTotal(data);
          state.shippingRateInfo = self._extractShippingRateInfo(data);
          self._updateOrderSummary();
        },
        error: function () {
          state.shippingLoading = false;
          state.shippingTotal = 0;
          state.shippingRateInfo = null;
          self._updateOrderSummary();
        }
      });
    },

    _extractShippingTotal: function (data) {
      var total = 0;

      if (data && Array.isArray(data.availableShippingRate) && data.availableShippingRate.length > 0) {
        data.availableShippingRate.forEach(function (rate) {
          total += parseFloat(rate.amount) || 0;
        });
      } else if (data && Array.isArray(data.shippingRates) && data.shippingRates.length > 0) {
        data.shippingRates.forEach(function (rate) {
          total += parseFloat(rate.price) || 0;
        });
      } else if (data && typeof data.totalShippingCost !== 'undefined') {
        total = parseFloat(data.totalShippingCost) || 0;
      }

      return Math.max(0, Math.round(total));
    },

    _extractShippingRateInfo: function (data) {
      var total = 0;
      var title = '配送料（クール便手数料含む）';

      if (data && Array.isArray(data.availableShippingRate) && data.availableShippingRate.length > 0) {
        data.availableShippingRate.forEach(function (rate) { total += parseFloat(rate.amount) || 0; });
        title = data.availableShippingRate[0].title || title;
      } else if (data && Array.isArray(data.shippingRates) && data.shippingRates.length > 0) {
        data.shippingRates.forEach(function (rate) { total += parseFloat(rate.price) || 0; });
        title = data.shippingRates[0].title || title;
      } else if (data && typeof data.totalShippingCost !== 'undefined') {
        total = parseFloat(data.totalShippingCost) || 0;
      } else {
        return null;
      }

      return { price: String(Math.max(0, Math.round(total))), title: title };
    },

    _getCartItemByKey: function (itemKey) {
      var items = (state.cart && state.cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].key === itemKey) return items[i];
      }
      return null;
    },

    // Migrate all key-indexed state from oldKey to newKey after a Shopify automatic-discount
    // line re-key. Updates localStorage-persisted state, in-memory maps, timer/seq state,
    // window metafield maps, and DOM data-item-key/data-source-item-key attributes.
    _migrateItemKey: function (oldKey, newKey) {
      if (!oldKey || !newKey || oldKey === newKey) return;
      var self = this;
      var splitOldPrefix = oldKey + '::split:';

      // Top-level state maps
      ['noshiSettings', 'stickerSettings', 'wrapOnlyItems', 'noWrapItems', 'deliverySettings'].forEach(function(mapName) {
        if (state[mapName][oldKey] !== undefined) {
          state[mapName][newKey] = state[mapName][oldKey];
          delete state[mapName][oldKey];
        }
      });

      // singleSplitLines
      if (state.singleSplitLines[oldKey] !== undefined) {
        state.singleSplitLines[newKey] = state.singleSplitLines[oldKey];
        delete state.singleSplitLines[oldKey];
      }

      // bagSettings: item key and all derived split-line keys (oldKey::split:*)
      Object.keys(state.bagSettings).forEach(function(bk) {
        if (bk === oldKey) {
          state.bagSettings[newKey] = state.bagSettings[bk];
          delete state.bagSettings[bk];
        } else if (bk.indexOf(splitOldPrefix) === 0) {
          var lineId = bk.slice(splitOldPrefix.length);
          state.bagSettings[newKey + '::split:' + lineId] = state.bagSettings[bk];
          delete state.bagSettings[bk];
        }
      });

      // Timer/seq/intent/mutation state
      ['_quantitySeq', '_quantityTimers', '_qtyIntent', '_pendingMutation'].forEach(function(prop) {
        if (self[prop] && self[prop][oldKey] !== undefined) {
          self[prop][newKey] = self[prop][oldKey];
          delete self[prop][oldKey];
        }
      });

      // Window maps indexed by cart line key (set by Liquid on page load)
      [window.cartItemsMetafields, window.cartItemsApplicableNoshi,
       window.cartItemsApplicableRibbon, window.cartItemsNoshiSize].forEach(function(map) {
        if (map && map[oldKey] !== undefined) {
          map[newKey] = map[oldKey];
          delete map[oldKey];
        }
      });

      // DOM: update key attributes AND jQuery data cache for main wrapper, split cards,
      // and derived bag-settings-key references. Both .attr() and .data() are required
      // because jQuery's .data() cache does not observe later .attr() writes.
      $('[data-item-key="' + oldKey + '"]')
        .attr('data-item-key', newKey).data('item-key', newKey);
      $('[data-source-item-key="' + oldKey + '"]')
        .attr('data-source-item-key', newKey).data('source-item-key', newKey);
      $('[data-item-key^="' + oldKey + '::split:"]').each(function() {
        var $el = $(this);
        var lineId = $el.attr('data-item-key').slice(splitOldPrefix.length);
        var newSk = newKey + '::split:' + lineId;
        $el.attr('data-item-key', newSk).data('item-key', newSk);
      });
      $('[data-bag-settings-key="' + oldKey + '"]')
        .attr('data-bag-settings-key', newKey).data('bag-settings-key', newKey);
      $('[data-bag-settings-key^="' + oldKey + '::split:"]').each(function() {
        var $el = $(this);
        var lineId = $el.attr('data-bag-settings-key').slice(splitOldPrefix.length);
        var newBk = newKey + '::split:' + lineId;
        $el.attr('data-bag-settings-key', newBk).data('bag-settings-key', newBk);
      });
      $('[data-split-line-key^="' + oldKey + '::split:"]').each(function() {
        var $el = $(this);
        var lineId = $el.attr('data-split-line-key').slice(splitOldPrefix.length);
        var newSlk = newKey + '::split:' + lineId;
        $el.attr('data-split-line-key', newSlk).data('split-line-key', newSlk);
      });
      // Action attributes: Noshi/ribbon modal triggers and overlay entry points
      ['data-open-noshi', 'data-open-sticker', 'data-overlay-noshi', 'data-overlay-ribbon'].forEach(function(attr) {
        $('[' + attr + '="' + oldKey + '"]').attr(attr, newKey).data(attr, newKey);
      });

      // Persist migrated state
      this._saveData();
    },

    _getPaidHandbagVariants: function () {
      return PAID_HANDBAG_VARIANTS.slice();
    },

    _getFreeHandbagVariantForItem: function (itemKey) {
      var meta = (window.cartItemsMetafields && window.cartItemsMetafields[itemKey]) || {};
      var fromMetaobject = normalizeFreeHandbagVariant(meta.poly_bag);
      return fromMetaobject;
    },

    _normalizeBagAttachmentRule: function (rawValue) {
      if (rawValue === false || rawValue === 'false') return 'legacy_disabled';
      var value = String(rawValue || '').trim();
      if (value === '必ず付ける' || value === '付けられない' || value === '選択可能') return value;
      return '選択可能';
    },

    _getBagRuleConfig: function (itemKey) {
      var meta = (window.cartItemsMetafields && window.cartItemsMetafields[itemKey]) || {};
      var rule = this._normalizeBagAttachmentRule(meta.bag_attachment_rule);
      var isAlwaysIncluded = rule === '必ず付ける';
      var isSelectionDisabled = rule === '付けられない';
      var isLegacyDisabled = rule === 'legacy_disabled';
      return {
        rule: rule,
        forceOn: isAlwaysIncluded,
        forceFree: isAlwaysIncluded,
        disableOff: isAlwaysIncluded || isSelectionDisabled,
        disableOn: isSelectionDisabled || isLegacyDisabled,
        lockFree: isAlwaysIncluded,
        disableFree: isSelectionDisabled,
        hidePaid: isAlwaysIncluded || isLegacyDisabled,
        disablePaid: isSelectionDisabled,
        clearAllBags: isSelectionDisabled || isLegacyDisabled,
        freeDisplayTitle: isAlwaysIncluded ? '手提げ袋' : '手提げ袋（クリア）',
        noteText: isAlwaysIncluded ? '専用の手提げ袋を商品個数分お付けします。' : ''
      };
    },

    _getBagSelectionState: function (itemKey, settings) {
      // Resolve original item key from splitLineKey for rule config lookup
      var ruleItemKey = itemKey;
      if (this.isSplitLineKey(itemKey)) {
        var parsed = this.parseSplitLineKey(itemKey);
        if (parsed) ruleItemKey = parsed.itemKey;
      }
      var ruleConfig = this._getBagRuleConfig(ruleItemKey);
      if (ruleConfig.forceOn) return 'on';
      if (ruleConfig.clearAllBags || ruleConfig.disableOn) return 'off';
      var s = settings || {};
      if (s.bagSelection === 'on' || s.bagSelection === 'off') return s.bagSelection;
      if (s.freeBagEnabled || s.paidBagEnabled) return 'on';
      return 'off';
    },

    /**
     * Sync bag off-status message and bagSelection based on whether any bag is checked.
     * If any bag checkbox is checked → hide off-status, uncheck "付けない", set bagSelection='on'
     * If all unchecked → show off-status, check "付けない", set bagSelection='off'
     */
    _syncBagOffLabel: function ($wrapper, bagSettingsKey, itemKey) {
      var hasBag = $wrapper.find('[data-bag-type="free"]:checked, [data-bag-type="paid"]:checked').length > 0;
      var $offRadio = $wrapper.find('[data-bag-off-label] input[value="off"]');
      var settings = this._getBagSettings(bagSettingsKey, true);

      if (hasBag) {
        $offRadio.prop('checked', false);
        $wrapper.find('[data-bag-off-status]').hide();
        settings.bagSelection = 'on';
      } else {
        $offRadio.prop('checked', true);
        $wrapper.find('[data-bag-off-status]').show();
        $wrapper.find('[data-bag-status]').html('');
        settings.bagSelection = 'off';
        settings.bags = {};
        settings.freeBagEnabled = false;
        settings.paidBagEnabled = false;
      }
      this._saveData();
    },

    /**
     * 手提げ袋の選択必須バリデーション（通常配送の validateRequiredBagSelections 相当）
     * rule === '選択可能' かつバリアントが存在するアイテムで、bagSelection が null の場合エラー
     * @param {boolean} silent - trueの場合DOM操作しない
     * @returns {{ valid: boolean, $firstInvalid: jQuery|null }}
     */
    _validateRequiredBagSelections: function (silent) {
      var self = this;
      var hasError = false;
      var $firstInvalid = null;
      var cartItems = (state.cart && state.cart.items) || [];

      cartItems.forEach(function (item) {
        var ruleConfig = self._getBagRuleConfig(item.key);
        if (ruleConfig.rule !== '選択可能') return;
        var variants = self._getHandbagVariantsForProduct(item.key);
        if (!variants.length) return;

        // Check for split lines — validate each split line's bag settings individually
        var splitLines = self.getSingleSplitLinesForItem(item);
        if (splitLines.length >= 2) {
          splitLines.forEach(function (line) {
            var bagSettingsKey = line.splitLineKey;
            var settings = self._getBagSettings(bagSettingsKey) || {};
            var bagSelection = self._getBagSelectionState(bagSettingsKey, settings);

            var $wrapper = $('[data-bag-settings-key="' + bagSettingsKey + '"]');
            if (!$wrapper.length) $wrapper = $('[data-item-key="' + bagSettingsKey + '"]');

            if (bagSelection !== 'on' && bagSelection !== 'off') {
              hasError = true;
              if (!silent && $wrapper.length) {
                var $toggle = $wrapper.find('.js-bagToggle').first();
                $toggle.addClass('is-error');
                if (!$toggle.next('.js-bag-selection-error').length) {
                  $toggle.after('<p class="p-form-error-txt js-bag-selection-error">手提げ袋を選択してください。</p>');
                }
              }
              if (!$firstInvalid && $wrapper.length) {
                $firstInvalid = $wrapper.find('.js-bagToggle').first();
              }
            } else if (!silent && $wrapper.length) {
              $wrapper.find('.js-bagToggle').removeClass('is-error');
              $wrapper.find('.js-bag-selection-error').remove();
            }
          });
          return;
        }

        var settings = self._getBagSettings(item.key) || {};
        var bagSelection = self._getBagSelectionState(item.key, settings);

        var $wrapper = $('[data-item-key="' + item.key + '"]');

        if (bagSelection !== 'on' && bagSelection !== 'off') {
          hasError = true;
          if (!silent && $wrapper.length) {
            var $toggle = $wrapper.find('.js-bagToggle').first();
            $toggle.addClass('is-error');
            if (!$toggle.next('.js-bag-selection-error').length) {
              $toggle.after('<p class="p-form-error-txt js-bag-selection-error">手提げ袋を選択してください。</p>');
            }
          }
          if (!$firstInvalid && $wrapper.length) {
            $firstInvalid = $wrapper.find('.js-bagToggle').first();
          }
        } else if (!silent && $wrapper.length) {
          $wrapper.find('.js-bagToggle').removeClass('is-error');
          $wrapper.find('.js-bag-selection-error').remove();
        }
      });

      return { valid: !hasError, $firstInvalid: $firstInvalid ? $firstInvalid : null };
    },

    _applyBagRuleToSettings: function (itemKey, settings, freeBag, paidBags, itemQty) {
      if (!settings) return;
      if (!settings.bags || typeof settings.bags !== 'object') settings.bags = {};

      var ruleConfig = this._getBagRuleConfig(itemKey);
      if (ruleConfig.clearAllBags) {
        settings.bags = {};
        settings.freeBagEnabled = false;
        settings.paidBagEnabled = false;
        return;
      }

      if (ruleConfig.forceFree && freeBag) {
        var freeVariantId = String(freeBag.shopifyProductVariantId);
        settings.freeBagEnabled = true;
        settings.bags[freeVariantId] = Math.max(1, parseInt(itemQty, 10) || 1);
      }

      // For selectable free bags: cap qty at itemQty if it exceeds it.
      // Do NOT auto-increase — user controls qty independently (bag reduction policy).
      if (!ruleConfig.forceFree && freeBag && settings.freeBagEnabled) {
        var selectableVarId = String(freeBag.shopifyProductVariantId);
        var maxItemQty = Math.max(1, parseInt(itemQty, 10) || 1);
        var currentBagQty = parseInt(settings.bags[selectableVarId], 10) || 0;
        if (currentBagQty > maxItemQty) {
          settings.bags[selectableVarId] = maxItemQty;
        }
      }

      if (ruleConfig.hidePaid || ruleConfig.disablePaid) {
        settings.paidBagEnabled = false;
        (paidBags || []).forEach(function (paidBag) {
          delete settings.bags[String(paidBag.shopifyProductVariantId)];
        });
      }
    },

    _getHandbagVariantsForProduct: function (itemKey) {
      var variants = this._getPaidHandbagVariants();
      var freeBag = this._getFreeHandbagVariantForItem(itemKey);
      if (freeBag) variants.unshift(freeBag);
      return variants;
    },

    _getBagSettings: function (itemKey, ensure) {
      if (!itemKey) return null;
      if (ensure && !state.bagSettings[itemKey]) {
        state.bagSettings[itemKey] = { bags: {}, freeBagEnabled: false, paidBagEnabled: false };
      }
      return state.bagSettings[itemKey] || null;
    },

    _sanitizeBagSettings: function (bagSettings) {
      var safe = {};
      if (!bagSettings || typeof bagSettings !== 'object' || Array.isArray(bagSettings)) return safe;

      Object.keys(bagSettings).forEach(function (itemKey) {
        var src = bagSettings[itemKey] || {};
        var bags = {};

        if (src.bags && typeof src.bags === 'object' && !Array.isArray(src.bags)) {
          Object.keys(src.bags).forEach(function (variantId) {
            var qty = parseInt(src.bags[variantId], 10) || 0;
            if (qty > 0) {
              bags[String(variantId)] = qty;
            }
          });
        }

        safe[itemKey] = {
          bags: bags,
          freeBagEnabled: src.freeBagEnabled === true,
          paidBagEnabled: src.paidBagEnabled === true,
          bagSelection: (src.bagSelection === 'on' || src.bagSelection === 'off') ? src.bagSelection : null
        };
      });

      return safe;
    },

    _renderBagSectionHtml: function (itemKey, itemId, meta, splitLineKey) {
      var variants = this._getHandbagVariantsForProduct(itemKey);
      if (!variants.length) return '';

      // Use splitLineKey as bag settings key when split, otherwise itemKey
      var bagSettingsKey = splitLineKey || itemKey;
      var settings = this._getBagSettings(bagSettingsKey, true);
      var freeBag = variants.find(function (b) { return (parseInt(b.price, 10) || 0) === 0; });
      var paidBags = variants.filter(function (b) { return (parseInt(b.price, 10) || 0) > 0; });
      var item = this._getCartItemByKey(itemKey);
      var itemQty = item ? (parseInt(item.quantity, 10) || 1) : 1;
      // Resolve effective qty for split lines
      var effectiveQty = itemQty;
      if (splitLineKey) {
        var splitQty = this.getSingleSplitLineQty(splitLineKey);
        if (splitQty) effectiveQty = splitQty;
      }
      this._applyBagRuleToSettings(itemKey, settings, freeBag, paidBags, effectiveQty);
      var ruleConfig = this._getBagRuleConfig(itemKey);
      var hasFreeBag = !!freeBag;
      var hasPaidBag = !ruleConfig.hidePaid && paidBags.length > 0;
      var offDisabledAttr = ruleConfig.disableOff ? ' disabled' : '';
      var offDisabledClass = ruleConfig.disableOff ? ' is-disable' : '';
      var showBagReductionNote = ruleConfig.rule === '選択可能';
      var bagSelection = this._getBagSelectionState(bagSettingsKey, settings);
      var toggleOffChecked = bagSelection === 'off';

      var freeQty = 1;
      if (hasFreeBag && settings.bags && settings.bags[freeBag.shopifyProductVariantId] > 0) {
        freeQty = settings.bags[freeBag.shopifyProductVariantId];
      }
      var maxQty = effectiveQty;
      if (ruleConfig.lockFree) {
        freeQty = effectiveQty;
      }
      if (freeQty > effectiveQty) freeQty = effectiveQty;
      freeQty = Math.max(0, Math.min(maxQty, freeQty));

      var html = '';
      html += '<div class="addr-content__sect" data-bag-settings-key="' + this._escapeAttr(bagSettingsKey) + '" data-item-key="' + this._escapeAttr(itemKey) + '">';
      html += '<div class="addr-content__item">';
      html += '<h4 class="c-ttl-03">手提げ袋';
      if (showBagReductionNote) {
        html += '<span class="p-bag-box__note u-sm-min">手提げ袋の削減にご協力ください</span>';
      }
      html += '</h4>';
      if (ruleConfig.noteText) {
        html += '<p class="p-bag-box__note">' + this._escapeHtml(ruleConfig.noteText) + '</p>';
      }
      if (!ruleConfig.forceOn) {
        html += '<div class="p-bag-toggle js-bagToggle">';
        html += '<label class="p-bag-toggle__item option-card' + offDisabledClass + '" data-bag-off-label>';
        html += '<input type="radio" name="bagToggle_' + itemId + '" class="option-card__radio" value="off"' + (toggleOffChecked ? ' checked' : '') + offDisabledAttr + '>';
        html += '<span>手提げ袋なし</span>';
        html += '</label>';
        html += '</div>';
      }

      html += '<div class="p-bag-box js-bagBox">';
      html += '<div class="c-card-01">';

      if (hasFreeBag) {
        var freeBagChecked = ruleConfig.forceFree ? true : (settings.freeBagEnabled === true);
        var freeDisabledAttr = (ruleConfig.lockFree || ruleConfig.disableFree) ? ' disabled' : '';
        var freeDisabledClass = ruleConfig.disableFree ? ' is-disable' : '';
        var freePlusBtnDisabledAttr = freeDisabledAttr || (freeQty >= maxQty ? ' disabled' : '');
        var freeMinusBtnDisabledAttr = freeDisabledAttr || (freeQty <= 0 ? ' disabled' : '');
        var freeImage = freeBag.image || state.wrapImage || '';
        var freeCardLockStyle = ruleConfig.forceOn ? ' style="cursor:default;pointer-events:none;"' : '';
        html += '<div class="c-card-01__item">';
        html += '<div class="option-card js-freeBag' + (freeBagChecked ? ' is-active' : '') + freeDisabledClass + '"' + freeCardLockStyle + '>';
        html += '<input type="checkbox" name="bagBox_' + itemId + '" class="option-card__checkbox" data-bag-variant-id="' + this._escapeAttr(freeBag.shopifyProductVariantId) + '" data-bag-type="free"' + (freeBagChecked ? ' checked' : '') + freeDisabledAttr + '>';
        html += '<div class="option-card__inner">';
        html += '<div class="option-card__thumb">' + (freeImage ? '<img src="' + this._escapeAttr(freeImage) + '" alt="">' : '') + '</div>';
        html += '<div class="option-card__text">';
        html += '<p class="option-card__title">' + this._escapeHtml(ruleConfig.freeDisplayTitle) + '<span class="c-badge c-badge--free">無料サービス</span></p>';
        if (!ruleConfig.forceOn) {
          html += '<div class="qty-wrap js-freeBagQty" style="' + (freeBagChecked ? '' : 'display:none;') + '">';
          html += '<div class="qty qty--small">';
          html += '<button type="button" class="qty__btn js-bagQtyBtn" data-step="-1" aria-label="decrease"' + freeMinusBtnDisabledAttr + '>−</button>';
          html += '<input class="qty__input js-bagQtyInput" type="text" value="' + (freeBagChecked ? Math.max(1, freeQty) : 1) + '" inputmode="numeric" aria-label="quantity"' + freeDisabledAttr + '>';
          html += '<button type="button" class="qty__btn js-bagQtyBtn" data-step="1" aria-label="increase"' + freePlusBtnDisabledAttr + '>＋</button>';
          html += '</div>';
          html += '</div>';
        }
        html += '</div>';
        html += '</div>';
        html += '</div>';
        html += '</div>';
      }

      if (hasPaidBag) {
        var paidChecked = settings.paidBagEnabled === true;
        var paidImage = state.paidBagImage || '';
        var variantId = item ? item.variant_id : '';
        var paidDisabledAttr = ruleConfig.disablePaid ? ' disabled' : '';
        var paidDisabledClass = ruleConfig.disablePaid ? ' is-disable' : '';
        var paidOpenAttr = ruleConfig.disablePaid ? '' : ' data-open-bag-modal';
        var paidAriaAttr = ruleConfig.disablePaid ? ' tabindex="-1" aria-disabled="true"' : '';
        html += '<div class="c-card-01__item" style="position: relative;">';
        html += '<label class="option-card js-bagPaid' + (paidChecked ? ' is-active' : '') + paidDisabledClass + '">';
        html += '<input type="checkbox" name="bagBox_' + itemId + '" class="option-card__checkbox" data-bag-type="paid"' + (paidChecked ? ' checked' : '') + paidDisabledAttr + '>';
        html += '<a href="#" class="option-card__inner"' + paidOpenAttr + paidAriaAttr + ' data-item-key="' + this._escapeAttr(itemKey) + '" data-variant-id="' + this._escapeAttr(String(variantId || '')) + '" data-bag-settings-key="' + this._escapeAttr(bagSettingsKey) + '">';
        html += '<div class="option-card__thumb">' + (paidImage ? '<img src="' + this._escapeAttr(paidImage) + '" alt="">' : '') + '</div>';
        html += '<div class="option-card__text"><p class="option-card__title">手提げ袋（紙） </p></div>';
        html += '</a>';
        html += '</label>';
        if (!paidChecked && !ruleConfig.disablePaid) {
          html += '<div data-overlay-paid-bag data-item-key="' + this._escapeAttr(itemKey) + '" data-variant-id="' + this._escapeAttr(String(variantId || '')) + '" data-bag-settings-key="' + this._escapeAttr(bagSettingsKey) + '" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 5; cursor: pointer;"></div>';
        }
        html += '</div>';
      }

      html += '</div>';
      html += '<div data-bag-status class="bag-status">' + this._renderBagStatusSummary(bagSettingsKey) + '</div>';
      html += '<div data-bag-off-status class="bag-off-status" style="' + (toggleOffChecked ? '' : 'display:none;') + '">';
      html += '<div class="p-alert p-alert--small p-alert--center">';
      html += '<div class="p-alert__icon"><img src="' + this._escapeAttr(window.shippingAssets ? window.shippingAssets.iconPackagingInfo : '') + '" alt=""></div>';
      html += '<div class="p-alert__info"><h4>手提げ袋は付属しておりません。</h4></div>';
      html += '</div></div>';
      html += '</div>';
      if (showBagReductionNote) {
        html += '<span class="p-bag-box__note u-sm-max">手提げ袋の削減にご協力ください</span>';
      }
      html += '</div>'; // addr-content__item
      html += '</div>'; // addr-content__sect

      return html;
    },

    _extractBagSizeLabel: function (title) {
      var raw = String(title || '');
      var match = raw.match(/[-−]\s*(.+)$/);
      return match ? match[1].trim() : raw;
    },

    _normalizeBagSizeLabel: function (value) {
      return String(value || '').replace(/\s+/g, '').replace(/　/g, '');
    },

    _getRecommendedBagSizeForItem: function (itemKey) {
      var meta = (window.cartItemsMetafields && window.cartItemsMetafields[itemKey]) || {};
      var raw = meta.recommended_bag_size;
      if (Array.isArray(raw)) {
        raw = raw.length ? raw[0] : '';
      }
      return this._normalizeBagSizeLabel(raw);
    },

    _renderBagStatusSummary: function (bagSettingsKey) {
      var settings = this._getBagSettings(bagSettingsKey, false);
      if (!settings || !settings.bags || !Object.keys(settings.bags).length) return '';

      // Resolve original item key from splitLineKey if needed
      var origItemKey = bagSettingsKey;
      if (this.isSplitLineKey(bagSettingsKey)) {
        var parsed = this.parseSplitLineKey(bagSettingsKey);
        if (parsed) origItemKey = parsed.itemKey;
      }

      var variants = this._getHandbagVariantsForProduct(origItemKey);
      var paidTotal = 0;
      var paidCount = 0;
      var freeCount = 0;
      var paidLines = [];
      var self = this;
      var item = this._getCartItemByKey(origItemKey);
      var variantId = item ? item.variant_id : '';
      var ruleConfig = this._getBagRuleConfig(origItemKey);

      Object.keys(settings.bags).forEach(function (bagId) {
        var qty = parseInt(settings.bags[bagId], 10) || 0;
        if (qty <= 0) return;
        var info = variants.find(function (b) { return String(b.shopifyProductVariantId) === String(bagId); });
        if (!info) return;

        var price = parseInt(info.price, 10) || 0;
        if (price === 0 && settings.freeBagEnabled === true) {
          freeCount += qty;
        } else if (price > 0 && settings.paidBagEnabled === true) {
          var lineTotal = price * qty;
          paidTotal += lineTotal;
          paidCount += qty;
          paidLines.push({ label: self._extractBagSizeLabel(info.title) + ' × ' + qty, price: self._formatMoneyYen(lineTotal) });
        }
      });

      var totalCount = freeCount + paidCount;
      if (totalCount <= 0) return '';

      var html = '';

      if (paidCount > 0) {
        html += '<div class="p-fee u-mb-15 u-mt-15">';
        html += '<div class="p-fee__head">';
        html += '<h4 class="p-fee__title">選択中の手提げ袋（紙）</h4>';
        html += '<a href="#" class="p-fee__edit" data-open-bag-modal data-item-key="' + this._escapeAttr(origItemKey) + '" data-variant-id="' + this._escapeAttr(String(variantId || '')) + '" data-bag-settings-key="' + this._escapeAttr(bagSettingsKey) + '">変更</a>';
        html += '</div>';
        html += '<ul class="p-fee__list">';
        paidLines.forEach(function (line) {
          html += '<li class="p-fee__row"><span class="p-fee__label">' + self._escapeHtml(line.label) + '</span><span class="p-fee__price">' + line.price + '</span></li>';
        });
        html += '</ul>';
        html += '<div class="p-fee__divider"></div>';
        html += '<div class="p-fee__foot">';
        html += '<span class="p-fee__subtotal-label">手提げ袋 小計</span>';
        html += '<span class="p-fee__subtotal">' + this._formatMoneyYen(paidTotal) + '</span>';
        html += '</div>';
        html += '</div>';
      }

      // 必ず付ける ルール時は通知ボックスを表示しない
      if (!ruleConfig.forceOn) {
        html += '<div class="p-alert p-alert--small">';
        html += '<div class="p-alert__icon"><img src="' + this._escapeAttr(window.shippingAssets ? window.shippingAssets.iconPackagingInfo : '') + '" alt=""></div>';
        html += '<div class="p-alert__info"><h4>手提げ袋の組み合わせ</h4>';
        var parts = [];
        if (freeCount > 0) parts.push(ruleConfig.freeDisplayTitle);
        if (paidCount > 0) parts.push('手提げ袋（紙）');
        html += '<p>' + this._escapeHtml(parts.join(' + ')) + '（<strong>計' + totalCount + '点</strong>）をお付けします。</p>';
        html += '</div></div>';
      }

      return html;
    },

    _calculateBagTotals: function () {
      var self = this;
      var totalPrice = 0;
      var totalCount = 0;
      Object.keys(state.bagSettings || {}).forEach(function (itemKey) {
        // Resolve original item key from splitLineKey if needed
        var origItemKey = itemKey;
        if (self.isSplitLineKey(itemKey)) {
          var parsed = self.parseSplitLineKey(itemKey);
          if (parsed) origItemKey = parsed.itemKey;
        }
        var variants = self._getHandbagVariantsForProduct(origItemKey);
        var settings = state.bagSettings[itemKey];
        if (!settings || !settings.bags || settings.paidBagEnabled !== true) return;

        Object.keys(settings.bags).forEach(function (bagId) {
          var qty = parseInt(settings.bags[bagId], 10) || 0;
          if (qty <= 0) return;
          var info = variants.find(function (b) { return String(b.shopifyProductVariantId) === String(bagId); });
          if (!info) return;
          var price = parseInt(info.price, 10) || 0;
          if (price > 0) {
            totalPrice += price * qty;
            totalCount += qty;
          }
        });
      });

      return { totalPrice: totalPrice, totalCount: totalCount };
    },

    _openBagModal: function (bagSettingsKey, variantId) {
      // Resolve original item key from splitLineKey if needed
      var origItemKey = bagSettingsKey;
      if (this.isSplitLineKey(bagSettingsKey)) {
        var parsed = this.parseSplitLineKey(bagSettingsKey);
        if (parsed) origItemKey = parsed.itemKey;
      }
      var ruleConfig = this._getBagRuleConfig(origItemKey);
      if (ruleConfig.hidePaid || ruleConfig.disablePaid) {
        return;
      }
      state.currentBagItemKey = bagSettingsKey;
      state.currentBagVariantId = variantId;

      var paidBags = this._getPaidHandbagVariants();
      this._renderBagOptionsInModal(paidBags, bagSettingsKey);
      this.openModal('modalShoppingBag');
    },

    _renderBagOptionsInModal: function (bags, bagSettingsKey) {
      var self = this;
      var $container = $('[data-bag-options]');
      // Resolve original item key for recommendation lookup
      var origItemKey = bagSettingsKey;
      if (this.isSplitLineKey(bagSettingsKey)) {
        var parsed = this.parseSplitLineKey(bagSettingsKey);
        if (parsed) origItemKey = parsed.itemKey;
      }
      var recommendedBagSize = this._getRecommendedBagSizeForItem(origItemKey);
      if (!$container.length) return;

      if (!bags.length) {
        $container.html('<p class="no-bags-message">この商品には手提げ袋（紙）オプションがありません。</p>');
        $('[data-bag-subtotal]').text('0円');
        return;
      }

      var settings = this._getBagSettings(bagSettingsKey, true);
      var currentBags = settings.bags || {};
      bags.sort(function (a, b) { return (a.priority || 0) - (b.priority || 0); });

      var html = '';
      bags.forEach(function (bag) {
        var bagId = String(bag.shopifyProductVariantId);
        var currentQty = parseInt(currentBags[bagId], 10) || 0;
        var price = parseInt(bag.price, 10) || 0;
        var sizeLabel = self._extractBagSizeLabel(bag.title);
        var isRecommended = (recommendedBagSize && self._normalizeBagSizeLabel(sizeLabel) === recommendedBagSize) || bag.isRecommended === true;
        html += '<div class="optionRow" data-bag-id="' + self._escapeAttr(bagId) + '" data-bag-price="' + price + '">';
        html += '<div class="colLabel">' + self._escapeHtml(sizeLabel) + '</div>';
        html += '<div class="colPrice">';
        if (bag.image) {
          html += '<span class="priceDots"><img src="' + self._escapeAttr(bag.image) + '" alt=""></span>';
        }
        html += '<strong>' + self._formatMoneyYen(price) + '</strong>';
        if (isRecommended) {
          html += '<span class="c-badge c-badge--blue02">推奨</span>';
        }
        html += '</div>';
        html += '<div class="colQty"><span class="qtyText">数量</span><div class="qty qty--small">';
        html += '<button type="button" class="qty__btn" data-bag-qty-btn data-step="-1" aria-label="decrease">−</button>';
        html += '<input class="qty__input" type="text" data-bag-qty-input value="' + self._escapeAttr(String(currentQty)) + '" inputmode="numeric" aria-label="quantity" max="' + PAID_BAG_MAX_QTY + '">';
        html += '<button type="button" class="qty__btn" data-bag-qty-btn data-step="1" aria-label="increase">＋</button>';
        html += '</div></div></div>';
      });

      $container.html(html);
      this._updateBagModalSubtotal();
    },

    _updateBagModalSubtotal: function () {
      var total = 0;
      $('[data-bag-options] .optionRow').each(function () {
        var $row = $(this);
        var price = parseInt($row.attr('data-bag-price'), 10) || 0;
        var qty = parseInt($row.find('[data-bag-qty-input]').val(), 10) || 0;
        total += (price * Math.max(0, qty));
      });
      $('[data-bag-subtotal]').text(this._formatMoneyYen(total));
    },

    _saveBagSelection: function () {
      var bagSettingsKey = state.currentBagItemKey;
      if (!bagSettingsKey) {
        this.closeModal('modalShoppingBag');
        return;
      }
      // Resolve original item key from splitLineKey if needed
      var origItemKey = bagSettingsKey;
      if (this.isSplitLineKey(bagSettingsKey)) {
        var parsed = this.parseSplitLineKey(bagSettingsKey);
        if (parsed) origItemKey = parsed.itemKey;
      }
      var ruleConfig = this._getBagRuleConfig(origItemKey);
      if (ruleConfig.hidePaid || ruleConfig.disablePaid) {
        this.closeModal('modalShoppingBag');
        return;
      }

      var settings = this._getBagSettings(bagSettingsKey, true);
      var paidBags = {};
      $('[data-bag-options] .optionRow').each(function () {
        var $row = $(this);
        var bagId = String($row.attr('data-bag-id') || '');
        var qty = parseInt($row.find('[data-bag-qty-input]').val(), 10) || 0;
        if (bagId && qty > 0) {
          paidBags[bagId] = qty;
        }
      });

      var variants = this._getHandbagVariantsForProduct(origItemKey);
      var merged = {};
      Object.keys(settings.bags || {}).forEach(function (bagId) {
        var info = variants.find(function (b) { return String(b.shopifyProductVariantId) === String(bagId); });
        if (info && (parseInt(info.price, 10) || 0) === 0 && settings.bags[bagId] > 0) {
          merged[bagId] = settings.bags[bagId];
        }
      });
      Object.keys(paidBags).forEach(function (bagId) {
        merged[bagId] = paidBags[bagId];
      });

      settings.bags = merged;
      settings.paidBagEnabled = Object.keys(paidBags).length > 0;

      // Find the correct wrapper — for split lines, use data-bag-settings-key
      var $itemWrapper = $('[data-bag-settings-key="' + bagSettingsKey + '"]');
      if (!$itemWrapper.length) $itemWrapper = $('[data-item-key="' + bagSettingsKey + '"]');
      var hasAnyBag = settings.freeBagEnabled || settings.paidBagEnabled;
      $itemWrapper.find('[data-bag-off-label] input[value="off"]').prop('checked', !hasAnyBag);
      $itemWrapper.find('[data-bag-off-status]').toggle(!hasAnyBag);
      if (hasAnyBag) {
        settings.bagSelection = 'on';
      }

      var $paidCb = $itemWrapper.find('[data-bag-type="paid"]');
      $paidCb.prop('checked', settings.paidBagEnabled);
      $itemWrapper.find('label.js-bagPaid').toggleClass('is-active', settings.paidBagEnabled);
      if (settings.paidBagEnabled) {
        $itemWrapper.find('[data-overlay-paid-bag]').remove();
      } else {
        var item = this._getCartItemByKey(origItemKey);
        if ($itemWrapper.find('[data-overlay-paid-bag]').length === 0) {
          $paidCb.closest('.c-card-01__item').append(
            '<div data-overlay-paid-bag data-item-key="' + this._escapeAttr(origItemKey) + '" data-variant-id="' + this._escapeAttr(String(item ? item.variant_id : '')) + '" data-bag-settings-key="' + this._escapeAttr(bagSettingsKey) + '" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 5; cursor: pointer;"></div>'
          );
        }
      }

      $itemWrapper.find('[data-bag-status]').html(this._renderBagStatusSummary(bagSettingsKey));
      this._saveData();
      this._updateOrderSummary();
      this.closeModal('modalShoppingBag');
    },

    _buildHandbagItems: function (bagSettingsKey) {
      // Resolve original item key from splitLineKey if needed
      var origItemKey = bagSettingsKey;
      if (this.isSplitLineKey(bagSettingsKey)) {
        var parsed = this.parseSplitLineKey(bagSettingsKey);
        if (parsed) origItemKey = parsed.itemKey;
      }

      var settings = this._getBagSettings(bagSettingsKey, false);
      if (!settings || !settings.bags || !Object.keys(settings.bags).length) return [];

      var variants = this._getHandbagVariantsForProduct(origItemKey);
      var items = [];

      Object.keys(settings.bags).forEach(function (bagId) {
        var qty = parseInt(settings.bags[bagId], 10) || 0;
        if (qty <= 0) return;

        var info = variants.find(function (b) { return String(b.shopifyProductVariantId) === String(bagId); });
        if (!info) return;

        var price = parseInt(info.price, 10) || 0;
        if (price === 0 && settings.freeBagEnabled !== true) return;
        if (price > 0 && settings.paidBagEnabled !== true) return;

        items.push({
          parsedVariantId: 'gid://shopify/ProductVariant/' + String(bagId),
          quantity: qty,
          giftOptions: [],
          properties: {}
        });
      });

      return items;
    },

    // ---------------------------------------------------------------------------
    // Gift wrapping options (per item)
    // ---------------------------------------------------------------------------

    _renderGiftOptionsForAllItems: function () {
      var self = this;
      $('[data-gift-options-placeholder]').each(function () {
        var $placeholder = $(this);
        var itemKey = $placeholder.closest('[data-item-key]').attr('data-item-key');
        if (!itemKey) return;
        self._renderWrappingOptions(itemKey, $placeholder);
      });
    },

    /**
     * Resolve current item/split/bag-settings keys from the nearest migrated DOM
     * wrapper at call time, so re-key migration is always reflected in handlers.
     */
    _resolveCardKeys: function ($el) {
      var $sourceWrapper = $el.closest('[data-source-item-key]');
      var $itemWrapper   = $el.closest('[data-item-key]');
      var $slkWrapper    = $el.closest('[data-split-line-key]');
      var $bskWrapper    = $el.closest('[data-bag-settings-key]');
      var itemKey       = $sourceWrapper.attr('data-source-item-key') || $itemWrapper.attr('data-item-key') || '';
      var splitLineKey  = $slkWrapper.length ? ($slkWrapper.attr('data-split-line-key') || null) : null;
      var bagSettingsKey = $bskWrapper.attr('data-bag-settings-key') || splitLineKey || itemKey;
      return { itemKey: itemKey, splitLineKey: splitLineKey, bagSettingsKey: bagSettingsKey };
    },

    _renderWrappingOptions: function (itemKey, $container) {
      var self     = this;

      // Check for split lines — if split, render per-split-card UI
      var item = this._getCartItemByKey(itemKey);
      var splitLines = item ? this.getSingleSplitLinesForItem(item) : [];
      if (splitLines.length >= 2) {
        this._renderSplitWrappingOptions(itemKey, $container, splitLines);
        return;
      }

      // Restore original product card if previously hidden by split
      var $origSect = $container.siblings('.addr-content__sect').first();
      // Capture sync item reference before rendering gift options (used after $container.html below).
      var _syncItemForRestore = this._getCartItemByKey(itemKey);
      if (!_syncItemForRestore) {
        // Exact key lookup failed — Automatic Discount may have re-keyed the line.
        // All keyed state/DOM references use the old key and cannot be safely migrated;
        // reload to get a fresh Liquid render with correct keys.
        window.location.reload();
        return;
      }
      $origSect.show();

      var meta     = (window.cartItemsMetafields || {})[itemKey] || {};
      var isWrapDisabled = this._isFlagDisabled(meta.flags_wrapping);
      // Noshi/ribbon availability is independent of flags_wrapping (mirrors renderWrappingOptions)
      var hasNoshi =
        !this._isFlagDisabled(meta.flags_noshi) &&
        this._hasApplicableOption(window.cartItemsApplicableNoshi, itemKey, window.noshiData);
      var hasRibbon =
        !this._isFlagDisabled(meta.flags_ribbon) &&
        this._hasApplicableOption(window.cartItemsApplicableRibbon, itemKey, window.ribbonData);
      var canWrapOnly = !isWrapDisabled;
      var canNoWrap = isWrapDisabled;

      if (!hasNoshi && !hasRibbon && !canWrapOnly && !canNoWrap) {
        $container.empty();
        return;
      }

      var currentNoshi   = state.noshiSettings[itemKey];
      var currentSticker = state.stickerSettings[itemKey];
      var isWrapOnly     = state.wrapOnlyItems[itemKey];
      var isNoWrap       = state.noWrapItems[itemKey];
      var itemId         = this._sanitizeItemId(itemKey);
      var optionName     = 'packageOption_' + itemId;
      var bagToggleName  = 'bagToggle_' + itemId;
      var selectedOption = canNoWrap ? 'none' : 'wrap';

      // Only auto-set noWrap when no gift option (noshi/ribbon) is already saved.
      // If ribbon is saved, guard must not overwrite noWrapItems — buildGiftProperties
      // checks noWrapItems first with an early return before it reaches stickerSettings.
      if (!isWrapOnly && !isNoWrap && isWrapDisabled && !currentNoshi && !currentSticker) {
        isNoWrap = true;
        state.noWrapItems[itemKey] = true;
      }

      if (currentNoshi) selectedOption = 'noshi';
      else if (currentSticker) selectedOption = 'ribbon';
      else if (isNoWrap) selectedOption = 'none';
      else if (isWrapOnly) selectedOption = 'wrap';

      if (isWrapDisabled && selectedOption === 'wrap') {
        selectedOption = 'none';
      }

      var noshiDisabled = hasNoshi ? '' : ' disabled';
      var noshiDisabledClass = hasNoshi ? '' : ' is-disable';
      var ribbonDisabled = hasRibbon ? '' : ' disabled';
      var ribbonDisabledClass = hasRibbon ? '' : ' is-disable';

      var html = '<div class="addr-content__item">';
      html += this._renderBagSectionHtml(itemKey, itemId, meta);
      html += '<h4 class="c-ttl-03">包装・のし・リボン</h4>';
      html += '<div class="c-card-01 js-packageList" data-item-key="' + itemKey + '">';

      if (canWrapOnly) {
        html += '<div class="c-card-01__item">';
        html += '<label class="option-card js-packageItem js-packageWrap' + (selectedOption === 'wrap' ? ' is-active' : '') + '">';
        html += '<input type="radio" name="' + optionName + '" value="wrap" class="option-card__radio"' + (selectedOption === 'wrap' ? ' checked' : '') + '>';
        html += '<div class="option-card__inner js-packageClick">';
        // Product-level override (metafield yokumoku.wrap_thumbnail), e.g. seasonal wrapping paper
        var wrapImage = meta.wrap_thumbnail || state.wrapImage;
        if (wrapImage) {
          html += '<div class="option-card__thumb"><img src="' + this._escapeAttr(wrapImage) + '" alt=""></div>';
        } else {
          html += '<div class="option-card__thumb"></div>';
        }
        html += '<div class="option-card__text">';
        html += '<p class="option-card__title">包装のみ<span class="c-badge c-badge--free">無料サービス</span></p>';
        html += '</div>';
        html += '</div>';
        html += '</label>';
        html += '</div>';
      }

      html += '<div class="c-card-01__item" style="position: relative;">';
      html += '<label class="option-card js-packageItem js-packageNoshi' + noshiDisabledClass + (selectedOption === 'noshi' ? ' is-active' : '') + '">';
      html += '<input type="radio" name="' + optionName + '" value="noshi" class="option-card__radio"' + (selectedOption === 'noshi' ? ' checked' : '') + noshiDisabled + '>';
      html += '<a href="#" class="option-card__inner js-packageClick">';
      if (state.noshiImage) {
        html += '<div class="option-card__thumb"><img src="' + this._escapeAttr(state.noshiImage) + '" alt=""></div>';
      } else {
        html += '<div class="option-card__thumb"></div>';
      }
      html += '<div class="option-card__text">';
      html += '<p class="option-card__title">のし<span class="c-badge c-badge--free">無料サービス</span></p>';
      html += '</div>';
      html += '</a>';
      html += '</label>';
      if (hasNoshi) {
        html += '<div data-overlay-noshi="' + itemKey + '" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 5; cursor: pointer;"></div>';
      }
      html += '</div>';

      html += '<div class="c-card-01__item" style="position: relative;">';
      html += '<label class="option-card js-packageItem js-packageRibbon' + ribbonDisabledClass + (selectedOption === 'ribbon' ? ' is-active' : '') + '">';
      html += '<input type="radio" name="' + optionName + '" value="ribbon" class="option-card__radio"' + (selectedOption === 'ribbon' ? ' checked' : '') + ribbonDisabled + '>';
      html += '<a href="#" class="option-card__inner js-packageClick">';
      if (state.ribbonImage) {
        html += '<div class="option-card__thumb"><img src="' + this._escapeAttr(state.ribbonImage) + '" alt=""></div>';
      } else {
        html += '<div class="option-card__thumb"></div>';
      }
      html += '<div class="option-card__text">';
      html += '<p class="option-card__title"><span class="option-card__title--txt">リボンシール・<br class="u-md-max">季節ラッピング</span><span class="c-badge c-badge--free">無料サービス</span></p>';
      html += '</div>';
      html += '</a>';
      html += '</label>';
      if (hasRibbon) {
        html += '<div data-overlay-ribbon="' + itemKey + '" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 5; cursor: pointer;"></div>';
      }
      html += '</div>';

      if (canNoWrap) {
        html += '<div class="c-card-01__item">';
        html += '<label class="option-card js-packageItem js-packageNone' + (selectedOption === 'none' ? ' is-active' : '') + '">';
        html += '<input type="radio" name="' + optionName + '" value="none" class="option-card__radio"' + (selectedOption === 'none' ? ' checked' : '') + '>';
        html += '<div class="option-card__inner js-packageClick">';
        html += '<div class="option-card__text">';
        html += '<p class="option-card__title">包装なし</p>';
        html += '</div>';
        html += '</div>';
        html += '</label>';
        html += '</div>';
      }

      html += '</div>';
      html += this._renderNoshiStatusSummary(itemKey);
      html += this._renderStickerStatusSummary(itemKey);
      html += '</div>';

      $container.html(html);

      // Sync qty, prices, and button states on restored original card after split deletion.
      // Use cart response data directly — do not rely on stale Liquid HTML attributes.
      var _syncQty = parseInt(_syncItemForRestore.quantity, 10) || 1;
      // Qty input — update both property and HTML attribute to keep them in sync
      var $syncQtyInput = $origSect.find('.qty__input').not('.js-bagQtyInput');
      if ($syncQtyInput.length) $syncQtyInput.val(_syncQty).attr('value', _syncQty);
      // − button
      var $syncMinusBtn = $origSect.find('.qty__btn.js-qtyBtn[data-step="-1"]');
      $syncMinusBtn.prop('disabled', _syncQty <= 1).toggleClass('is-disabled', _syncQty <= 1);
      // + button — use same effective-max logic as the qty click handler
      var $syncPlusBtn = $origSect.find('.qty__btn.js-qtyBtn[data-step="1"]');
      var $syncWrapper = $origSect.closest('[data-item-key]');
      var _suggestMax = this._getCartSuggestMaxQty(itemKey);
      var _inventoryMax = parseInt($syncWrapper.attr('data-max-qty'), 10) || 0;
      var _pcsRemaining = this._getMaxCartPcsRemainingForItem ? this._getMaxCartPcsRemainingForItem(itemKey) : null;
      var _effectiveMax = _suggestMax;
      if (_inventoryMax > 0) _effectiveMax = (_effectiveMax === null) ? _inventoryMax : Math.min(_effectiveMax, _inventoryMax);
      if (_pcsRemaining !== null) _effectiveMax = (_effectiveMax === null) ? _pcsRemaining : Math.min(_effectiveMax, _pcsRemaining);
      var _plusDisabled = _effectiveMax !== null && _syncQty >= _effectiveMax;
      $syncPlusBtn.prop('disabled', _plusDisabled).toggleClass('is-disabled', _plusDisabled);
      // Update data-unit / data-discounted-unit from cart response so _updateCartItemUI uses correct prices
      var _origUnit = (_syncItemForRestore.original_price != null ? _syncItemForRestore.original_price : _syncItemForRestore.price) / 100;
      var _finalUnit = (_syncItemForRestore.final_price != null ? _syncItemForRestore.final_price : _syncItemForRestore.price) / 100;
      var $syncUnitEls = $origSect.find('.cart-item__unit');
      $syncUnitEls.attr('data-unit', _origUnit);
      if (_finalUnit < _origUnit) {
        $syncUnitEls.attr('data-discounted-unit', _finalUnit);
      } else {
        $syncUnitEls.removeAttr('data-discounted-unit');
      }
      // Re-render unit price text and total via shared helper
      this._updateCartItemUI(itemKey, _syncQty);

      // Bag toggle (付けない) - clear bags when "付けない" is selected
      $container.find('input[name="' + bagToggleName + '"]').off('change.egiftBagToggle').on('change.egiftBagToggle', function () {
        var currentItemKey = self._resolveCardKeys($(this)).itemKey || itemKey;
        var selected = $(this).val();
        var $wrapper = $(this).closest('.addr-content__item');
        // Clear bag validation error on selection
        $wrapper.find('.js-bagToggle').removeClass('is-error');
        $wrapper.find('.js-bag-selection-error').remove();
        var settings = self._getBagSettings(currentItemKey, true);
        var variants = self._getHandbagVariantsForProduct(currentItemKey);
        var freeBag = variants.find(function (b) { return (parseInt(b.price, 10) || 0) === 0; });
        var paidBags = variants.filter(function (b) { return (parseInt(b.price, 10) || 0) > 0; });
        var ruleConfig = self._getBagRuleConfig(currentItemKey);
        var item = self._getCartItemByKey(currentItemKey);
        var itemQty = item ? (parseInt(item.quantity, 10) || 1) : 1;
        self._applyBagRuleToSettings(currentItemKey, settings, freeBag, paidBags, itemQty);

        if (selected === 'off') {
          settings.bagSelection = 'off';
          settings.bags = {};
          settings.freeBagEnabled = false;
          settings.paidBagEnabled = false;
          $wrapper.find('[data-bag-type="free"], [data-bag-type="paid"]').prop('checked', false).closest('.option-card').removeClass('is-active');
          $wrapper.find('.js-freeBagQty').hide();
          $wrapper.find('.js-bagQtyInput').val(1);
          $wrapper.find('[data-bag-status]').html('');
          $wrapper.find('[data-bag-off-status]').show();
          // Restore paid bag overlay
          $wrapper.find('.js-bagPaid').each(function() {
            var $label = $(this);
            if (!$label.next('[data-overlay-paid-bag]').length) {
              var ik = $wrapper.closest('[data-item-key]').attr('data-item-key') || currentItemKey;
              var vid = $label.find('[data-open-bag-modal]').data('variant-id') || '';
              var bsk = $wrapper.closest('[data-bag-settings-key]').attr('data-bag-settings-key') || currentItemKey;
              $label.after('<div data-overlay-paid-bag data-item-key="' + ik + '" data-variant-id="' + vid + '" data-bag-settings-key="' + bsk + '" style="position:absolute;top:0;left:0;right:0;bottom:0;z-index:5;cursor:pointer;"></div>');
            }
          });
          self._saveData();
          self._updateOrderSummary();
          self._updateCheckoutButtonState();
        }
      });

      // Free bag card click — toggle checkbox (label replaced with div)
      $container.find('.js-freeBag').off('click.egiftFreeBagCard').on('click.egiftFreeBagCard', function(e) {
        if ($(e.target).closest('.qty-wrap').length) return;
        if ($(e.target).is('.option-card__checkbox')) return;
        var $card = $(this);
        var $cb = $card.find('.option-card__checkbox');
        if ($cb.prop('disabled') || $card.hasClass('is-disable')) return;
        $cb.prop('checked', !$cb.is(':checked')).trigger('change.egiftBagFree');
      });

      $container.find('[data-bag-type="free"]').off('change.egiftBagFree').on('change.egiftBagFree', function () {
        var currentItemKey = self._resolveCardKeys($(this)).itemKey || itemKey;
        var $cb = $(this);
        var settings = self._getBagSettings(currentItemKey, true);
        var variantId = String($cb.attr('data-bag-variant-id') || '');
        var $row = $cb.closest('.c-card-01__item');
        var $qtyInput = $row.find('.js-bagQtyInput');
        var $qtyWrap = $row.find('.js-freeBagQty');
        var ruleConfig = self._getBagRuleConfig(currentItemKey);
        var qty = parseInt($qtyInput.val(), 10) || 1;
        var item = self._getCartItemByKey(currentItemKey);
        var maxQty = item ? (parseInt(item.quantity, 10) || 1) : 1;
        qty = Math.max(1, Math.min(maxQty, qty));
        if (ruleConfig.lockFree) {
          qty = maxQty;
          $cb.prop('checked', true);
        }
        $qtyInput.val(qty);

        settings.freeBagEnabled = ruleConfig.lockFree ? true : $cb.is(':checked');
        if (settings.freeBagEnabled) {
          settings.bags[variantId] = qty;
          $qtyWrap.show();
        } else {
          if (variantId) delete settings.bags[variantId];
          $qtyWrap.hide();
        }

        $cb.closest('.option-card').toggleClass('is-active', settings.freeBagEnabled);
        var $wrapper = $cb.closest('.addr-content__item');
        $container.find('[data-bag-status]').html(self._renderBagStatusSummary(currentItemKey));
        self._syncBagOffLabel($wrapper, currentItemKey, currentItemKey);
        self._updateOrderSummary();
        self._updateCheckoutButtonState();
      });

      $container.find('.js-bagQtyBtn').off('click.egiftBagQty').on('click.egiftBagQty', function (e) {
        e.preventDefault();
        var currentItemKey = self._resolveCardKeys($(this)).itemKey || itemKey;
        var $btn = $(this);
        if ($btn.prop('disabled')) return;
        var $input = $btn.siblings('.js-bagQtyInput');
        var step = parseInt($btn.attr('data-step'), 10) || 0;
        var current = parseInt($input.val(), 10) || 0;
        var ruleConfig = self._getBagRuleConfig(currentItemKey);
        if (ruleConfig.lockFree) return;
        var item = self._getCartItemByKey(currentItemKey);
        var maxQty = item ? (parseInt(item.quantity, 10) || 1) : 1;
        var next = Math.max(0, Math.min(maxQty, current + step));
        $input.val(next);
        $btn.closest('.qty').find('[data-step="1"]').prop('disabled', next >= maxQty);

        var $freeCb = $btn.closest('.c-card-01__item').find('[data-bag-type="free"]');
        var variantId = String($freeCb.attr('data-bag-variant-id') || '');
        var $addrWrapper = $btn.closest('.addr-content__item');
        if (next === 0 && $freeCb.length && $freeCb.is(':checked')) {
          $freeCb.prop('checked', false).closest('.option-card').removeClass('is-active');
          $btn.closest('.js-freeBagQty').hide();
          var settings = self._getBagSettings(currentItemKey, true);
          settings.freeBagEnabled = false;
          if (variantId) delete settings.bags[variantId];
          $container.find('[data-bag-status]').html(self._renderBagStatusSummary(currentItemKey));
          self._syncBagOffLabel($addrWrapper, currentItemKey, currentItemKey);
          self._updateOrderSummary();
        } else if (next > 0 && $freeCb.length && !$freeCb.is(':checked')) {
          $freeCb.prop('checked', true).closest('.option-card').addClass('is-active');
          $btn.closest('.js-freeBagQty').show();
          var settings = self._getBagSettings(currentItemKey, true);
          settings.freeBagEnabled = true;
          if (variantId) settings.bags[variantId] = next;
          $container.find('[data-bag-status]').html(self._renderBagStatusSummary(currentItemKey));
          self._syncBagOffLabel($addrWrapper, currentItemKey, currentItemKey);
          self._updateOrderSummary();
        } else if ($freeCb.length && $freeCb.is(':checked')) {
          var settings = self._getBagSettings(currentItemKey, true);
          if (variantId) {
            settings.bags[variantId] = next;
            $container.find('[data-bag-status]').html(self._renderBagStatusSummary(currentItemKey));
            self._saveData();
            self._updateOrderSummary();
          }
        }
      });

      $container.find('.js-bagQtyInput').off('change.egiftBagQty').on('change.egiftBagQty', function () {
        var currentItemKey = self._resolveCardKeys($(this)).itemKey || itemKey;
        var $input = $(this);
        if ($input.prop('disabled')) return;
        var entered = parseInt($input.val(), 10) || 0;
        var ruleConfig = self._getBagRuleConfig(currentItemKey);
        if (ruleConfig.lockFree) return;
        var item = self._getCartItemByKey(currentItemKey);
        var maxQty = item ? (parseInt(item.quantity, 10) || 1) : 1;
        var normalized = Math.max(0, Math.min(maxQty, entered));
        $input.val(normalized);
        $input.closest('.qty').find('[data-step="1"]').prop('disabled', normalized >= maxQty);

        var $freeCb = $input.closest('.c-card-01__item').find('[data-bag-type="free"]');
        var variantId = String($freeCb.attr('data-bag-variant-id') || '');
        var $addrWrapper = $input.closest('.addr-content__item');
        if (normalized === 0 && $freeCb.length && $freeCb.is(':checked')) {
          $freeCb.prop('checked', false).closest('.option-card').removeClass('is-active');
          $input.closest('.js-freeBagQty').hide();
          var settings = self._getBagSettings(currentItemKey, true);
          settings.freeBagEnabled = false;
          if (variantId) delete settings.bags[variantId];
          $container.find('[data-bag-status]').html(self._renderBagStatusSummary(currentItemKey));
          self._syncBagOffLabel($addrWrapper, currentItemKey, currentItemKey);
          self._updateOrderSummary();
        } else if (normalized > 0 && $freeCb.length && !$freeCb.is(':checked')) {
          $freeCb.prop('checked', true).closest('.option-card').addClass('is-active');
          $input.closest('.js-freeBagQty').show();
          var settings = self._getBagSettings(currentItemKey, true);
          settings.freeBagEnabled = true;
          if (variantId) settings.bags[variantId] = normalized;
          $container.find('[data-bag-status]').html(self._renderBagStatusSummary(currentItemKey));
          self._syncBagOffLabel($addrWrapper, currentItemKey, currentItemKey);
          self._updateOrderSummary();
        } else if ($freeCb.length && $freeCb.is(':checked')) {
          var settings = self._getBagSettings(currentItemKey, true);
          if (variantId) {
            settings.bags[variantId] = normalized;
            $container.find('[data-bag-status]').html(self._renderBagStatusSummary(currentItemKey));
            self._saveData();
            self._updateOrderSummary();
          }
        }
      });

      $container.find('[data-bag-type="paid"]').off('change.egiftBagPaid').on('change.egiftBagPaid', function () {
        var currentItemKey = self._resolveCardKeys($(this)).itemKey || itemKey;
        var $cb = $(this);
        var ruleConfig = self._getBagRuleConfig(currentItemKey);
        if (ruleConfig.hidePaid || ruleConfig.disablePaid) {
          $cb.prop('checked', false);
          return;
        }
        var settings = self._getBagSettings(currentItemKey, true);
        var variants = self._getHandbagVariantsForProduct(currentItemKey);
        var isChecked = $cb.is(':checked');
        settings.paidBagEnabled = isChecked;

        if (!isChecked) {
          Object.keys(settings.bags || {}).forEach(function (bagId) {
            var info = variants.find(function (b) { return String(b.shopifyProductVariantId) === String(bagId); });
            if (info && (parseInt(info.price, 10) || 0) > 0) {
              delete settings.bags[bagId];
            }
          });
          var item = self._getCartItemByKey(currentItemKey);
          if ($container.find('[data-overlay-paid-bag]').length === 0) {
            $cb.closest('.c-card-01__item').append(
              '<div data-overlay-paid-bag data-item-key="' + self._escapeAttr(currentItemKey) + '" data-variant-id="' + self._escapeAttr(String(item ? item.variant_id : '')) + '" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 5; cursor: pointer;"></div>'
            );
          }
        } else {
          $container.find('[data-overlay-paid-bag]').remove();
        }

        $cb.closest('.js-bagPaid').toggleClass('is-active', isChecked);
        var $addrWrapper = $cb.closest('.addr-content__item');
        $container.find('[data-bag-status]').html(self._renderBagStatusSummary(currentItemKey));
        self._syncBagOffLabel($addrWrapper, currentItemKey, currentItemKey);
        self._updateOrderSummary();
      });

      $container.off('click.egiftBagOpen', '[data-open-bag-modal], [data-overlay-paid-bag]').on('click.egiftBagOpen', '[data-open-bag-modal], [data-overlay-paid-bag]', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var bagSettingsKey = $(this).attr('data-bag-settings-key') || itemKey;
        var resolvedItemKey = itemKey;
        if (self.isSplitLineKey(bagSettingsKey)) {
          var parsed = self.parseSplitLineKey(bagSettingsKey);
          if (parsed) resolvedItemKey = parsed.itemKey;
        }
        var item = self._getCartItemByKey(resolvedItemKey);
        self._openBagModal(bagSettingsKey, item ? item.variant_id : '');
      });

      $container.find('input[name="' + optionName + '"]').off('change.egiftWrap').on('change.egiftWrap', function () {
        var currentItemKey = self._resolveCardKeys($(this)).itemKey || itemKey;
        var selected = $(this).val();

        if (selected === 'wrap') {
          state.wrapOnlyItems[currentItemKey] = true;
          delete state.noWrapItems[currentItemKey];
          delete state.noshiSettings[currentItemKey];
          delete state.stickerSettings[currentItemKey];
        } else if (selected === 'none') {
          state.noWrapItems[currentItemKey] = true;
          delete state.wrapOnlyItems[currentItemKey];
          delete state.noshiSettings[currentItemKey];
          delete state.stickerSettings[currentItemKey];
        } else if (selected === 'noshi' && state.noshiSettings[currentItemKey]) {
          delete state.wrapOnlyItems[currentItemKey];
          delete state.noWrapItems[currentItemKey];
          delete state.stickerSettings[currentItemKey];
        } else if (selected === 'ribbon' && state.stickerSettings[currentItemKey]) {
          delete state.wrapOnlyItems[currentItemKey];
          delete state.noWrapItems[currentItemKey];
          delete state.noshiSettings[currentItemKey];
        }

        self._saveData();
        self._renderWrappingOptions(currentItemKey, $container);
      });

      $container.find('[data-overlay-noshi]').off('click.egiftWrap').on('click.egiftWrap', function (e) {
        e.preventDefault();
        var currentItemKey = $(this).attr('data-overlay-noshi') || itemKey;
        self.openNoshiModal(currentItemKey);
      });

      $container.find('[data-overlay-ribbon]').off('click.egiftWrap').on('click.egiftWrap', function (e) {
        e.preventDefault();
        var currentItemKey = $(this).attr('data-overlay-ribbon') || itemKey;
        self.openStickerModal(currentItemKey);
      });
    },

    // ---------------------------------------------------------------------------
    // Split line infrastructure (noshi/ribbon partial split)
    // ---------------------------------------------------------------------------

    isSplitLineKey: function (itemKey) {
      return typeof itemKey === 'string' && itemKey.indexOf('::split:') !== -1;
    },

    makeSplitLineKey: function (itemKey, lineId) {
      return itemKey + '::split:' + lineId;
    },

    parseSplitLineKey: function (splitLineKey) {
      if (!this.isSplitLineKey(splitLineKey)) return null;
      var parts = String(splitLineKey).split('::split:');
      if (parts.length !== 2 || !parts[0] || !parts[1]) return null;
      return { itemKey: parts[0], lineId: parts[1] };
    },

    getSingleSplitLinesByItemKey: function (itemKey) {
      var cfg = state.singleSplitLines[itemKey];
      if (!cfg || !Array.isArray(cfg.lines)) return [];
      return cfg.lines;
    },

    getSingleSplitLineByKey: function (splitLineKey) {
      var parsed = this.parseSplitLineKey(splitLineKey);
      if (!parsed) return null;
      var lines = this.getSingleSplitLinesByItemKey(parsed.itemKey);
      for (var i = 0; i < lines.length; i++) {
        if (String(lines[i].id) === parsed.lineId) return lines[i];
      }
      return null;
    },

    getSingleSplitLineSettings: function (splitLineKey) {
      var line = this.getSingleSplitLineByKey(splitLineKey);
      if (!line) return null;
      if (!line.settings) line.settings = { noshi: null, ribbon: null, wrapOnly: false, noWrap: false };
      return line.settings;
    },

    setSingleSplitLineSettings: function (splitLineKey, nextSettings) {
      var line = this.getSingleSplitLineByKey(splitLineKey);
      if (!line) return;
      line.settings = nextSettings || { noshi: null, ribbon: null, wrapOnly: false, noWrap: false };
    },

    getSingleSplitLineQty: function (splitLineKey) {
      var line = this.getSingleSplitLineByKey(splitLineKey);
      return line ? (parseInt(line.qty, 10) || 0) : 0;
    },

    updateSingleSplitLineQty: function (splitLineKey, nextQty) {
      var parsed = this.parseSplitLineKey(splitLineKey);
      if (!parsed) return false;
      var item = this._getCartItemByKey(parsed.itemKey);
      if (!item) return false;
      var totalQty = Math.max(1, parseInt(item.quantity, 10) || 1);
      var lines = this.getSingleSplitLinesByItemKey(parsed.itemKey);
      if (lines.length < 2) return false;

      var targetIndex = -1;
      for (var i = 0; i < lines.length; i++) {
        if (String(lines[i].id) === parsed.lineId) { targetIndex = i; break; }
      }
      if (targetIndex === -1) return false;

      var targetQty = Math.max(1, Math.min(parseInt(nextQty, 10) || 1, totalQty - (lines.length - 1)));
      var oldQty = lines[targetIndex].qty;
      lines[targetIndex].qty = targetQty;
      // Absorb diff into last line (or next line if target is last)
      var adjustIndex = targetIndex === lines.length - 1 ? 0 : lines.length - 1;
      lines[adjustIndex].qty = Math.max(1, lines[adjustIndex].qty + (oldQty - targetQty));

      // Clamp noshi/ribbon counts
      lines.forEach(function (line) {
        if (line.settings && line.settings.noshi) {
          line.settings.noshi.count = Math.max(1, Math.min(parseInt(line.settings.noshi.count, 10) || line.qty, line.qty));
        }
        if (line.settings && line.settings.ribbon) {
          line.settings.ribbon.count = Math.max(1, Math.min(parseInt(line.settings.ribbon.count, 10) || line.qty, line.qty));
        }
      });

      this._saveData();
      this._renderGiftOptionsForAllItems();
      return true;
    },

    /**
     * Copy bag settings from the parent item to each split line.
     * Called when split lines are first created so each split card inherits the parent's bag state.
     */
    copyBagSettingsToSplitLines: function (itemKey) {
      var parentBag = state.bagSettings[itemKey];
      if (!parentBag) return;
      var cfg = state.singleSplitLines[itemKey];
      if (!cfg || !Array.isArray(cfg.lines)) return;
      var self = this;
      cfg.lines.forEach(function (line) {
        var splitKey = self.makeSplitLineKey(itemKey, line.id);
        if (!state.bagSettings[splitKey]) {
          state.bagSettings[splitKey] = JSON.parse(JSON.stringify(parentBag));
        }
      });
    },

    clearSingleSplitItemLegacySettings: function (itemKey) {
      delete state.noshiSettings[itemKey];
      delete state.stickerSettings[itemKey];
      delete state.wrapOnlyItems[itemKey];
      delete state.noWrapItems[itemKey];
    },

    createSingleSplitLinesFromNoshi: function (itemKey, totalQty, noshiData, noshiQty) {
      var qty = parseInt(totalQty, 10) || 1;
      var nQty = Math.max(1, Math.min(parseInt(noshiQty, 10) || qty, qty - 1));
      var plainQty = qty - nQty;
      if (plainQty <= 0) return;

      var noshiCopy = JSON.parse(JSON.stringify(noshiData || {}));
      noshiCopy.count = nQty;

      state.singleSplitLines[itemKey] = {
        lines: [
          { id: 'a', qty: nQty, settings: { noshi: noshiCopy, ribbon: null, wrapOnly: false, noWrap: false } },
          { id: 'b', qty: plainQty, settings: { noshi: null, ribbon: null, wrapOnly: false, noWrap: false } }
        ]
      };
      this.copyBagSettingsToSplitLines(itemKey);
      this.clearSingleSplitItemLegacySettings(itemKey);
    },

    createSingleSplitLinesFromSticker: function (itemKey, totalQty, ribbonData, ribbonQty) {
      var qty = parseInt(totalQty, 10) || 1;
      var rQty = Math.max(1, Math.min(parseInt(ribbonQty, 10) || qty, qty - 1));
      var plainQty = qty - rQty;
      if (plainQty <= 0) return;

      var ribbonCopy = JSON.parse(JSON.stringify(ribbonData || {}));
      ribbonCopy.count = rQty;

      state.singleSplitLines[itemKey] = {
        lines: [
          { id: 'a', qty: rQty, settings: { noshi: null, ribbon: ribbonCopy, wrapOnly: false, noWrap: false } },
          { id: 'b', qty: plainQty, settings: { noshi: null, ribbon: null, wrapOnly: false, noWrap: false } }
        ]
      };
      this.copyBagSettingsToSplitLines(itemKey);
      this.clearSingleSplitItemLegacySettings(itemKey);
    },

    /**
     * Split an existing split line into two: one with gift settings, one without.
     */
    splitExistingSplitLine: function (splitLineKey, noshiData, ribbonData, giftQty) {
      var parsed = this.parseSplitLineKey(splitLineKey);
      if (!parsed) return;
      var itemKey = parsed.itemKey;
      var cfg = state.singleSplitLines[itemKey];
      if (!cfg || !Array.isArray(cfg.lines)) return;

      var targetIndex = -1;
      for (var i = 0; i < cfg.lines.length; i++) {
        if (String(cfg.lines[i].id) === parsed.lineId) {
          targetIndex = i;
          break;
        }
      }
      if (targetIndex === -1) return;

      var targetLine = cfg.lines[targetIndex];
      var targetQty = parseInt(targetLine.qty, 10) || 1;
      var gQty = Math.max(1, Math.min(parseInt(giftQty, 10) || 1, targetQty - 1));
      var remainQty = targetQty - gQty;
      if (remainQty <= 0) return;

      // Generate a unique line id
      var existingIds = {};
      cfg.lines.forEach(function (l) { existingIds[String(l.id)] = true; });
      var newId = parsed.lineId;
      var suffix = 1;
      while (existingIds[newId + '_' + suffix]) suffix++;
      newId = newId + '_' + suffix;

      // Build the new gift line
      var giftNoshi = noshiData ? JSON.parse(JSON.stringify(noshiData)) : null;
      if (giftNoshi) giftNoshi.count = gQty;
      var giftRibbon = ribbonData ? JSON.parse(JSON.stringify(ribbonData)) : null;
      if (giftRibbon) giftRibbon.count = gQty;

      var newLine = {
        id: newId,
        qty: gQty,
        settings: { noshi: giftNoshi, ribbon: giftRibbon, wrapOnly: false, noWrap: false }
      };

      // Shrink the original line
      targetLine.qty = remainQty;

      // Insert the new line before the target line
      cfg.lines.splice(targetIndex, 0, newLine);

      // Copy bag settings from the original split line to the new split line
      var origBagKey = this.makeSplitLineKey(itemKey, parsed.lineId);
      var newBagKey = this.makeSplitLineKey(itemKey, newId);
      var origBagSettings = state.bagSettings[origBagKey];
      if (origBagSettings) {
        state.bagSettings[newBagKey] = JSON.parse(JSON.stringify(origBagSettings));
      }
    },

    normalizeSingleSplitLines: function (itemKey, totalQty) {
      var cfg = state.singleSplitLines[itemKey];
      var qty = Math.max(1, parseInt(totalQty, 10) || 1);
      if (!cfg || !Array.isArray(cfg.lines) || cfg.lines.length < 2) {
        delete state.singleSplitLines[itemKey];
        return [];
      }

      cfg.lines = cfg.lines.filter(function (line) {
        return line && (parseInt(line.qty, 10) || 0) > 0;
      });
      if (cfg.lines.length < 2) {
        delete state.singleSplitLines[itemKey];
        return [];
      }

      var sum = 0;
      cfg.lines.forEach(function (line) {
        line.qty = Math.max(1, parseInt(line.qty, 10) || 1);
        if (!line.settings) line.settings = { noshi: null, ribbon: null, wrapOnly: false, noWrap: false };
        if (line.settings.noshi && line.settings.noshi.count) {
          line.settings.noshi.count = Math.max(1, Math.min(parseInt(line.settings.noshi.count, 10) || line.qty, line.qty));
        }
        if (line.settings.ribbon && line.settings.ribbon.count) {
          line.settings.ribbon.count = Math.max(1, Math.min(parseInt(line.settings.ribbon.count, 10) || line.qty, line.qty));
        }
        sum += line.qty;
      });

      if (sum !== qty) {
        var lastLine = cfg.lines[cfg.lines.length - 1];
        lastLine.qty = Math.max(1, lastLine.qty + (qty - sum));
      }
      sum = 0;
      cfg.lines.forEach(function (line) { sum += line.qty; });
      if (sum !== qty || cfg.lines.length < 2) {
        delete state.singleSplitLines[itemKey];
        return [];
      }

      var self = this;
      return cfg.lines.map(function (line) {
        return {
          id: String(line.id || ''),
          qty: line.qty,
          settings: line.settings,
          splitLineKey: self.makeSplitLineKey(itemKey, line.id)
        };
      });
    },

    getSingleSplitLinesForItem: function (item) {
      var itemKey = item.key || item;
      var itemObj = typeof item === 'object' ? item : this._getCartItemByKey(itemKey);
      var totalQty = itemObj ? (parseInt(itemObj.quantity, 10) || 1) : 1;
      return this.normalizeSingleSplitLines(itemKey, totalQty);
    },

    // ---------------------------------------------------------------------------
    // Noshi modal
    // ---------------------------------------------------------------------------

    getNoshiDataForItem: function (itemKey) {
      return this._resolveApplicableEntries(window.cartItemsApplicableNoshi, itemKey, window.noshiData);
    },

    openNoshiModal: function (itemKey, splitLineKey) {
      this.currentNoshiItemKey = itemKey;
      this.currentNoshiSplitLineKey = splitLineKey || null;
      this.selectedNoshiEntry = null;
      this.currentNoshiMode = 'normal';

      var data = this.getNoshiDataForItem(itemKey);
      var savedNoshi = null;
      if (splitLineKey) {
        var splitSettings = this.getSingleSplitLineSettings(splitLineKey);
        savedNoshi = splitSettings ? splitSettings.noshi : null;
      } else {
        savedNoshi = state.noshiSettings[itemKey] || null;
      }

      var item = this._getCartItemByKey(itemKey);
      var totalQty = item ? (parseInt(item.quantity, 10) || 1) : 1;
      var effectiveQty = splitLineKey ? (this.getSingleSplitLineQty(splitLineKey) || totalQty) : totalQty;
      var savedCount = (savedNoshi && savedNoshi.count) ? Math.min(savedNoshi.count, effectiveQty) : effectiveQty;
      $('[data-noshi-count-input]').val(savedCount);
      $('[data-noshi-count-input]').prop('disabled', false);
      $('[data-noshi-count-total]').text(effectiveQty);
      this.syncGiftSettingCountControl($('[data-noshi-count-input]'), effectiveQty);

      $('#noshi-current-item-key').val(itemKey);
      $('#noshi-paper-size').val((window.cartItemsNoshiSize && window.cartItemsNoshiSize[itemKey]) || 'A4');
      $('#noshi-metaobject-gid').val('');
      $('#noshi-current-mode').val('normal');

      this.resetNoshiModal();
      this.populateNoshiPurposeSelect(data);

      if (savedNoshi) {
        this.restoreNoshiSettings(itemKey, data, savedNoshi);
      }

      this.openModal('modalGift');
    },

    resetNoshiModal: function () {
      if (window.NoshiDialogCommon) window.NoshiDialogCommon.clearValidationErrors();
      $('[data-gift-options]').empty().removeClass('c-card-02 c-card-03');
      $('[data-noshi-cards-block]').hide();
      $('[data-noshi-purpose-select]').val('');
      $('.js-preview-img').attr('src', '');

      $('[data-noshi-input-fields]').hide();
      $('[data-noshi-normal-fields]').show();
      $('[data-noshi-uchiiwai-fields]').hide();
      $('[data-noshi-name-note]').show();

      $('#noshi-line1, #noshi-line2, #noshi-uchiiwai-name, #noshi-uchiiwai-furigana, #corpCompany, #corpTitle, #corpName').val('');
      $('#modalGift .js-corpToggle').prop('checked', false);
      $('#modalGift .js-corpFields').hide();

      $('[data-noshi-preview-section]').hide();
      $('.js-giftPreview').hide();
      $('.js-preview-img').attr('src', '');

      $('[data-noshi-preview-btn]').hide();
      $('[data-noshi-preview-note]').hide();

      $('#modalGift [data-save-noshi]').prop('disabled', true);
    },

    NOSHI_CATEGORY_ORDER: {
      '慶事': 0,
      '弔事': 1
    },

    getNoshiNumericId: function (gid) {
      if (!gid) return -1;
      var parts = String(gid).split('/');
      var raw = parts.length ? parts[parts.length - 1] : gid;
      var id = parseInt(raw, 10);
      return isNaN(id) ? -1 : id;
    },

    getNoshiPurposeOptions: function (data) {
      var self = this;
      var latestByType = {};

      (data || []).forEach(function (entry) {
        if (!entry || entry.kind !== 'のし' || !entry.type) return;
        var type = entry.type;
        var current = latestByType[type];
        var nextOrder = self.NOSHI_CATEGORY_ORDER.hasOwnProperty(entry.category) ? self.NOSHI_CATEGORY_ORDER[entry.category] : 999;
        var nextId = self.getNoshiNumericId(entry.gid);

        if (!current || nextOrder < current.categoryOrder || (nextOrder === current.categoryOrder && nextId > current.sortId)) {
          latestByType[type] = {
            type: type,
            category: entry.category || '',
            categoryOrder: nextOrder,
            sortId: nextId
          };
        }
      });

      var options = Object.keys(latestByType).map(function (type) {
        return latestByType[type];
      });

      options.sort(function (a, b) {
        if (a.categoryOrder !== b.categoryOrder) return a.categoryOrder - b.categoryOrder;
        if (a.sortId !== b.sortId) return b.sortId - a.sortId;
        return a.type.localeCompare(b.type, 'ja');
      });

      return options;
    },

    populateNoshiPurposeSelect: function (data) {
      var $select = $('[data-noshi-purpose-select]');
      if (!$select.length) return;

      $select.empty();
      $select.append('<option value="">用途をお選びください</option>');
      this.getNoshiPurposeOptions(data).forEach(function (option) {
        $select.append('<option value="' + option.type + '">' + option.type + '</option>');
      });
      $select.val('');
    },

    renderNoshiCardsByPurpose: function (data, purpose) {
      var self = this;
      var filtered = (data || []).filter(function (entry) {
        return entry && entry.kind === 'のし' && entry.type === purpose;
      });

      var primaryCategory = filtered.length > 0 ? (filtered[0].category || '') : '';
      var isChouji = primaryCategory === '弔事';
      var cardClass = isChouji ? 'c-card-03__item' : 'c-card-02__item';
      var containerClass = isChouji ? 'c-card-03' : 'c-card-02';
      var $container = $('[data-gift-options]');
      $container.removeClass('c-card-02 c-card-03').addClass(containerClass);

      var html = '';
      filtered.forEach(function (entry, index) {
        var imgSrc = entry.image || '';
        html += '<div class="' + cardClass + '">';
        html += '<a href="#" class="p-gift-item" data-noshi-index="' + index + '"';
        html += ' data-noshi-gid="' + self._escapeAttr(entry.gid || '') + '"';
        html += ' data-img="' + self._escapeAttr(imgSrc) + '"';
        html += ' data-title="' + self._escapeAttr(entry.omotegaki || entry.name || '') + '"';
        html += ' data-desc="' + self._escapeAttr(entry.subtitle || '') + '">';
        html += '<div class="p-gift-img">';
        if (imgSrc) {
          html += '<img src="' + self._escapeAttr(imgSrc) + '" alt="' + self._escapeAttr(entry.name || '') + '">';
        }
        html += '</div>';
        html += '<div class="p-gift-info">';
        html += '<h4>' + self._escapeHtml(entry.omotegaki || '') + '</h4>';
        html += '<p>' + self._escapeHtml(entry.name || '') + '</p>';
        if (entry.type) html += '<small>' + self._escapeHtml(entry.type) + '</small>';
        html += '</div>';
        html += '</a>';
        html += '</div>';
      });

      $container.html(html);
      this._currentNoshiFiltered = filtered;
    },

    handleNoshiPurposeChange: function (purpose) {
      var data = this.getNoshiDataForItem(this.currentNoshiItemKey);

      if (purpose) {
        $('[data-noshi-cards-block]').show();
        this.renderNoshiCardsByPurpose(data, purpose);
      } else {
        $('[data-noshi-cards-block]').hide();
        $('[data-gift-options]').empty().removeClass('c-card-02 c-card-03');
        this._currentNoshiFiltered = [];
      }

      this.selectedNoshiEntry = null;
      this.currentNoshiMode = null;

      if (window.NoshiDialogCommon) window.NoshiDialogCommon.clearValidationErrors();
      $('[data-noshi-input-fields]').hide();
      $('[data-noshi-preview-section]').hide();
      $('[data-noshi-name-note]').show();
      $('#noshi-line1, #noshi-line2').val('');
      $('#noshi-uchiiwai-name, #noshi-uchiiwai-furigana').val('');
      $('#corpCompany, #corpTitle, #corpName').val('');
      $('#modalGift .js-corpToggle').prop('checked', false);
      $('#modalGift .js-corpFields').hide();
      $('#noshi-metaobject-gid').val('');
      $('.js-preview-img').attr('src', '');
      $('[data-noshi-preview-btn]').hide();
      $('[data-noshi-preview-note]').hide();
      $('#modalGift [data-save-noshi]').prop('disabled', true);
    },

    handleNoshiCardSelect: function ($card) {
      var index = parseInt($card.attr('data-noshi-index'), 10);
      var filtered = this._currentNoshiFiltered || [];
      var entry = filtered[index];
      if (!entry) return;

      $('#modalGift .p-gift-item').removeClass('is-active');
      $card.addClass('is-active');

      this.selectedNoshiEntry = entry;
      $('#noshi-metaobject-gid').val(entry.gid || '');

      var imgSrc = entry.image || '';
      $('.js-preview-img').attr('src', imgSrc);

      this.showNoshiInputFields(entry);
      this.updateNoshiPreview();
      $('[data-noshi-preview-section]').show();
      $('[data-noshi-count]').show();
    },

    showNoshiInputFields: function (noshi) {
      this.currentNoshiMode = window.NoshiDialogCommon.showInputFieldsForEntry(noshi);
    },

    handleCorpToggle: function () {
      this.currentNoshiMode = window.NoshiDialogCommon.handleCorpToggle(this.selectedNoshiEntry);
      this.updateNoshiPreview();
    },

    updateNoshiPreview: function () {
      if (!this.selectedNoshiEntry) return;
      window.NoshiDialogCommon.resetPreviewVisibility();
    },

    validateNoshiFields: function () {
      return window.NoshiDialogCommon.validateFields(this.currentNoshiMode);
    },

    handleNoshiPreviewClick: function () {
      var entry = this.selectedNoshiEntry;
      if (!entry) return;

      var texts = this.validateNoshiFields();
      if (!texts) return;
      var mode = this.currentNoshiMode;

      window.NoshiDialogCommon.renderPreviewText(entry, mode, texts);
      $('.js-giftPreview').show();
      $('#modalGift [data-save-noshi]').prop('disabled', false);
      this.fetchNoshiPreviewImage(entry, mode, texts);
    },

    fetchNoshiPreviewImage: function (entry, mode, texts) {
      window.NoshiDialogCommon.fetchPreviewImage(entry, mode, texts);
    },

    saveNoshi: function () {
      var itemKey = this.currentNoshiItemKey;
      var splitLineKey = this.currentNoshiSplitLineKey;
      var entry = this.selectedNoshiEntry;
      if (!entry) {
        window.alert('のしの種類を選択してください');
        return;
      }
      if (!itemKey) return;

      var result = this.validateNoshiFields();
      if (!result) return;
      var mode = this.currentNoshiMode;
      var texts = result;

      var item = this._getCartItemByKey(itemKey);
      var totalQty = item ? item.quantity : 1;
      var splitQty = splitLineKey ? this.getSingleSplitLineQty(splitLineKey) : null;
      var effectiveQty = splitQty || totalQty;
      var noshiCount = parseInt($('[data-noshi-count-input]').val(), 10) || effectiveQty;
      noshiCount = Math.max(1, Math.min(noshiCount, effectiveQty));
      $('[data-noshi-count-input]').val(noshiCount);

      var noshiData = {
        gid: entry.gid || '',
        name: entry.name || '',
        category: entry.category || '',
        type: entry.type || '',
        omotegaki: entry.omotegaki || '',
        subtitle: entry.subtitle || '',
        image: entry.image || '',
        mode: mode,
        texts: texts,
        previewImage: $('.js-preview-img').attr('src') || '',
        count: noshiCount
      };

      if (splitLineKey) {
        // Saving noshi on an already-split line
        var splitQtyForSave = this.getSingleSplitLineQty(splitLineKey) || 1;
        if (noshiCount < splitQtyForSave) {
          // Further split this split line
          this.splitExistingSplitLine(splitLineKey, noshiData, null, noshiCount);
        } else {
          var splitSettings = this.getSingleSplitLineSettings(splitLineKey);
          if (splitSettings) {
            splitSettings.noshi = noshiData;
            splitSettings.ribbon = null;
            splitSettings.wrapOnly = false;
            splitSettings.noWrap = false;
          }
        }
      } else if (noshiCount < totalQty) {
        // Partial noshi → create split lines
        this.createSingleSplitLinesFromNoshi(itemKey, totalQty, noshiData, noshiCount);
      } else {
        // Full noshi on all items → no split needed
        state.noshiSettings[itemKey] = noshiData;
        delete state.singleSplitLines[itemKey];
        delete state.stickerSettings[itemKey];
        delete state.wrapOnlyItems[itemKey];
        delete state.noWrapItems[itemKey];
      }

      this._saveData();
      this.closeModal('modalGift');
      this._refreshItemWrappingLabel(itemKey);
    },

    saveNoshiSelection: function () {
      this.saveNoshi();
    },

    restoreNoshiSettings: function (itemKey, data, savedNoshi) {
      var saved = savedNoshi;
      if (!saved && this.currentNoshiSplitLineKey) {
        var splitSettings = this.getSingleSplitLineSettings(this.currentNoshiSplitLineKey);
        saved = splitSettings ? splitSettings.noshi : null;
      }
      if (!saved) saved = state.noshiSettings[itemKey];
      if (!saved) return;

      var restorePurpose = saved.type || '';
      if (!restorePurpose) return;

      $('[data-noshi-purpose-select]').val(restorePurpose);
      this.handleNoshiPurposeChange(restorePurpose);

      var matchedEntry = null;
      var matchedIndex = -1;
      var filtered = this._currentNoshiFiltered || [];
      filtered.forEach(function (entry, i) {
        if (entry.gid === saved.gid || entry.name === saved.name) {
          matchedEntry = entry;
          matchedIndex = i;
        }
      });

      if (!matchedEntry) return;

      var $card = $('#modalGift .p-gift-item[data-noshi-index="' + matchedIndex + '"]');
      if (!$card.length) return;

      this.selectedNoshiEntry = matchedEntry;
      $card.addClass('is-active');
      $('#noshi-metaobject-gid').val(matchedEntry.gid || '');
      $('.js-preview-img').attr('src', matchedEntry.image || '');

      this.showNoshiInputFields(matchedEntry);
      var inputModes = window.NoshiDialogCommon.getEntryInputModes(matchedEntry);

      var savedTexts = saved.texts || {};
      if (saved.mode === 'uchiiwai') {
        $('#noshi-uchiiwai-name').val(savedTexts.name || '');
        $('#noshi-uchiiwai-furigana').val(savedTexts.furigana || '');
        if (window.NoshiDialogCommon) {
          window.NoshiDialogCommon.normalizeUchiiwaiNoshiTexts();
        }
      } else if (saved.mode === 'corporate' && inputModes.allowCorporate) {
        this.currentNoshiMode = 'corporate';
        $('#modalGift .js-corpToggle').prop('checked', true);
        $('#modalGift .js-corpFields').show();
        $('[data-noshi-normal-fields]').hide();
        $('[data-noshi-uchiiwai-fields]').hide();
        $('[data-noshi-name-note]').hide();
        $('#corpCompany').val(savedTexts.company || '');
        $('#corpTitle').val(savedTexts.title || '');
        $('#corpName').val(savedTexts.name || '');
        if (window.NoshiDialogCommon) {
          window.NoshiDialogCommon.normalizeCorporateNoshiTexts();
        }
      } else {
        if (inputModes.defaultMode === 'uchiiwai') {
          $('#noshi-uchiiwai-name').val(savedTexts.name || savedTexts.name1 || '');
          $('#noshi-uchiiwai-furigana').val(savedTexts.furigana || '');
          if (window.NoshiDialogCommon) {
            window.NoshiDialogCommon.normalizeUchiiwaiNoshiTexts();
          }
        } else {
          $('#noshi-line1').val(savedTexts.name1 || savedTexts.name || '');
          $('#noshi-line2').val(savedTexts.name2 || '');
          if (window.NoshiDialogCommon) {
            window.NoshiDialogCommon.normalizeNormalNoshiTexts();
          }
        }
      }

      if (saved.previewImage) {
        $('.js-preview-img').attr('src', saved.previewImage);
      }

      if (saved.count) {
        var countItem = this._getCartItemByKey(itemKey);
        var countTotal = countItem ? countItem.quantity : 1;
        $('[data-noshi-count-input]').val(Math.min(saved.count, countTotal));
      }

      this.updateNoshiPreview();
      $('[data-noshi-preview-section]').show();
      $('[data-noshi-count]').show();
      $('#modalGift [data-save-noshi]').prop('disabled', false);
    },

    // ---------------------------------------------------------------------------
    // Sticker/Ribbon modal
    // ---------------------------------------------------------------------------

    openStickerModal: function (itemKey, splitLineKey) {
      this.currentStickerSplitLineKey = splitLineKey || null;
      $('#sticker-current-item-key').val(itemKey);

      var ribbonData = this._resolveApplicableEntries(window.cartItemsApplicableRibbon, itemKey, window.ribbonData);

      // Populate unified select
      var $select = $('#sticker-unified-select');
      $select.html('<option value="">リボン・シール・ラッピングを選択してください</option>');

      ribbonData.forEach(function (e) {
        var category = e.kind === 'ラッピング' ? '季節ラッピング' : (e.type || 'リボンシール');
        var name = e.name || '';
        var label = '[' + category + '] ' + name;
        var opt = '<option value="' + EgiftShippingApp._escapeAttr(e.gid || '') + '" data-name="' + EgiftShippingApp._escapeAttr(name) + '" data-category="' + EgiftShippingApp._escapeAttr(category) + '">' + EgiftShippingApp._escapeHtml(label) + '</option>';
        $select.append(opt);
      });

      // Restore existing saved selection if exists
      var saved = null;
      if (splitLineKey) {
        var splitSettings = this.getSingleSplitLineSettings(splitLineKey);
        saved = splitSettings ? splitSettings.ribbon : null;
      } else {
        saved = state.stickerSettings[itemKey];
      }
      if (saved && saved.gid) {
        $select.val(saved.gid);
      } else {
        $select.val('');
      }
      $('[data-save-sticker]').prop('disabled', !$select.val());

      // Show/update sticker count control
      var item = this._getCartItemByKey(itemKey);
      var totalQty = item ? (parseInt(item.quantity, 10) || 1) : 1;
      var effectiveQty = splitLineKey ? (this.getSingleSplitLineQty(splitLineKey) || totalQty) : totalQty;
      var savedCount = (saved && saved.count) ? Math.min(saved.count, effectiveQty) : effectiveQty;
      $('[data-sticker-count-input]').val(savedCount);
      $('[data-sticker-count-input]').prop('disabled', false);
      $('[data-sticker-count-total]').text(effectiveQty);
      this.syncGiftSettingCountControl($('[data-sticker-count-input]'), effectiveQty);

      this.openModal('modalSticker');
    },

    saveStickerSelection: function () {
      var itemKey = $('#sticker-current-item-key').val();
      var splitLineKey = this.currentStickerSplitLineKey;
      var $sel    = $('#sticker-unified-select');
      var gid     = $sel.val();
      var name    = $sel.find(':selected').data('name') || '';
      var type    = $sel.find(':selected').data('category') || '';

      if (!itemKey || !gid) return;

      var item = this._getCartItemByKey(itemKey);
      var totalQty = item ? item.quantity : 1;
      var splitQty = splitLineKey ? this.getSingleSplitLineQty(splitLineKey) : null;
      var effectiveQty = splitQty || totalQty;
      var stickerCount = parseInt($('[data-sticker-count-input]').val(), 10) || effectiveQty;
      stickerCount = Math.max(1, Math.min(stickerCount, effectiveQty));
      $('[data-sticker-count-input]').val(stickerCount);

      var ribbonData = { gid: gid, name: name, category: type, count: stickerCount };

      if (splitLineKey) {
        var splitQtyForSave = this.getSingleSplitLineQty(splitLineKey) || 1;
        if (stickerCount < splitQtyForSave) {
          this.splitExistingSplitLine(splitLineKey, null, ribbonData, stickerCount);
        } else {
          var splitSettings = this.getSingleSplitLineSettings(splitLineKey);
          if (splitSettings) {
            splitSettings.ribbon = ribbonData;
            splitSettings.noshi = null;
            splitSettings.wrapOnly = false;
            splitSettings.noWrap = false;
          }
        }
      } else if (stickerCount < totalQty) {
        this.createSingleSplitLinesFromSticker(itemKey, totalQty, ribbonData, stickerCount);
      } else {
        state.stickerSettings[itemKey] = ribbonData;
        delete state.singleSplitLines[itemKey];
        delete state.wrapOnlyItems[itemKey];
        delete state.noWrapItems[itemKey];
        delete state.noshiSettings[itemKey];
      }

      this._saveData();
      this._refreshItemWrappingLabel(itemKey);
      this.closeModal('modalSticker');
    },

    // ---------------------------------------------------------------------------
    // Gift properties builder
    // ---------------------------------------------------------------------------

    buildGiftProperties: function (itemKey) {
      var props = {};

      if (state.wrapOnlyItems[itemKey]) {
        props['_●のし、ラッピングについて'] = '包装のみ';
        return props;
      }
      if (state.noWrapItems[itemKey]) {
        props['_●のし、ラッピングについて'] = '包装なし';
        return props;
      }

      var noshi   = state.noshiSettings[itemKey];
      var sticker = state.stickerSettings[itemKey];

      if (noshi) {
        props['_●のし、ラッピングについて'] = noshi.name;
        var nameLines = [];
        var t = noshi.texts || {};
        if (noshi.mode === 'uchiiwai') {
          nameLines.push('●名入れ：お名前（のし選択者のみ）：' + (t.name || ''));
          nameLines.push('●名入れ：よみがな（のし選択者かつ「出産内祝」希望者のみ）：' + (t.furigana || ''));
        } else if (noshi.mode === 'corporate') {
          nameLines.push('●名入れ：会社名（のし選択者のみ）：' + (t.company || ''));
          nameLines.push('●名入れ：肩書き（のし選択者のみ）：' + (t.title || ''));
          nameLines.push('●名入れ：お名前（のし選択者のみ）：' + (t.name || ''));
        } else {
          nameLines.push('●名入れ：お名前（のし選択者のみ）：' + (t.name1 || ''));
          nameLines.push('●名入れ：連名（のし選択者のみ）：' + (t.name2 || ''));
        }
        if (nameLines.length) {
          props['_●名入れ'] = nameLines.join('\n');
        }
      } else if (sticker) {
        props['_●のし、ラッピングについて'] = sticker.name;
      } else {
        var meta = (window.cartItemsMetafields || {})[itemKey] || {};
        if (this._isFlagDisabled(meta.flags_wrapping)) {
          props['_●のし、ラッピングについて'] = '包装なし';
        } else {
          props['_●のし、ラッピングについて'] = '包装のみ';
        }
      }

      return props;
    },

    /**
     * Build gift properties from split line settings (instead of global state).
     */
    _buildSplitGiftProperties: function (itemKey, splitSettings) {
      var props = {};
      if (!splitSettings) {
        props['_●のし、ラッピングについて'] = '包装のみ';
        return props;
      }

      var noshi = splitSettings.noshi;
      var sticker = splitSettings.ribbon;
      var wrapOnly = splitSettings.wrapOnly;
      var noWrap = splitSettings.noWrap;

      if (wrapOnly) {
        props['_●のし、ラッピングについて'] = '包装のみ';
        return props;
      }
      if (noWrap) {
        props['_●のし、ラッピングについて'] = '包装なし';
        return props;
      }

      if (noshi) {
        props['_●のし、ラッピングについて'] = noshi.name;
        var nameLines = [];
        var t = noshi.texts || {};
        if (noshi.mode === 'uchiiwai') {
          nameLines.push('●名入れ：お名前（のし選択者のみ）：' + (t.name || ''));
          nameLines.push('●名入れ：よみがな（のし選択者かつ「出産内祝」希望者のみ）：' + (t.furigana || ''));
        } else if (noshi.mode === 'corporate') {
          nameLines.push('●名入れ：会社名（のし選択者のみ）：' + (t.company || ''));
          nameLines.push('●名入れ：肩書き（のし選択者のみ）：' + (t.title || ''));
          nameLines.push('●名入れ：お名前（のし選択者のみ）：' + (t.name || ''));
        } else {
          nameLines.push('●名入れ：お名前（のし選択者のみ）：' + (t.name1 || ''));
          nameLines.push('●名入れ：連名（のし選択者のみ）：' + (t.name2 || ''));
        }
        if (nameLines.length) {
          props['_●名入れ'] = nameLines.join('\n');
        }
      } else if (sticker) {
        props['_●のし、ラッピングについて'] = sticker.name;
      } else {
        // No gift option set — default to wrap only
        var meta = (window.cartItemsMetafields || {})[itemKey] || {};
        if (this._isFlagDisabled(meta.flags_wrapping)) {
          props['_●のし、ラッピングについて'] = '包装なし';
        } else {
          props['_●のし、ラッピングについて'] = '包装のみ';
        }
      }

      return props;
    },

    // ---------------------------------------------------------------------------
    // Delivery options
    // ---------------------------------------------------------------------------

    _renderDeliveryOptions: function () {
      var self = this;
      $('[data-delivery-date]').each(function () {
        var $select      = $(this);
        var shippingType = $select.data('shipping-type');
        var shipmentKey  = $select.data('shipment-key');

        // Load dates from AllInGift API when available
        self.waitForAllInGift().then(function () {
          // Populate with basic options for now; real implementation
          // would call AllInGift delivery date API
          self._populateDateSelect($select, shippingType, shipmentKey);
        }).catch(function () {
          self._populateDateSelect($select, shippingType, shipmentKey);
        });
      });

      // eGiftは配送時間指定不要のため、時間行を非表示にする
      $('[data-delivery-time]').each(function () {
        var $row = $(this).closest('.shiptime__row');
        if ($row.length) {
          $row.remove();
        } else {
          $(this).remove();
        }
      });
    },

    _populateDateSelect: function ($select, shippingType, shipmentKey) {
      var saved = (state.deliverySettings[shipmentKey] || {}).date || '';
      var opts  = '<option value="" ' + (!saved ? 'selected' : '') + '>指定なし</option>';

      // Generate next 14 days
      var today = new Date();
      for (var i = 2; i <= 14; i++) {
        var d    = new Date(today);
        d.setDate(today.getDate() + i);
        var val  = this._formatDate(d);
        var label= this._formatDateLabel(d);
        opts += '<option value="' + val + '" ' + (saved === val ? 'selected' : '') + '>' + label + '</option>';
      }

      $select.html(opts);
      $select.on('change', function () {
        state.deliverySettings[shipmentKey] = state.deliverySettings[shipmentKey] || {};
        state.deliverySettings[shipmentKey].date = $(this).val();
        EgiftShippingApp._saveData();
      });
    },

    _populateTimeSelect: function ($select) {
      var shipmentKey = $select.data('shipment-key');
      var saved       = (state.deliverySettings[shipmentKey] || {}).time || '';

      var timeSlots = [
        { value: '',           label: '指定なし' },
        { value: 'MORNING',    label: '午前中' },
        { value: 'FROM12TO14', label: '12:00〜14:00' },
        { value: 'FROM14TO16', label: '14:00〜16:00' },
        { value: 'FROM16TO18', label: '16:00〜18:00' },
        { value: 'FROM18TO20', label: '18:00〜20:00' },
        { value: 'FROM19TO21', label: '19:00〜21:00' }
      ];

      var opts = timeSlots.map(function (s) {
        return '<option value="' + s.value + '" ' + (saved === s.value ? 'selected' : '') + '>' + s.label + '</option>';
      }).join('');

      $select.html(opts);
      $select.on('change', function () {
        state.deliverySettings[shipmentKey] = state.deliverySettings[shipmentKey] || {};
        state.deliverySettings[shipmentKey].time = $(this).val();
        EgiftShippingApp._saveData();
      });
    },

    // ---------------------------------------------------------------------------
    // Checkout
    // ---------------------------------------------------------------------------

    _bindCheckoutButton: function () {
      var self = this;
      var $btn = $('[data-egift-checkout-btn]');
      if (!$btn.length) return;

      $btn.on('click', function () {
        if ($btn.hasClass('is-disabled')) {
          // Show validation errors and scroll to first error
          self._validateForm(false);
          return;
        }
        self._validateAndCheckout();
      });

      // Reset checkout button & card selection when user navigates back from checkout page (bfcache restore)
      window.addEventListener('pageshow', function(event) {
        if (event.persisted) {
          var $b = $('[data-egift-checkout-btn]');
          $b.prop('disabled', false).removeClass('is-disabled');
          $('#egift-checkout-overlay').addClass('is-hidden');
          self._restoreEgiftForm();
          self._renderMessageCards();
          self._syncEgiftFormState();
          self._updatePreviewButtonState();
          self._updateCheckoutButtonState();
        }
      });

      // Privacy policy checkbox — update checkout button state on change
      $(document).on('change', '#privacy-policy-check', function() {
        self._updateCheckoutButtonState();
      });
    },

    _updateCheckoutButtonState: function () {
      var $btn  = $('[data-egift-checkout-btn]');
      var valid = this._validateForm(true);
      var privacyChecked = window.shippingCustomer ? true : $('#privacy-policy-check').is(':checked');
      if (valid && privacyChecked) {
        $btn.removeClass('is-disabled').prop('disabled', false);
      } else {
        $btn.addClass('is-disabled').prop('disabled', true);
      }
    },

    _updatePreviewButtonState: function () {
      var form = this._getEgiftFormData();
      var canPreview = !!(form.destinationName && form.cardUrl && form.message && form.nickname);
      var $btn = $('[data-egift-preview-btn]');
      if (!$btn.length) return;

      if (canPreview) {
        $btn.removeClass('is-disabled').prop('disabled', false);
      } else {
        $btn.addClass('is-disabled').prop('disabled', true);
      }
    },

    openEgiftPreview: function () {
      if (!this._validateForm(false, { forPreview: true })) return;

      var form = this._getEgiftFormData();
      var $modal = $('#modalEgiftPreview');
      var $canvas = $modal.find('.egift-preview-canvas');
      var $image = $modal.find('[data-egift-preview-card-image]');
      var $message = $modal.find('[data-egift-preview-message]');
      var $nickname = $modal.find('[data-egift-preview-nickname]');

      this._resetEgiftPreview();
      $canvas.addClass('is-loading');
      $message.text(this._composeCardMessage(form));
      $nickname.text(form.nickname);
      $image.off('.egiftPreview').one('load.egiftPreview error.egiftPreview', function () {
        $canvas.removeClass('is-loading');
      });
      window.requestAnimationFrame(function () {
        $image.attr('src', form.cardUrl);
      });

      this.openModal('modalEgiftPreview');
    },

    /**
     * フォームバリデーション
     * @param {boolean} silent - trueの場合エラーメッセージを表示しない
     * @param {Object} [options]
     * @returns {boolean}
     */
    _validateForm: function (silent, options) {
      options = options || {};
      var form = this._getEgiftFormData();
      var errors = {};
      var messages = [];
      var newlineCount = (form.message.match(/\n/g) || []).length;

      if (!form.destinationName) {
        errors.destinationName = '「ギフトを贈る相手のお名前」をご入力ください。';
        messages.push(errors.destinationName);
      } else if (form.destinationName.length > DESTINATION_NAME_MAX_LENGTH) {
        errors.destinationName = '「ギフトを贈る相手のお名前」は' + DESTINATION_NAME_MAX_LENGTH + '文字以内でご入力ください。';
        messages.push(errors.destinationName);
      } else if (window.CharValidator) {
        var _cvDestMsg = window.CharValidator.validate(form.destinationName, 'name');
        if (_cvDestMsg) {
          errors.destinationName = _cvDestMsg;
          messages.push(_cvDestMsg);
        }
      }
      if (!form.cardUrl) {
        errors.cardUrl = '「デジタルカードのデザイン」をお選びください。';
        messages.push(errors.cardUrl);
      } else if (!this._isValidUrl(form.cardUrl)) {
        errors.cardUrl = '選択されたメッセージカードに問題があります。お手数ですが再度お選びください。';
        messages.push(errors.cardUrl);
      }
      if (!form.message) {
        errors.message = '「メッセージ」をご入力ください。';
        messages.push(errors.message);
      } else {
        if (newlineCount > 1) {
          errors.message = 'メッセージの改行は1回以内でご入力ください。';
        } else if (this._countMessageChars(form.message) > 40 || form.message.length > (40 + newlineCount)) {
          errors.message = 'メッセージは40文字以内でご入力ください。';
        }
        if (errors.message) {
          messages.push(errors.message);
        }
      }
      if (!form.nickname) {
        errors.nickname = '「贈り主名」をご入力ください。';
        messages.push(errors.nickname);
      } else if (form.nickname.length > state.nicknameMaxLength) {
        errors.nickname = '「贈り主名」は' + state.nicknameMaxLength + '文字以内でご入力ください。';
        messages.push(errors.nickname);
      } else if (window.CharValidator) {
        var _cvNickMsg = window.CharValidator.validate(form.nickname, 'name');
        if (_cvNickMsg) {
          errors.nickname = _cvNickMsg;
          messages.push(_cvNickMsg);
        }
      }

      // Orderer info required
      var ordererMissing = !state.orderer || !state.orderer.lastName || !state.orderer.firstName;
      if (ordererMissing) {
        errors.orderer = '「ご注文者情報」のご登録をお願いいたします。';
        messages.push(errors.orderer);
      }

      // Bag selection validation (選択可能 items must have on/off chosen) — skip for preview
      if (!options.forPreview) {
        var bagResult = this._validateRequiredBagSelections(silent);
        if (!bagResult.valid) {
          messages.push('手提げ袋を選択してください。');
        }
      }

      if (silent) {
        return messages.length === 0;
      }

      this._renderFormErrors(errors);

      if (messages.length > 0) {
        // Alert to notify user of all errors
        var alertHeader = 'ご入力内容をご確認ください。\n\n';
        alert(alertHeader + messages.map(function (m) { return '・' + m; }).join('\n'));

        // Orderer missing → open orderer modal
        if (ordererMissing) {
          this.openModal('modalEgiftAddOrderer');
          return false;
        }

        // Bag error → scroll to first invalid bag
        if (!bagResult.valid && bagResult.$firstInvalid && bagResult.$firstInvalid.length) {
          $('html, body').animate({
            scrollTop: Math.max(bagResult.$firstInvalid.offset().top - 120, 0)
          }, 400);
          return false;
        }

        // Scroll to first eGift form error field
        var fieldPriority = ['destinationName', 'cardUrl', 'message', 'nickname'];
        for (var i = 0; i < fieldPriority.length; i++) {
          if (errors[fieldPriority[i]]) {
            var $target = $('[data-egift-field="' + fieldPriority[i] + '"]');
            if ($target.length) {
              $('html, body').animate({
                scrollTop: $target.offset().top - 100
              }, 400);
            }
            break;
          }
        }
      }

      return messages.length === 0;
    },

    _renderFormErrors: function (errors) {
      this._clearAllFieldErrors();
      var self = this;
      Object.keys(errors).forEach(function (field) {
        self._showFieldError(field, errors[field]);
      });
    },

    _clearAllFieldErrors: function () {
      $('[data-egift-field]').removeClass('is-error');
      $('[data-egift-error-for]').text('');
    },

    _showFieldError: function (field, message) {
      var $field = $('[data-egift-field="' + field + '"]');
      var $error = $('[data-egift-error-for="' + field + '"]');
      if ($field.length) {
        $field.addClass('is-error');
      }
      if ($error.length) {
        $error.text(message || '');
      }
    },

    _clearFieldError: function (field) {
      var $field = $('[data-egift-field="' + field + '"]');
      var $error = $('[data-egift-error-for="' + field + '"]');
      if ($field.length) {
        $field.removeClass('is-error');
      }
      if ($error.length) {
        $error.text('');
      }
    },

    _isValidUrl: function (url) {
      try {
        var parsed = new URL(url);
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
      } catch (e) {
        return false;
      }
    },

    _isFlagDisabled: function (value) {
      return value === false || value === 'false' || value === 0 || value === '0';
    },

    _sanitizeItemId: function (value) {
      return String(value || '').replace(/[^a-zA-Z0-9]/g, '_');
    },

    _hasApplicableOption: function (mapping, itemKey, fallbackData) {
      if (mapping && Object.prototype.hasOwnProperty.call(mapping, itemKey)) {
        var mappedValue = mapping[itemKey];
        if (Array.isArray(mappedValue)) {
          return mappedValue.length > 0;
        }
        return !!mappedValue;
      }

      if (Array.isArray(fallbackData)) {
        return fallbackData.length > 0;
      }

      return true;
    },

    _resolveApplicableEntries: function (mapping, itemKey, allEntries) {
      var entries = Array.isArray(allEntries) ? allEntries : [];

      if (mapping && Object.prototype.hasOwnProperty.call(mapping, itemKey)) {
        var mappedValue = mapping[itemKey];
        if (Array.isArray(mappedValue)) {
          return mappedValue.map(function (idx) {
            return entries[idx];
          }).filter(Boolean);
        }
      }

      return entries;
    },

    /**
     * Run sync _validateForm, then async orderer address validation, then proceed to checkout
     */
    _validateAndCheckout: function () {
      var self = this;
      if (!this._validateForm(false)) return;
      // yokumoku.max-cart-pcs Wチェック (チェックアウト直前)
      var mcpCheck = window.MaxCartPcs && window.MaxCartPcs.validateCart
        ? window.MaxCartPcs.validateCart()
        : Promise.resolve({ ok: true });
      mcpCheck.then(function (result) {
        if (!result.ok) return;
        self._validateOrdererAddress().then(function (valid) {
          if (valid) self.checkout();
        });
      });
    },

    /**
     * Async validate orderer zip (zipcloud API) and phone (regex)
     * @returns {Promise<boolean>}
     */
    _validateOrdererAddress: function () {
      var self = this;
      var o = state.orderer;
      if (!o) {
        return Promise.resolve(true);
      }

      var errors = [];

      // Name validation
      if (!o.lastName || !o.firstName) {
        errors.push({ field: 'name', msg: 'お名前を入力してください。' });
      }

      // Phone validation (same logic as _validateAddressFields)
      var oPhone = this._normalizePhoneInput(o.phone || '').replace(/[-\s]/g, '');
      var phoneValid = oPhone &&
        /^(0[5789]0\d{8}|0[1-9]\d{8}|0120\d{6}|0800\d{7})$/.test(oPhone) &&
        !/0{8}$/.test(oPhone);
      if (!phoneValid) {
        errors.push({ field: 'phone', msg: '正しい電話番号を入力してください。' });
      }

      // Zip format check (sync)
      var oZip = this._normalizeZipInput(o.zip || '');
      var zipFormatOk = /^\d{7}$/.test(oZip);
      if (!zipFormatOk) {
        errors.push({ field: 'zip', msg: '正しい郵便番号を入力してください。' });
      }

      // Prefecture check (separate message)
      if (!o.prefectureCode) {
        errors.push({ field: 'prefecture', msg: '都道府県を選択してください。' });
      }

      // Any sync error → skip API check
      if (errors.length > 0) {
        this._showOrdererValidationErrors(errors);
        return Promise.resolve(false);
      }

      // Zip: async API check via self-hosted postal-codes API
      return new Promise(function (resolve) {
        $.ajax({
          url: '/apps/ping/postal-codes/search',
          dataType: 'jsonp',
          data: { zipcode: oZip },
          timeout: 3000,
          success: function (res) {
            if (!res || res.status !== 200 || !res.results || !res.results.length) {
              errors.push({ field: 'zip', msg: '正しい郵便番号を入力してください。' });
            } else {
              if (o.prefectureCode !== 'JP-' + res.results[0].prefcode) {
                errors.push({ field: 'prefecture', msg: '郵便番号と住所の組み合わせが一致していません。郵便番号または住所をご確認のうえ、再入力してください。' });
              }
            }
            if (errors.length > 0) {
              self._showOrdererValidationErrors(errors);
              resolve(false);
            } else {
              self._ordererAddressFieldErrors = {};
              $('[data-orderer-validation-errors]').remove();
              resolve(true);
            }
          },
          error: function (xhr, status) {
            // API unreachable — skip zip check, only surface phone errors
            if (errors.length > 0) {
              self._showOrdererValidationErrors(errors);
              resolve(false);
            } else {
              resolve(true);
            }
          }
        });
      });
    },

    /**
     * Show inline validation errors under the orderer info block and scroll to it
     */
    _showOrdererValidationErrors: function (errors) {
      this._ordererAddressFieldErrors = {};
      var self = this;
      errors.forEach(function (e) {
        self._ordererAddressFieldErrors[e.field] = e.msg;
      });
      $('[data-orderer-validation-errors]').remove();
      var $pAddress = $('[data-orderer-info]').closest('.p-address');
      errors.forEach(function (e) {
        $pAddress.append('<p class="p-form-error-txt" data-orderer-validation-errors>' + e.msg + '</p>');
      });
      var $ordererSection = $pAddress.closest('.p-checkout__item');
      if ($ordererSection.length) {
        $('html, body').animate({ scrollTop: $ordererSection.offset().top - 100 }, 400);
      }
    },

    /**
     * Show error on a specific orderer form field (same pattern as _validateAddressFields)
     */
    _showOrdererFieldError: function (fieldId, msg) {
      var $el = $('#' + fieldId);
      if (!$el.length) return;
      var $rowItem = $el.closest('.p-row-item');
      $rowItem.addClass('is-error');
      $rowItem.find('.p-form-error-txt').remove();
      $rowItem.append('<p class="p-form-error-txt">' + msg + '</p>');
    },

    /**
     * チェックアウトデータを構築して AllInGift.checkout.eGift() を呼び出す
     */
    checkout: function () {
      if (!this._validateForm(false)) return;

      // Push begin_checkout event to dataLayer for GTM/GA4
      try {
        var egiftCartItems = (state.cart && state.cart.items) || [];
        var gtmItems = egiftCartItems.map(function (item, idx) {
          return {
            item_id: String(item.product_id),
            item_name: item.product_title,
            price: item.price / 100,
            item_brand: 'ヨックモック',
            item_variant: item.variant_title || '',
            quantity: item.quantity || 1,
            index: idx
          };
        });
        var gtmValue = gtmItems.reduce(function (sum, i) { return sum + i.price * i.quantity; }, 0);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'begin_checkout',
          ecommerce: {
            currency: 'JPY',
            value: gtmValue,
            items: gtmItems
          }
        });
      } catch (e) {}

      // Save default address before checkout (fire-and-forget, never blocks checkout)
      // Skip if metafield already has a saved address ID
      if (window.shippingCustomer && !window.shippingCustomer.defaultAddressIdAtCheckout) {
        fetch('/apps/ping/customers/default-address/save', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        }).catch(function(err) {
          console.warn('Failed to save default address:', err);
        });
      }

      var self     = this;
      var formData = this._getEgiftFormData();
      var customer = window.shippingCustomer;

      // Check if current customer is in the debug list for raw AIG error display
      var isDebugPaymentUser = (function() {
        var ids = (window.debugPaymentErrorUsers || '').split(',').map(function(s) { return s.trim(); }).filter(Boolean);
        var cid = customer && String(customer.id);
        return !!cid && ids.indexOf(cid) !== -1;
      })();

      var checkoutData = this._buildCheckoutData(formData, customer);


      var $btn = $('[data-egift-checkout-btn]');
      $btn.addClass('is-disabled').prop('disabled', true);
      $('#egift-checkout-overlay').removeClass('is-hidden');

      this.waitForAllInGift().then(function () {
        window.AllInGift.checkout.eGift(checkoutData)
          .then(function (response) {
            if (response.success && response.invoiceUrl) {
              // Mark that checkout has started (so returning via back button won't reset settings)
              try { sessionStorage.setItem('egiftCheckoutStarted', '1'); } catch (e) {}
              window.location.href = response.invoiceUrl;
            } else {
              var alertMsg;
              if (isDebugPaymentUser) {
                alertMsg = '[DEBUG] Raw AIG response:\n' + JSON.stringify(response, null, 2);
              } else {
                try {
                  var msgStr = response.message || '';
                  var bracketMatch = msgStr.match(/\[gift\]\s*(\[[\s\S]*\])/);
                  var parsed = bracketMatch ? JSON.parse(bracketMatch[1]) : null;
                  var isAddress1Error = parsed && Array.isArray(parsed) && parsed.some(function(e) {
                    return e.path && e.path.indexOf('address1') !== -1;
                  });
                  alertMsg = isAddress1Error
                    ? '「町名・番地」に誤りがあります。番地まで入力してください。'
                    : 'エラーが発生しました: ' + (msgStr || '不明なエラー');
                } catch (e) {
                  alertMsg = 'エラーが発生しました: ' + (response.message || '不明なエラー');
                }
              }
              $('#egift-checkout-overlay').addClass('is-hidden');
              alert(alertMsg);
              $btn.removeClass('is-disabled').prop('disabled', false);
            }
          })
          .catch(function (error) {
            $('#egift-checkout-overlay').addClass('is-hidden');
            alert(isDebugPaymentUser ? '[DEBUG] AIG checkout exception:\n' + String(error) : 'エラーが発生しました: ' + (error.message || '不明なエラー'));
            $btn.removeClass('is-disabled').prop('disabled', false);
          });
      }).catch(function (sdkErr) {
        $('#egift-checkout-overlay').addClass('is-hidden');
        alert(isDebugPaymentUser ? '[DEBUG] waitForAllInGift failed:\n' + String(sdkErr) : 'ただいまアクセスが集中しております。\nしばらく経ってから再度お試しください。');
        $btn.removeClass('is-disabled').prop('disabled', false);
      });
    },

    /**
     * Build parentOrderNote string for the parent draft order (eGift)
     */
    _buildParentOrderNote: function (customer, orderer) {
      var lines = [];

      // 顧客区分
      var category = (function () {
        if (!customer) return 'ゲスト';
        var tags = Array.isArray(customer.tags) ? customer.tags : [];
        if (tags.indexOf('旧外商顧客') !== -1) return '外商顧客';
        // 社売15%タグも外商顧客扱い（％は全角/半角どちらの表記でも一致させる）
        var hasShauri15 = tags.some(function (tag) {
          var normalized = String(tag)
            .replace(/％/g, '%')
            .replace(/[０-９]/g, function (d) { return String.fromCharCode(d.charCodeAt(0) - 0xFEE0); });
          return normalized === '社売15%';
        });
        if (hasShauri15) return '外商顧客';
        if (tags.indexOf('社員売顧客') !== -1) return '社売';
        var memberType = String(customer.memberType || '').trim();
        if (memberType === '法人') return '法人顧客';
        return '一般顧客';
      })();
      lines.push('顧客区分は' + category + 'です。');

      // 社員番号（顧客タグに「社員売顧客」がある場合のみ）
      if (customer && Array.isArray(customer.tags) && customer.tags.indexOf('社員売顧客') !== -1) {
        var employeeId = customer.employeeId || '';
        if (employeeId) {
          lines.push('社員番号は' + employeeId + 'です。');
        }
      }

      // 要注意顧客チェック
      if (customer && Array.isArray(customer.tags) && customer.tags.indexOf('要注意顧客') !== -1) {
        lines.push('この顧客は要注意タグがついています。');
      }

      // 注文者氏名（ordererから直接取得）
      var ordererName = $.trim((orderer.lastName || '') + ' ' + (orderer.firstName || ''));
      lines.push('注文者氏名は' + (ordererName || '未登録') + 'です。');

      // eギフト識別
      lines.push('この注文はeギフトです。');

      // Yahoo広告 yclid（_yclid_ydn Cookie があれば parentOrderNote 末尾に追記）
      var yclidMatch = document.cookie.match(/(?:^|; )_yclid_ydn=([^;]+)/);
      if (yclidMatch && yclidMatch[1]) {
        lines.push('「Yahoo!広告効果計測用タグ：' + yclidMatch[1] + '」');
      }

      return '\n' + lines.join('\n');
    },

    /**
     * MultiShipEGift[] を構築する
     * 配送タイプ（常温/冷凍/メール便）ごとに1オブジェクト
     */
    _buildCheckoutData: function (formData, customer) {
      var self = this;
      var cart = state.cart;
      var orderer = state.orderer || {};
      var ordererName = $.trim((orderer.lastName || '') + ' ' + (orderer.firstName || ''));

      var customAttribute = {
        digitalMessageCardUrl: formData.cardUrl,
        digitalMessage:        this._composeCardMessage(formData),
        nickname:              formData.nickname,
        // UI上は空欄許容だが、All in Gift APIは宛先名必須のため送信時のみ補完する
        destinationName:       formData.destinationName || DESTINATION_NAME_FALLBACK_FOR_API,
        senderName:            ordererName || orderer.lastName || '',
        remark:                '',
        usage:                 '贈り物'
      };

      var parentOrderNote = this._buildParentOrderNote(customer, orderer);

      // Build orderer address for childOrderBillingAddress + defaultShippingAddress
      var ordererAddr = {
        lastName:    orderer.lastName    || '',
        firstName:   orderer.firstName   || '',
        zip:         (orderer.zip || '').replace(/-/g, ''),
        countryCode: 'JP',
        provinceCode: orderer.prefectureCode || '',
        city:        orderer.city        || '',
        address1:    orderer.address1    || '',
        address2:    orderer.address2    || ''
      };
      var ordererPhone = (orderer.phone || '').replace(/[^0-9]/g, '');
      if (ordererPhone) ordererAddr.phone = ordererPhone;

      var defaultShippingAddr = {
        lastName:    ordererAddr.lastName,
        firstName:   ordererAddr.firstName,
        address1:    ordererAddr.address1,
        address2:    ordererAddr.address2,
        city:        ordererAddr.city,
        province:    ordererAddr.provinceCode,
        countryCode: 'JP',
        zip:         ordererAddr.zip
      };
      if (ordererPhone) defaultShippingAddr.phone = ordererPhone;

      // Group items by shipment key
      var shipmentGroups = this._groupItemsByShipment(cart.items);
      var checkoutData   = [];

      Object.keys(shipmentGroups).forEach(function (shipmentKey) {
        var group    = shipmentGroups[shipmentKey];
        var type     = group.shippingType;
        var variantId = SHIPPING_VARIANT_IDS[type] || SHIPPING_VARIANT_IDS.ambient;
        var title     = SHIPPING_METHOD_TITLES[type] || SHIPPING_METHOD_TITLES.ambient;

        var items = [];
        var isFirstItem = true;
        group.items.forEach(function (item) {
          var splitLines = self.getSingleSplitLinesForItem(item);

          if (splitLines.length >= 2) {
            // Item is split — generate separate line items per split with their own gift properties
            splitLines.forEach(function (line) {
              var splitGiftProps = self._buildSplitGiftProperties(item.key, line.settings);
              var itemData = {
                parsedVariantId: 'gid://shopify/ProductVariant/' + item.variant_id,
                quantity: line.qty,
                giftOptions: [],
                properties: splitGiftProps
              };
              if (isFirstItem && state.shippingRateInfo) {
                itemData.shippingLine = {
                  price: state.shippingRateInfo.price,
                  title: title
                };
              }
              isFirstItem = false;
              items.push(itemData);

              // Collect bag items from each split line key
              var lineBags = self._buildHandbagItems(line.splitLineKey);
              lineBags.forEach(function (bagItem) {
                items.push(bagItem);
              });
            });
            return;
          }

          var itemData = {
            parsedVariantId:  'gid://shopify/ProductVariant/' + item.variant_id,
            quantity:         item.quantity,
            giftOptions:      [],
            properties:       self.buildGiftProperties(item.key)
          };
          if (isFirstItem && state.shippingRateInfo) {
            itemData.shippingLine = {
              price: state.shippingRateInfo.price,
              title: title
            };
          }
          isFirstItem = false;
          items.push(itemData);

          var handbagItems = self._buildHandbagItems(item.key);
          handbagItems.forEach(function (bagItem) {
            items.push(bagItem);
          });
        });

        var shipment = {
          customAttribute: $.extend({}, customAttribute),
          items:           items,
          defaultShippingMethod: {
            title:     title,
            variantId: 'gid://shopify/ProductVariant/' + variantId
          },
          shippingLineProductVariantId: variantId,
          childOrderBillingAddress: $.extend({}, ordererAddr),
          defaultShippingAddress:   $.extend({}, defaultShippingAddr),
          parentOrderNote: parentOrderNote
        };

        if (customer && customer.id) {
          shipment.customer = { id: customer.id, tags: customer.tags || [] };
        }

        checkoutData.push(shipment);
      });

      // _hide_pay: 複数条件をカンマ区切りで追加
      var hidePayValues = ['egift'];

      // 注文者住所やデフォルト配送先住所に顧客番号が含まれる場合 → paid
      var hasPaidHideTarget = hasPaidCustomerNumber(this.sender) || checkoutData.some(function (shipment) {
        return hasPaidCustomerNumber(shipment && shipment.defaultShippingAddress);
      });
      if (hasPaidHideTarget) {
        hidePayValues.push('paid');
      }

      var hidePayStr = hidePayValues.join(',');
      checkoutData.forEach(function(shipment) {
        (shipment.items || []).forEach(function(item) {
          item.properties = item.properties || {};
          item.properties['_hide_pay'] = hidePayStr;
        });
      });

      return checkoutData;
    },

    /**
     * カートアイテムを shipmentKey でグループ化
     * @returns {{ [shipmentKey]: { shippingType, items[] } }}
     */
    _groupItemsByShipment: function (cartItems) {
      var groups = {};

      cartItems.forEach(function (item) {
        var type = EgiftShippingApp.getItemShippingType(item);
        var disabled = EgiftShippingApp.getItemMixedLoadingDisabled(item);
        var shipmentKey = disabled ? (type + '_' + item.key) : type;

        if (!groups[shipmentKey]) {
          groups[shipmentKey] = { shippingType: type, items: [] };
        }
        groups[shipmentKey].items.push(item);
      });

      return groups;
    },

    // ---------------------------------------------------------------------------
    // Product type detection (mirrored from shipping-app.js)
    // ---------------------------------------------------------------------------

    getItemShippingType: function (item) {
      var meta = (window.cartItemsMetafields || {})[item.key];
      if (meta && meta.temperature_zone) {
        var zone = meta.temperature_zone;
        if (zone === '冷凍')       return 'frozen';
        if (zone === '常温メール便') return 'mail';
        return 'ambient';
      }
      var text = ((item.product_type || '') + ' ' + ((item.tags || []).join(' '))).toLowerCase();
      if (text.indexOf('冷凍') !== -1 || text.indexOf('frozen') !== -1) return 'frozen';
      if (text.indexOf('メール便') !== -1 || text.indexOf('mail') !== -1) return 'mail';
      return 'ambient';
    },

    getItemMixedLoadingDisabled: function (item) {
      var meta = (window.cartItemsMetafields || {})[item.key];
      return !!(meta && meta.flags_mixed_loading_disable);
    },

    // ---------------------------------------------------------------------------
    // Modal helpers
    // ---------------------------------------------------------------------------

    openModal: function (id) {
      var $modal = $('#' + id);
      if (!$modal.length) return;

      if (!$('.p-modal.active').length) {
        state.modalScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        $('html').addClass('freezePage');
        $('body').addClass('freezePage').css({ top: -state.modalScrollTop + 'px' });
      }

      $modal.addClass('active');
    },

    closeModal: function (id) {
      var $modal = $('#' + id);
      if (!$modal.length) return;
      $modal.removeClass('active');

      if (id === 'modalEgiftPreview') {
        this._resetEgiftPreview();
      }

      if (!$('.p-modal.active').length) {
        var bodyTop = parseInt($('body').css('top'), 10);
        var restorePos = !isNaN(bodyTop) ? (bodyTop * -1) : state.modalScrollTop;
        $('html').removeClass('freezePage');
        $('body').removeClass('freezePage').css({ top: 0 });
        window.scrollTo(0, restorePos || 0);
        state.modalScrollTop = 0;
      }
    },

    // ---------------------------------------------------------------------------
    // SDK wait helper
    // ---------------------------------------------------------------------------

    waitForAllInGift: function () {
      return new Promise(function (resolve, reject) {
        var attempts = 0;
        var max = 30;
        var timer = setInterval(function () {
          if (window.AllInGift && typeof window.AllInGift.config === 'function') {
            clearInterval(timer);
            resolve();
          } else if (++attempts >= max) {
            clearInterval(timer);
            reject(new Error('AllInGift SDK not available'));
          }
        }, 200);
      });
    },

    // ---------------------------------------------------------------------------
    // LocalStorage persistence
    // ---------------------------------------------------------------------------

    _normalizeBagSettingsByRules: function () {
      var self = this;
      Object.keys(state.bagSettings || {}).forEach(function (bagKey) {
        var settings = state.bagSettings[bagKey];
        if (!settings) return;
        // Resolve original item key from splitLineKey if needed
        var origItemKey = bagKey;
        if (self.isSplitLineKey(bagKey)) {
          var parsed = self.parseSplitLineKey(bagKey);
          if (parsed) origItemKey = parsed.itemKey;
        }
        var item = self._getCartItemByKey(origItemKey);
        if (!item) return;
        var effectiveQty;
        if (self.isSplitLineKey(bagKey)) {
          effectiveQty = self.getSingleSplitLineQty(bagKey) || (parseInt(item.quantity, 10) || 1);
        } else {
          effectiveQty = parseInt(item.quantity, 10) || 1;
        }
        var variants = self._getHandbagVariantsForProduct(origItemKey);
        var freeBag = variants.find(function (v) { return (parseInt(v.price, 10) || 0) === 0; });
        var paidBags = variants.filter(function (v) { return (parseInt(v.price, 10) || 0) > 0; });
        self._applyBagRuleToSettings(origItemKey, settings, freeBag, paidBags, effectiveQty);
      });
    },

    /**
     * カートが空になった時にeGift関連のlocalStorageを全クリアする。
     * ゲストユーザーの場合は注文者情報もリセット。
     */
    _clearAllEgiftData: function () {
      localStorage.removeItem(BAG_SETTINGS_STORAGE_KEY);
      localStorage.removeItem('egift_noshi_settings');
      localStorage.removeItem('egift_sticker_settings');
      localStorage.removeItem('egift_wraponly_items');
      localStorage.removeItem('egift_nowrap_items');
      localStorage.removeItem('egift_delivery_settings');
      localStorage.removeItem('egift_split_lines');
      localStorage.removeItem(SENDER_STORAGE_KEY);
      localStorage.removeItem('egift_form_data');
      // ゲスト: 注文者情報もクリア
      if (!window.shippingCustomer) {
        localStorage.removeItem(ORDERER_STORAGE_KEY);
        state.orderer = null;
      }
      state.bagSettings = {};
      state.noshiSettings = {};
      state.stickerSettings = {};
      state.wrapOnlyItems = {};
      state.noWrapItems = {};
      state.deliverySettings = {};
      state.singleSplitLines = {};
      state.sender = this._defaultSender();
    },

    _saveData: function () {
      try {
        this._normalizeBagSettingsByRules();
        localStorage.setItem(BAG_SETTINGS_STORAGE_KEY, JSON.stringify(this._sanitizeBagSettings(state.bagSettings)));
        localStorage.setItem('egift_noshi_settings',    JSON.stringify(state.noshiSettings));
        localStorage.setItem('egift_sticker_settings',  JSON.stringify(state.stickerSettings));
        localStorage.setItem('egift_wraponly_items',    JSON.stringify(state.wrapOnlyItems));
        localStorage.setItem('egift_nowrap_items',      JSON.stringify(state.noWrapItems));
        localStorage.setItem('egift_delivery_settings', JSON.stringify(state.deliverySettings));
        localStorage.setItem('egift_split_lines',       JSON.stringify(state.singleSplitLines));
        localStorage.setItem(SENDER_STORAGE_KEY, JSON.stringify(this._normalizeSender(state.sender)));
        if (state.orderer) {
          localStorage.setItem(ORDERER_STORAGE_KEY, JSON.stringify(state.orderer));
        }
      } catch (e) {}
    },

    _loadData: function () {
      function tryParse(key) {
        try { return JSON.parse(localStorage.getItem(key)) || {}; } catch (e) { return {}; }
      }
      state.noshiSettings    = tryParse('egift_noshi_settings');
      state.stickerSettings  = tryParse('egift_sticker_settings');
      state.wrapOnlyItems    = tryParse('egift_wraponly_items');
      state.noWrapItems      = tryParse('egift_nowrap_items');
      state.deliverySettings = tryParse('egift_delivery_settings');
      state.singleSplitLines = tryParse('egift_split_lines');
      state.bagSettings      = this._sanitizeBagSettings(tryParse(BAG_SETTINGS_STORAGE_KEY));
      var senderData = tryParse(SENDER_STORAGE_KEY);
      if (!senderData || typeof senderData !== 'object' || Array.isArray(senderData)) {
        senderData = {};
      }
      state.sender = this._normalizeSender(senderData);

      // Orderer: logged-in with valid defaultAddress → use it; otherwise load from localStorage
      var customerDa = window.shippingCustomer && window.shippingCustomer.defaultAddress;
      if (customerDa && (customerDa.lastName || customerDa.address1)) {
        var pc = customerDa.province || customerDa.provinceCode || '';
        if (!pc) {
        }
        state.orderer = {
          addressId:      customerDa.id || '',
          lastName:       customerDa.lastName || '',
          firstName:      customerDa.firstName || '',
          zip:            (customerDa.zip || '').replace(/-/g, ''),
          prefecture:     this._getPrefectureNameByCode(pc),
          prefectureCode: pc,
          city:           customerDa.city || '',
          address1:       customerDa.address1 || '',
          address2:       customerDa.address2 || '',
          company:        customerDa.company || '',
          personType:     customerDa.company ? 'corporate' : 'individual',
          phone:          this._normalizeDomesticPhone(customerDa.phone || ''),
          countryCode:    'JP'
        };
      } else {
        var savedOrderer = tryParse(ORDERER_STORAGE_KEY);
        if (savedOrderer && savedOrderer.lastName) {
          state.orderer = savedOrderer;
          if (!savedOrderer.prefectureCode) {
          }
        } else {
          state.orderer = null;
        }
      }
    },

    _loadAssetImages: function () {
      var $root = $('[data-egift-shipping-page]');
      if (!$root.length) return;
      state.wrapImage = $root.attr('data-free-bag-img') || '';
      state.paidBagImage = $root.attr('data-paid-bag-img') || '';
      state.noshiImage = $root.attr('data-noshi-img') || '';
      state.ribbonImage = $root.attr('data-ribbon-img') || '';
    },

    _resetEgiftPreview: function () {
      var $modal = $('#modalEgiftPreview');
      if (!$modal.length) return;

      var $canvas = $modal.find('.egift-preview-canvas');
      var $image = $modal.find('[data-egift-preview-card-image]');
      var $message = $modal.find('[data-egift-preview-message]');
      var $nickname = $modal.find('[data-egift-preview-nickname]');

      $canvas.addClass('is-loading');
      $message.text('');
      $nickname.text('');
      $image.off('.egiftPreview').attr('src', '');
    },

    // ---------------------------------------------------------------------------
    // Split card rendering (noshi/ribbon partial split)
    // ---------------------------------------------------------------------------

    /**
     * Render wrapping + bag options for each split card when items are split.
     * Each split line gets its own independent bag settings and wrapping option card.
     */
    _renderSplitWrappingOptions: function (itemKey, $container, splitLines) {
      try { return this._renderSplitWrappingOptionsInner(itemKey, $container, splitLines); }
      catch (e) { console.error('[eGift][_renderSplitWrappingOptions] ERROR:', e); $container.html('<p style="color:red;">分割表示エラー: ' + e.message + '</p>'); }
    },

    _renderSplitWrappingOptionsInner: function (itemKey, $container, splitLines) {
      var self = this;
      var meta = (window.cartItemsMetafields || {})[itemKey] || {};
      var isWrapDisabled = this._isFlagDisabled(meta.flags_wrapping);
      // Noshi/ribbon availability is independent of flags_wrapping (mirrors renderWrappingOptions)
      var hasNoshi =
        !this._isFlagDisabled(meta.flags_noshi) &&
        this._hasApplicableOption(window.cartItemsApplicableNoshi, itemKey, window.noshiData);
      var hasRibbon =
        !this._isFlagDisabled(meta.flags_ribbon) &&
        this._hasApplicableOption(window.cartItemsApplicableRibbon, itemKey, window.ribbonData);
      var canWrapOnly = !isWrapDisabled;
      var canNoWrap = isWrapDisabled;
      var item = this._getCartItemByKey(itemKey);

      // Precompute floor+remainder allocation in integer yen so split card totals
      // sum exactly to the displayed line total (parseInt in _formatMoney is lossless).
      var _sriDiscFloors = null, _sriOrigFloors = null;
      if (item && item.quantity > 0 && splitLines.length > 1) {
        var _sriFinalYen = Math.round((item.final_line_price || 0) / 100);
        var _sriOrigYen  = Math.round((item.original_line_price || 0) / 100);
        _sriDiscFloors = splitLines.map(function(l) {
          return Math.floor(_sriFinalYen * (parseInt(l.qty, 10) || 0) / item.quantity);
        });
        _sriDiscFloors[_sriDiscFloors.length - 1] +=
          _sriFinalYen - _sriDiscFloors.reduce(function(s, v) { return s + v; }, 0);
        _sriOrigFloors = splitLines.map(function(l) {
          return Math.floor(_sriOrigYen * (parseInt(l.qty, 10) || 0) / item.quantity);
        });
        _sriOrigFloors[_sriOrigFloors.length - 1] +=
          _sriOrigYen - _sriOrigFloors.reduce(function(s, v) { return s + v; }, 0);
      }

      var html = '';
      for (var si = 0; si < splitLines.length; si++) {
        var line = splitLines[si];
        var splitLineKey = line.splitLineKey;
        var splitSettings = line.settings || {};
        var lineQty = line.qty;
        var itemId = this._sanitizeItemId(splitLineKey);
        var optionName = 'packageOption_' + itemId;

        // Determine current selection from split line settings
        var currentNoshi = splitSettings.noshi;
        var currentRibbon = splitSettings.ribbon;
        var isWrapOnly = splitSettings.wrapOnly;
        var isNoWrap = splitSettings.noWrap;
        var selectedOption = canNoWrap ? 'none' : 'wrap';

        // Only auto-set noWrap when no gift option (noshi/ribbon) is already saved.
        if (!isWrapOnly && !isNoWrap && isWrapDisabled && !currentNoshi && !currentRibbon) {
          isNoWrap = true;
          splitSettings.noWrap = true;
        }

        if (currentNoshi) selectedOption = 'noshi';
        else if (currentRibbon) selectedOption = 'ribbon';
        else if (isNoWrap) selectedOption = 'none';
        else if (isWrapOnly) selectedOption = 'wrap';
        if (isWrapDisabled && selectedOption === 'wrap') selectedOption = 'none';

        var noshiDisabled = hasNoshi ? '' : ' disabled';
        var noshiDisabledClass = hasNoshi ? '' : ' is-disable';
        var ribbonDisabled = hasRibbon ? '' : ' disabled';
        var ribbonDisabledClass = hasRibbon ? '' : ' is-disable';

        var splitPrice = item ? ((item.original_price != null ? item.original_price : item.price) / 100) : 0;
        var splitDiscountedPrice = splitPrice;
        var splitHasUnitDiscount = false;
        var splitHasDiscount = false;

        // Use the actual Automatic Discount applied to the cart line.
        if (item) {
          var _lineDiscounted = (item.final_price != null ? item.final_price : item.price) / 100;
          if (_lineDiscounted < splitPrice) {
            splitHasUnitDiscount = true;
            splitHasDiscount = true;
            splitDiscountedPrice = _lineDiscounted;
          } else if (item.original_line_price != null && item.original_line_price > item.final_line_price) {
            splitHasDiscount = true;
          }
        }

        // Use precomputed floor+remainder allocation (integer yen) when available; fall back to unit × qty.
        var _splitDiscCard = (_sriDiscFloors && _sriDiscFloors[si] != null)
          ? _sriDiscFloors[si]
          : splitDiscountedPrice * lineQty;
        var _splitOrigCard = (_sriOrigFloors && _sriOrigFloors[si] != null)
          ? _sriOrigFloors[si]
          : splitPrice * lineQty;
        var splitTotal = _splitDiscCard;
        var splitMaxQty = item ? (parseInt(item.quantity, 10) || 1) : 1;
        var splitDecDisabled = lineQty <= 1;
        var splitIncDisabled = lineQty >= splitMaxQty;

        var shippingType = this._getItemShippingType(item);
        var tempTag = '常温', tempClass = 'c-badge--green';
        if (shippingType === 'frozen') { tempTag = '冷凍'; tempClass = 'c-badge--blue02'; }
        else if (shippingType === 'mail') { tempTag = 'メール便'; tempClass = 'c-badge--mail'; }

        html += '<div class="wrap-product-item wrap-product-item--split" data-item-key="' + this._escapeAttr(splitLineKey) + '" data-source-item-key="' + this._escapeAttr(itemKey) + '" data-bag-settings-key="' + this._escapeAttr(splitLineKey) + '">';
        html += '<div class="addr-content__sect"><div class="addr-content__item">';
        html += '<div class="cart-item">';
        html += '<div class="cart-item__thumb"><img src="' + (item.image || window._defaultProductImage || '') + '" alt="' + this._escapeHtml(item.title || '') + '"></div>';
        html += '<div class="cart-item__main"><div class="cart-item__top">';
        html += '<span class="c-badge ' + tempClass + '">' + tempTag + '</span>';
        html += '<h4 class="cart-item__title">' + this._escapeHtml(item.product_title || item.title || '') + '</h4>';
        html += '</div></div>';
        html += '<div class="cart-item__bottom"><div class="cart-item__right">';
        html += '<div class="cart-item__unit" data-unit="' + splitPrice + '" data-discounted-unit="' + (splitHasUnitDiscount ? splitDiscountedPrice : '') + '" data-has-discount="' + (splitHasDiscount ? 'true' : '') + '">';
        if (splitHasUnitDiscount) {
          html += this._renderDiscountPricePair(this._formatMoney(splitPrice), this._formatMoney(splitDiscountedPrice));
        } else {
          html += '<span class="price">' + this._formatMoney(splitPrice) + '</span>';
        }
        html += '</div>';
        html += '<div class="qty">';
        html += '<button type="button" class="qty__btn js-splitQtyBtn' + (splitDecDisabled ? ' is-disabled' : '') + '" data-step="-1"' + (splitDecDisabled ? ' disabled' : '') + ' aria-label="decrease">−</button>';
        html += '<input class="qty__input js-splitQtyInput" type="number" value="' + lineQty + '" inputmode="numeric" aria-label="quantity" min="1" max="' + splitMaxQty + '">';
        html += '<button type="button" class="qty__btn js-splitQtyBtn' + (splitIncDisabled ? ' is-disabled' : '') + '" data-step="1"' + (splitIncDisabled ? ' disabled' : '') + ' aria-label="increase">＋</button>';
        html += '</div>';
        if (splitHasDiscount) {
          html += '<div class="cart-item__total">' + this._renderDiscountPricePair(this._formatMoney(_splitOrigCard), this._formatMoney(splitTotal)) + '</div>';
        } else {
          html += '<div class="cart-item__total"><span class="price">' + this._formatMoney(_splitOrigCard) + '</span></div>';
        }
        html += '</div></div>';
        html += '<button type="button" class="btn-remove-item js-removeItem" aria-label="' + this._escapeHtml(item.product_title || item.title || '') + 'を削除する">';
        html += '<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="24" height="24" rx="12" fill="white" stroke="#9DB2CE"></rect><path d="M17.7003 7.29687L7.30029 17.6969" stroke="#9DB2CE" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.30029 7.29688L17.7003 17.6969" stroke="#9DB2CE" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
        html += '</button>';
        html += '</div></div></div>';

        // Bag section per split card
        html += this._renderBagSectionHtml(itemKey, itemId, meta, splitLineKey);

        html += '<div class="addr-content__sect"><div class="addr-content__item">';
        html += '<h4 class="c-ttl-03">包装・のし・リボン</h4>';
        html += '<div class="c-card-01 js-packageList" data-item-key="' + this._escapeAttr(splitLineKey) + '" data-split-line-key="' + this._escapeAttr(splitLineKey) + '" data-source-item-key="' + this._escapeAttr(itemKey) + '">';

        if (canWrapOnly) {
          html += '<div class="c-card-01__item">';
          html += '<label class="option-card js-packageItem js-packageWrap' + (selectedOption === 'wrap' ? ' is-active' : '') + '">';
          html += '<input type="radio" name="' + optionName + '" value="wrap" class="option-card__radio"' + (selectedOption === 'wrap' ? ' checked' : '') + '>';
          html += '<div class="option-card__inner js-packageClick">';
          // Product-level override (metafield yokumoku.wrap_thumbnail), e.g. seasonal wrapping paper
          var wrapImage = meta.wrap_thumbnail || state.wrapImage;
          if (wrapImage) {
            html += '<div class="option-card__thumb"><img src="' + this._escapeAttr(wrapImage) + '" alt=""></div>';
          } else {
            html += '<div class="option-card__thumb"></div>';
          }
          html += '<div class="option-card__text"><p class="option-card__title">包装のみ<span class="c-badge c-badge--free">無料サービス</span></p></div>';
          html += '</div></label></div>';
        }

        html += '<div class="c-card-01__item" style="position: relative;">';
        html += '<label class="option-card js-packageItem js-packageNoshi' + noshiDisabledClass + (selectedOption === 'noshi' ? ' is-active' : '') + '">';
        html += '<input type="radio" name="' + optionName + '" value="noshi" class="option-card__radio"' + (selectedOption === 'noshi' ? ' checked' : '') + noshiDisabled + '>';
        html += '<a href="#" class="option-card__inner js-packageClick">';
        if (state.noshiImage) {
          html += '<div class="option-card__thumb"><img src="' + this._escapeAttr(state.noshiImage) + '" alt=""></div>';
        } else {
          html += '<div class="option-card__thumb"></div>';
        }
        html += '<div class="option-card__text"><p class="option-card__title">のし<span class="c-badge c-badge--free">無料サービス</span></p></div>';
        html += '</a></label>';
        if (hasNoshi) {
          html += '<div data-overlay-noshi="' + this._escapeAttr(itemKey) + '" data-split-line-key="' + this._escapeAttr(splitLineKey) + '" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 5; cursor: pointer;"></div>';
        }
        html += '</div>';

        html += '<div class="c-card-01__item" style="position: relative;">';
        html += '<label class="option-card js-packageItem js-packageRibbon' + ribbonDisabledClass + (selectedOption === 'ribbon' ? ' is-active' : '') + '">';
        html += '<input type="radio" name="' + optionName + '" value="ribbon" class="option-card__radio"' + (selectedOption === 'ribbon' ? ' checked' : '') + ribbonDisabled + '>';
        html += '<a href="#" class="option-card__inner js-packageClick">';
        if (state.ribbonImage) {
          html += '<div class="option-card__thumb"><img src="' + this._escapeAttr(state.ribbonImage) + '" alt=""></div>';
        } else {
          html += '<div class="option-card__thumb"></div>';
        }
        html += '<div class="option-card__text"><p class="option-card__title"><span class="option-card__title--txt">リボンシール・<br class="u-md-max">季節ラッピング</span><span class="c-badge c-badge--free">無料サービス</span></p></div>';
        html += '</a></label>';
        if (hasRibbon) {
          html += '<div data-overlay-ribbon="' + this._escapeAttr(itemKey) + '" data-split-line-key="' + this._escapeAttr(splitLineKey) + '" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 5; cursor: pointer;"></div>';
        }
        html += '</div>';

        if (canNoWrap) {
          html += '<div class="c-card-01__item">';
          html += '<label class="option-card js-packageItem js-packageNone' + (selectedOption === 'none' ? ' is-active' : '') + '">';
          html += '<input type="radio" name="' + optionName + '" value="none" class="option-card__radio"' + (selectedOption === 'none' ? ' checked' : '') + '>';
          html += '<div class="option-card__inner js-packageClick">';
          html += '<div class="option-card__text"><p class="option-card__title">包装なし</p></div>';
          html += '</div></label></div>';
        }

        html += '</div>'; // c-card-01

        // Noshi/sticker status for this split line
        if (currentNoshi) {
          html += this._renderNoshiStatusSummary(itemKey, currentNoshi, splitLineKey);
        }
        if (currentRibbon) {
          html += this._renderStickerStatusSummary(itemKey, currentRibbon, splitLineKey);
        }

        html += '</div></div>'; // addr-content__item + addr-content__sect
        html += '</div>'; // wrap-product-item--split

        if (si < splitLines.length - 1) {
          html += '<div class="linegap u-sm-min"></div>';
        }
      }

      // Hide the original product card section (split cards include their own product info)
      var $origCard = $container.siblings('.addr-content__sect').first();
      $origCard.hide();

      $container.html(html);

      // Bind events for each split card
      $container.find('[data-split-card], [data-source-item-key]').each(function () {
        var $card = $(this);
        var cardSplitLineKey = $card.attr('data-item-key');
        var cardItemKey = $card.attr('data-source-item-key');
        var cardItemId = self._sanitizeItemId(cardSplitLineKey);
        var cardBagToggleName = 'bagToggle_' + cardItemId;
        var cardOptionName = 'packageOption_' + cardItemId;

        // Bag toggle events
        self._bindSplitCardBagEvents($card, cardItemKey, cardSplitLineKey, cardBagToggleName);

        // Wrapping option change
        $card.find('input[name="' + cardOptionName + '"]').off('change.egiftWrap').on('change.egiftWrap', function () {
          var _k = self._resolveCardKeys($(this));
          var currentCardSplitLineKey = _k.splitLineKey || cardSplitLineKey;
          var currentCardItemKey = _k.itemKey || cardItemKey;
          var selected = $(this).val();
          var splitSettings = self.getSingleSplitLineSettings(currentCardSplitLineKey);
          if (!splitSettings) return;

          if (selected === 'wrap') {
            splitSettings.wrapOnly = true;
            splitSettings.noWrap = false;
            splitSettings.noshi = null;
            splitSettings.ribbon = null;
          } else if (selected === 'none') {
            splitSettings.noWrap = true;
            splitSettings.wrapOnly = false;
            splitSettings.noshi = null;
            splitSettings.ribbon = null;
          } else if (selected === 'noshi' && splitSettings.noshi) {
            splitSettings.wrapOnly = false;
            splitSettings.noWrap = false;
            splitSettings.ribbon = null;
          } else if (selected === 'ribbon' && splitSettings.ribbon) {
            splitSettings.wrapOnly = false;
            splitSettings.noWrap = false;
            splitSettings.noshi = null;
          }

          self._saveData();
          self._renderWrappingOptions(currentCardItemKey, $container);
        });

        // Noshi overlay
        $card.find('[data-overlay-noshi]').off('click.egiftWrap').on('click.egiftWrap', function (e) {
          e.preventDefault();
          var currentItemKey = $(this).attr('data-overlay-noshi') || cardItemKey;
          var slk = $(this).attr('data-split-line-key') || cardSplitLineKey;
          self.openNoshiModal(currentItemKey, slk);
        });

        // Ribbon overlay
        $card.find('[data-overlay-ribbon]').off('click.egiftWrap').on('click.egiftWrap', function (e) {
          e.preventDefault();
          var currentItemKey = $(this).attr('data-overlay-ribbon') || cardItemKey;
          var slk = $(this).attr('data-split-line-key') || cardSplitLineKey;
          self.openStickerModal(currentItemKey, slk);
        });

        // Bag modal open
        $card.off('click.egiftBagOpen', '[data-open-bag-modal], [data-overlay-paid-bag]').on('click.egiftBagOpen', '[data-open-bag-modal], [data-overlay-paid-bag]', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var _k = self._resolveCardKeys($card);
          var currentCardItemKey = _k.itemKey || cardItemKey;
          var bagKey = $(this).attr('data-bag-settings-key') || _k.splitLineKey || cardSplitLineKey;
          var item = self._getCartItemByKey(currentCardItemKey);
          self._openBagModal(bagKey, item ? item.variant_id : '');
        });
      });
    },

    /**
     * Bind bag toggle, free bag checkbox, qty buttons for a split card.
     */
    _bindSplitCardBagEvents: function ($card, itemKey, splitLineKey, bagToggleName) {
      var self = this;
      var bagSettingsKey = splitLineKey;
      // Resolve live keys from $card at callback time so post-re-key interactions
      // use migrated attributes rather than closed-over constructor arguments.
      // Note: $card is the outer .wrap-product-item--split which carries data-item-key
      // (the split line key) and data-source-item-key (parent key), but NOT
      // data-split-line-key (that attr lives on the inner .js-packageList child).
      // We therefore read splitLineKey directly from data-item-key on $card.
      function liveKeys() {
        var currentItemKey      = $card.attr('data-source-item-key') || itemKey;
        var currentBagKey       = $card.attr('data-bag-settings-key') || splitLineKey;
        // data-item-key on a split card IS the split line key (e.g. parentKey::split:N)
        var currentSplitLineKey = $card.attr('data-item-key') || currentBagKey || splitLineKey;
        return {
          itemKey:        currentItemKey,
          splitLineKey:   currentSplitLineKey,
          bagSettingsKey: currentBagKey
        };
      }

      // Bag toggle (付けない) - clear bags when "付けない" is selected
      $card.find('input[name="' + bagToggleName + '"]').off('change.egiftBagToggle').on('change.egiftBagToggle', function () {
        var _k = liveKeys(); var itemKey = _k.itemKey; var splitLineKey = _k.splitLineKey; var bagSettingsKey = _k.bagSettingsKey;
        var selected = $(this).val();
        var $wrapper = $(this).closest('.addr-content__item');
        $wrapper.find('.js-bagToggle').removeClass('is-error');
        $wrapper.find('.js-bag-selection-error').remove();
        var settings = self._getBagSettings(bagSettingsKey, true);
        var variants = self._getHandbagVariantsForProduct(itemKey);
        var freeBag = variants.find(function (b) { return (parseInt(b.price, 10) || 0) === 0; });
        var paidBags = variants.filter(function (b) { return (parseInt(b.price, 10) || 0) > 0; });
        var ruleConfig = self._getBagRuleConfig(itemKey);
        var effectiveQty = self.getSingleSplitLineQty(splitLineKey) || 1;
        self._applyBagRuleToSettings(itemKey, settings, freeBag, paidBags, effectiveQty);

        if (selected === 'off') {
          settings.bagSelection = 'off';
          settings.bags = {};
          settings.freeBagEnabled = false;
          settings.paidBagEnabled = false;
          $wrapper.find('[data-bag-type="free"], [data-bag-type="paid"]').prop('checked', false).closest('.option-card').removeClass('is-active');
          $wrapper.find('.js-freeBagQty').hide();
          $wrapper.find('.js-bagQtyInput').val(1);
          $wrapper.find('[data-bag-status]').html('');
          $wrapper.find('[data-bag-off-status]').show();
          $wrapper.find('.js-bagPaid').each(function() {
            var $label = $(this);
            if (!$label.next('[data-overlay-paid-bag]').length) {
              var ik = $wrapper.closest('[data-item-key]').data('item-key') || itemKey;
              var vid = $label.find('[data-open-bag-modal]').data('variant-id') || '';
              var bsk = $wrapper.closest('[data-bag-settings-key]').data('bag-settings-key') || bagSettingsKey;
              $label.after('<div data-overlay-paid-bag data-item-key="' + ik + '" data-variant-id="' + vid + '" data-bag-settings-key="' + bsk + '" style="position:absolute;top:0;left:0;right:0;bottom:0;z-index:5;cursor:pointer;"></div>');
            }
          });
          self._saveData();
          self._updateOrderSummary();
          self._updateCheckoutButtonState();
        }
      });

      // Free bag card click — toggle checkbox (label replaced with div)
      $card.find('.js-freeBag').off('click.egiftFreeBagCard').on('click.egiftFreeBagCard', function(e) {
        if ($(e.target).closest('.qty-wrap').length) return;
        if ($(e.target).is('.option-card__checkbox')) return;
        var $cardEl = $(this);
        var $cb = $cardEl.find('.option-card__checkbox');
        if ($cb.prop('disabled') || $cardEl.hasClass('is-disable')) return;
        $cb.prop('checked', !$cb.is(':checked')).trigger('change.egiftBagFree');
      });

      $card.find('[data-bag-type="free"]').off('change.egiftBagFree').on('change.egiftBagFree', function () {
        var _k = liveKeys(); var itemKey = _k.itemKey; var splitLineKey = _k.splitLineKey; var bagSettingsKey = _k.bagSettingsKey;
        var $cb = $(this);
        var settings = self._getBagSettings(bagSettingsKey, true);
        var variantId = String($cb.attr('data-bag-variant-id') || '');
        var $row = $cb.closest('.c-card-01__item');
        var $qtyInput = $row.find('.js-bagQtyInput');
        var $qtyWrap = $row.find('.js-freeBagQty');
        var ruleConfig = self._getBagRuleConfig(itemKey);
        var effectiveQty = self.getSingleSplitLineQty(splitLineKey) || 1;
        var qty = parseInt($qtyInput.val(), 10) || 1;
        qty = Math.max(1, Math.min(effectiveQty, qty));
        if (ruleConfig.lockFree) {
          qty = effectiveQty;
          $cb.prop('checked', true);
        }
        $qtyInput.val(qty);

        settings.freeBagEnabled = ruleConfig.lockFree ? true : $cb.is(':checked');
        if (settings.freeBagEnabled) {
          settings.bags[variantId] = qty;
          $qtyWrap.show();
        } else {
          if (variantId) delete settings.bags[variantId];
          $qtyWrap.hide();
        }

        $cb.closest('.option-card').toggleClass('is-active', settings.freeBagEnabled);
        var $wrapper = $cb.closest('.addr-content__item');
        $card.find('[data-bag-status]').html(self._renderBagStatusSummary(bagSettingsKey));
        self._syncBagOffLabel($wrapper, bagSettingsKey, itemKey);
        self._updateOrderSummary();
        self._updateCheckoutButtonState();
      });

      $card.find('.js-bagQtyBtn').off('click.egiftBagQty').on('click.egiftBagQty', function (e) {
        e.preventDefault();
        var _k = liveKeys(); var itemKey = _k.itemKey; var splitLineKey = _k.splitLineKey; var bagSettingsKey = _k.bagSettingsKey;
        var $btn = $(this);
        if ($btn.prop('disabled')) return;
        var $input = $btn.siblings('.js-bagQtyInput');
        var step = parseInt($btn.attr('data-step'), 10) || 0;
        var current = parseInt($input.val(), 10) || 0;
        var ruleConfig = self._getBagRuleConfig(itemKey);
        if (ruleConfig.lockFree) return;
        var maxQty = self.getSingleSplitLineQty(splitLineKey) || 1;
        var next = Math.max(0, Math.min(maxQty, current + step));
        $input.val(next);
        $btn.closest('.qty').find('[data-step="1"]').prop('disabled', next >= maxQty);
        $btn.closest('.qty').find('[data-step="-1"]').prop('disabled', next <= 0);

        var $freeCb = $btn.closest('.c-card-01__item').find('[data-bag-type="free"]');
        var variantId = String($freeCb.attr('data-bag-variant-id') || '');
        var $addrWrapper = $btn.closest('.addr-content__item');
        if (next === 0 && $freeCb.length && $freeCb.is(':checked')) {
          $freeCb.prop('checked', false).closest('.option-card').removeClass('is-active');
          $btn.closest('.js-freeBagQty').hide();
          var settings = self._getBagSettings(bagSettingsKey, true);
          settings.freeBagEnabled = false;
          if (variantId) delete settings.bags[variantId];
          $card.find('[data-bag-status]').html(self._renderBagStatusSummary(bagSettingsKey));
          self._syncBagOffLabel($addrWrapper, bagSettingsKey, itemKey);
          self._updateOrderSummary();
        } else if (next > 0 && $freeCb.length && !$freeCb.is(':checked')) {
          $freeCb.prop('checked', true).closest('.option-card').addClass('is-active');
          $btn.closest('.js-freeBagQty').show();
          var settings = self._getBagSettings(bagSettingsKey, true);
          settings.freeBagEnabled = true;
          if (variantId) settings.bags[variantId] = next;
          $card.find('[data-bag-status]').html(self._renderBagStatusSummary(bagSettingsKey));
          self._syncBagOffLabel($addrWrapper, bagSettingsKey, itemKey);
          self._updateOrderSummary();
        } else if ($freeCb.length && $freeCb.is(':checked')) {
          var settings = self._getBagSettings(bagSettingsKey, true);
          if (variantId) {
            settings.bags[variantId] = next;
            $card.find('[data-bag-status]').html(self._renderBagStatusSummary(bagSettingsKey));
            self._saveData();
            self._updateOrderSummary();
          }
        }
      });

      $card.find('.js-bagQtyInput').off('change.egiftBagQty').on('change.egiftBagQty', function () {
        var _k = liveKeys(); var itemKey = _k.itemKey; var splitLineKey = _k.splitLineKey; var bagSettingsKey = _k.bagSettingsKey;
        var $input = $(this);
        if ($input.prop('disabled')) return;
        var entered = parseInt($input.val(), 10) || 0;
        var ruleConfig = self._getBagRuleConfig(itemKey);
        if (ruleConfig.lockFree) return;
        var maxQty = self.getSingleSplitLineQty(splitLineKey) || 1;
        var normalized = Math.max(0, Math.min(maxQty, entered));
        $input.val(normalized);
        $input.closest('.qty').find('[data-step="1"]').prop('disabled', normalized >= maxQty);
        $input.closest('.qty').find('[data-step="-1"]').prop('disabled', normalized <= 0);

        var $freeCb = $input.closest('.c-card-01__item').find('[data-bag-type="free"]');
        var variantId = String($freeCb.attr('data-bag-variant-id') || '');
        var $addrWrapper = $input.closest('.addr-content__item');
        if (normalized === 0 && $freeCb.length && $freeCb.is(':checked')) {
          $freeCb.prop('checked', false).closest('.option-card').removeClass('is-active');
          $input.closest('.js-freeBagQty').hide();
          var settings = self._getBagSettings(bagSettingsKey, true);
          settings.freeBagEnabled = false;
          if (variantId) delete settings.bags[variantId];
          $card.find('[data-bag-status]').html(self._renderBagStatusSummary(bagSettingsKey));
          self._syncBagOffLabel($addrWrapper, bagSettingsKey, itemKey);
          self._updateOrderSummary();
        } else if (normalized > 0 && $freeCb.length && !$freeCb.is(':checked')) {
          $freeCb.prop('checked', true).closest('.option-card').addClass('is-active');
          $input.closest('.js-freeBagQty').show();
          var settings = self._getBagSettings(bagSettingsKey, true);
          settings.freeBagEnabled = true;
          if (variantId) settings.bags[variantId] = normalized;
          $card.find('[data-bag-status]').html(self._renderBagStatusSummary(bagSettingsKey));
          self._syncBagOffLabel($addrWrapper, bagSettingsKey, itemKey);
          self._updateOrderSummary();
        } else if ($freeCb.length && $freeCb.is(':checked')) {
          var settings = self._getBagSettings(bagSettingsKey, true);
          if (variantId) {
            settings.bags[variantId] = normalized;
            $card.find('[data-bag-status]').html(self._renderBagStatusSummary(bagSettingsKey));
            self._saveData();
            self._updateOrderSummary();
          }
        }
      });

      $card.find('[data-bag-type="paid"]').off('change.egiftBagPaid').on('change.egiftBagPaid', function () {
        var _k = liveKeys(); var itemKey = _k.itemKey; var splitLineKey = _k.splitLineKey; var bagSettingsKey = _k.bagSettingsKey;
        var $cb = $(this);
        var ruleConfig = self._getBagRuleConfig(itemKey);
        if (ruleConfig.hidePaid || ruleConfig.disablePaid) {
          $cb.prop('checked', false);
          return;
        }
        var settings = self._getBagSettings(bagSettingsKey, true);
        var variants = self._getHandbagVariantsForProduct(itemKey);
        var isChecked = $cb.is(':checked');
        settings.paidBagEnabled = isChecked;

        if (!isChecked) {
          Object.keys(settings.bags || {}).forEach(function (bagId) {
            var info = variants.find(function (b) { return String(b.shopifyProductVariantId) === String(bagId); });
            if (info && (parseInt(info.price, 10) || 0) > 0) {
              delete settings.bags[bagId];
            }
          });
          var item = self._getCartItemByKey(itemKey);
          if ($card.find('[data-overlay-paid-bag]').length === 0) {
            $cb.closest('.c-card-01__item').append(
              '<div data-overlay-paid-bag data-item-key="' + self._escapeAttr(itemKey) + '" data-variant-id="' + self._escapeAttr(String(item ? item.variant_id : '')) + '" data-bag-settings-key="' + self._escapeAttr(bagSettingsKey) + '" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 5; cursor: pointer;"></div>'
            );
          }
        } else {
          $card.find('[data-overlay-paid-bag]').remove();
        }

        $cb.closest('.js-bagPaid').toggleClass('is-active', isChecked);
        var $addrWrapper = $cb.closest('.addr-content__item');
        $card.find('[data-bag-status]').html(self._renderBagStatusSummary(bagSettingsKey));
        self._syncBagOffLabel($addrWrapper, bagSettingsKey, itemKey);
        self._updateOrderSummary();
      });
    },

    // ---------------------------------------------------------------------------
    // UI helpers
    // ---------------------------------------------------------------------------

    _renderNoshiStatusSummary: function (itemKey, savedNoshi, splitLineKey) {
      var saved = savedNoshi || state.noshiSettings[itemKey];
      if (!saved) return '';

      var nameLine = '';
      if (saved.mode === 'uchiiwai') {
        nameLine = this._escapeHtml((saved.texts && saved.texts.name) || '');
      } else if (saved.mode === 'corporate') {
        var parts = [saved.texts && saved.texts.company, saved.texts && saved.texts.title, saved.texts && saved.texts.name].filter(Boolean);
        nameLine = this._escapeHtml(parts.join(' / '));
      } else {
        var parts = [saved.texts && saved.texts.name1, saved.texts && saved.texts.name2].filter(Boolean);
        nameLine = this._escapeHtml(parts.join(' / '));
      }

      var displayKey = splitLineKey || itemKey;
      var html = '<div class="p-fee u-mb-15 u-mt-15 noshi-status" data-noshi-status="' + displayKey + '">';
      html += '<div class="p-fee__head">';
      html += '<h4 class="p-fee__title">のし設定</h4>';
      html += '<a href="#" class="p-fee__edit" data-open-noshi="' + itemKey + '" data-split-line-key="' + (splitLineKey || '') + '">変更</a>';
      html += '</div>';
      html += '<ul class="p-fee__list">';
      html += '<li class="p-fee__row"><span class="p-fee__label">種類</span><span>' + this._escapeHtml(saved.category || '') + '</span></li>';
      html += '<li class="p-fee__row"><span class="p-fee__label">表書き</span><span>' + this._escapeHtml(saved.omotegaki || '') + '</span></li>';
      html += '<li class="p-fee__row"><span class="p-fee__label">水引</span><span>' + this._escapeHtml(saved.name || '') + '</span></li>';
      html += '<li class="p-fee__row"><span class="p-fee__label">お名前</span><span>' + nameLine + '</span></li>';
      html += '</ul>';
      html += '</div>';
      return html;
    },

    _renderStickerStatusSummary: function (itemKey, savedSticker, splitLineKey) {
      var saved = savedSticker || state.stickerSettings[itemKey];
      if (!saved) return '';

      var displayKey = splitLineKey || itemKey;
      var html = '<div class="p-fee u-mb-15 u-mt-15 sticker-status" data-sticker-status="' + displayKey + '">';
      html += '<div class="p-fee__head">';
      html += '<h4 class="p-fee__title">リボン設定</h4>';
      html += '<a href="#" class="p-fee__edit" data-open-sticker="' + itemKey + '" data-split-line-key="' + (splitLineKey || '') + '">変更</a>';
      html += '</div>';
      html += '<ul class="p-fee__list">';
      html += '<li class="p-fee__row"><span class="p-fee__label">種類</span><span>' + this._escapeHtml(saved.category || '') + '</span></li>';
      html += '<li class="p-fee__row"><span class="p-fee__label">名称</span><span>' + this._escapeHtml(saved.name || '') + '</span></li>';
      html += '</ul>';
      html += '</div>';
      return html;
    },

    _refreshItemWrappingLabel: function (itemKey) {
      var self = this;
      var $placeholder = $('[data-item-key="' + itemKey + '"] [data-gift-options-placeholder]');
      if ($placeholder.length) {
        self._renderWrappingOptions(itemKey, $placeholder);
      } else {
        // Fallback: try finding placeholder directly under wrap-product-item
        var $wrapper = $('[data-item-key="' + itemKey + '"]').not('[data-source-item-key]');
        var $fallback = $wrapper.find('[data-gift-options-placeholder]');
        if ($fallback.length) {
          self._renderWrappingOptions(itemKey, $fallback);
        }
      }
    },

    _formatMoneyYen: function (value) {
      var amount = parseInt(value, 10) || 0;
      return amount.toLocaleString('ja-JP') + '円';
    },

    _formatDate: function (d) {
      var m = ('0' + (d.getMonth() + 1)).slice(-2);
      var day = ('0' + d.getDate()).slice(-2);
      return d.getFullYear() + '-' + m + '-' + day;
    },

    _formatDateLabel: function (d) {
      var days = ['日', '月', '火', '水', '木', '金', '土'];
      return (d.getMonth() + 1) + '/' + d.getDate() + '（' + days[d.getDay()] + '）';
    },

    _getItemShippingType: function (item) {
      if (!item) return 'ambient';
      var meta = (window.cartItemsMetafields && window.cartItemsMetafields[item.key]) || {};
      var tz = meta.temperature_zone || '常温';
      if (tz === '冷凍') return 'frozen';
      if (tz === '常温メール便') return 'mail';
      return 'ambient';
    },

    _formatMoney: function (amount) {
      var n = parseInt(amount, 10) || 0;
      return n.toLocaleString('ja-JP') + '円';
    },

    _renderDiscountPricePair: function (originalHtml, discountedHtml) {
      return (
        '<s class="price price--original">' + originalHtml + '</s>' +
        '&nbsp;&nbsp;' +
        '<span class="price price--discounted">' + discountedHtml + '</span>'
      );
    },

    _escapeHtml: function (str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    },

    _escapeAttr: function (str) {
      return String(str || '').replace(/"/g, '&quot;');
    },

    /**
     * yokumoku.max-cart-pcs に基づき、当該ライン分として許容できる残り数量を返す
     * (max_cart_pcs - 同一productIdの他ラインの合計qty)
     * 上限が設定されていない、またはMaxCartPcs不在のときは null
     */
    _getMaxCartPcsRemainingForItem: function (itemKey) {
      if (!window.MaxCartPcs || !window.MaxCartPcs.getLimit) return null;
      var cart = state.cart || {};
      var items = Array.isArray(cart.items) ? cart.items : [];
      var item = items.find(function (ci) { return ci.key === itemKey; });
      if (!item) return null;
      var limit = window.MaxCartPcs.getLimit(item.product_id);
      if (limit == null) return null;
      var otherQty = 0;
      items.forEach(function (ci) {
        if (String(ci.product_id) !== String(item.product_id)) return;
        if (ci.key === itemKey) return;
        otherQty += parseInt(ci.quantity, 10) || 0;
      });
      return Math.max(0, limit - otherQty);
    },

    /**
     * カートサジェストルールに基づく数量上限を返す
     * サジェスト対象でない場合は null を返す
     */
    _getCartSuggestMaxQty: function (itemKey) {
      if (!window.cartSuggestRules || !window.cartSuggestRules.length) return null;
      var cart = state.cart || {};
      var items = Array.isArray(cart.items) ? cart.items : [];
      var item = items.find(function (ci) { return ci.key === itemKey; });
      if (!item) return null;
      var variantId = item.variant_id;
      for (var i = 0; i < window.cartSuggestRules.length; i++) {
        var rule = window.cartSuggestRules[i];
        if (rule.suggestVariantId !== variantId) continue;
        var total = 0;
        items.forEach(function (ci) {
          if (rule.collectionProductIds.indexOf(ci.product_id) !== -1) {
            total += ci.quantity;
          }
        });
        return total;
      }
      return null;
    },

    // ---------------------------------------------------------------------------
    // Sync parent Noshi/ribbon count after a non-split quantity change
    // ---------------------------------------------------------------------------

    _syncUnsplitGiftCount: function(itemKey, actualQty) {
      // Skip when 2+ active split lines remain — each split line owns its own count.
      var splitCfg = state.singleSplitLines && state.singleSplitLines[itemKey];
      if (splitCfg && Array.isArray(splitCfg.lines) && splitCfg.lines.length >= 2) return;
      var changed = false;
      if (state.noshiSettings && state.noshiSettings[itemKey] && state.noshiSettings[itemKey].count != null) {
        state.noshiSettings[itemKey].count = actualQty;
        changed = true;
      }
      if (state.stickerSettings && state.stickerSettings[itemKey] && state.stickerSettings[itemKey].count != null) {
        state.stickerSettings[itemKey].count = actualQty;
        changed = true;
      }
      if (changed) this._saveData();
    },

    // ---------------------------------------------------------------------------
    // Cart quantity update (item qty +/-)
    // ---------------------------------------------------------------------------

    _updateCartItemUI: function (itemKey, newQuantity) {
      var $wrapper = $('[data-item-key="' + itemKey + '"]');
      // Read prices from first element; apply markup to all (mobile u-sm-max + desktop u-sm-min).
      // Use .attr() not .data() — jQuery caches .data() from initial read, misses later .attr() writes
      var $units = $wrapper.find('.cart-item__unit');
      var $unit = $units.first();
      var unitPrice = parseFloat($unit.attr('data-unit')) || 0;
      var discountedUnit = parseFloat($unit.attr('data-discounted-unit'));
      // Look up authoritative cart item before computing discount flags so line-level discounts
      // (original_line_price > final_line_price with equal unit prices) are detected correctly.
      var _uciSourceKey = (self.isSplitLineKey && self.isSplitLineKey(itemKey))
        ? ((self.parseSplitLineKey(itemKey) || {}).itemKey || itemKey)
        : itemKey;
      var _uciCartItem = state.cart && (state.cart.items || []).find(function(i) { return i.key === _uciSourceKey; });
      var hasUnitDiscount = Number.isFinite(discountedUnit) && discountedUnit < unitPrice;
      var hasDiscount = hasUnitDiscount || ($unit.attr('data-has-discount') === 'true') ||
        (_uciCartItem && _uciCartItem.original_line_price != null && _uciCartItem.original_line_price > _uciCartItem.final_line_price);
      // Update unit price display in case discount changed (e.g. tier pricing by quantity)
      if (hasUnitDiscount) {
        $units.html(this._renderDiscountPricePair(this._formatMoney(unitPrice), this._formatMoney(discountedUnit)));
      } else {
        $units.html('<span class="price">' + unitPrice.toLocaleString('ja-JP') + '円</span>');
      }
      var _uciSplitCfg = (_uciSourceKey !== itemKey) && state.singleSplitLines && state.singleSplitLines[_uciSourceKey];
      var discTotal, newTotal;
      if (_uciSplitCfg && Array.isArray(_uciSplitCfg.lines) && _uciSplitCfg.lines.length > 1
          && _uciCartItem && _uciCartItem.quantity > 0) {
        // Sibling-aware floor+remainder distribution in integer yen.
        var _uciParsed = self.parseSplitLineKey ? self.parseSplitLineKey(itemKey) : null;
        var _uciMyIdx = _uciParsed ? _uciSplitCfg.lines.findIndex(function(l) {
          return String(l.id) === String(_uciParsed.lineId);
        }) : -1;
        if (_uciMyIdx >= 0) {
          var _uciTotQty = _uciCartItem.quantity;
          // Convert to integer yen before distributing so parseInt in the formatter is lossless.
          var _uciFinalYen = Math.round((_uciCartItem.final_line_price || 0) / 100);
          var _uciOrigYen  = Math.round((_uciCartItem.original_line_price || 0) / 100);
          var _uciDiscFloors = _uciSplitCfg.lines.map(function(l) {
            return Math.floor(_uciFinalYen * (parseInt(l.qty, 10) || 0) / _uciTotQty);
          });
          _uciDiscFloors[_uciDiscFloors.length - 1] +=
            _uciFinalYen - _uciDiscFloors.reduce(function(s, v) { return s + v; }, 0);
          var _uciOrigFloors = _uciSplitCfg.lines.map(function(l) {
            return Math.floor(_uciOrigYen * (parseInt(l.qty, 10) || 0) / _uciTotQty);
          });
          _uciOrigFloors[_uciOrigFloors.length - 1] +=
            _uciOrigYen - _uciOrigFloors.reduce(function(s, v) { return s + v; }, 0);
          discTotal = _uciDiscFloors[_uciMyIdx];
          newTotal  = _uciOrigFloors[_uciMyIdx];
        }
      }
      if (discTotal === undefined) {
        // Non-split or no split context: proportional with /100 unit conversion.
        discTotal = (_uciCartItem && _uciCartItem.final_line_price != null && _uciCartItem.quantity > 0)
          ? Math.round(_uciCartItem.final_line_price * newQuantity / _uciCartItem.quantity) / 100
          : Math.round((hasUnitDiscount ? discountedUnit : unitPrice) * newQuantity);
        newTotal = (_uciCartItem && _uciCartItem.original_line_price != null && _uciCartItem.quantity > 0)
          ? Math.round(_uciCartItem.original_line_price * newQuantity / _uciCartItem.quantity) / 100
          : Math.round(unitPrice * newQuantity);
      }
      if (hasDiscount) {
        $wrapper.find('.cart-item__total').html(this._renderDiscountPricePair(this._formatMoney(Math.round(newTotal)), this._formatMoney(Math.round(discTotal))));
      } else {
        $wrapper.find('.cart-item__total').html('<span class="price">' + Math.round(newTotal).toLocaleString('ja-JP') + '円</span>');
      }
    },

    _debouncedUpdateCartQuantity: function (itemKey, quantity) {
      var self = this;
      if (!this._quantityTimers) this._quantityTimers = {};
      if (!this._quantitySeq) this._quantitySeq = {};
      if (!this._qtyIntent) this._qtyIntent = {};
      clearTimeout(this._quantityTimers[itemKey]);
      // Track pending intent so pagehide can flush it
      this._qtyIntent[itemKey] = quantity;
      this._quantitySeq[itemKey] = (this._quantitySeq[itemKey] || 0) + 1;
      var seq = this._quantitySeq[itemKey];
      this._quantityTimers[itemKey] = setTimeout(function () {
        delete self._qtyIntent[itemKey];
        self._updateCartQuantity(itemKey, quantity, seq);
      }, 400);
    },

    /**
     * Flush all pending (debounced) cart qty updates via sendBeacon on page unload.
     */
    _flushPendingQtyUpdates: function () {
      var self = this;
      var intents = self._qtyIntent || {};
      Object.keys(intents).forEach(function (itemKey) {
        clearTimeout(self._quantityTimers && self._quantityTimers[itemKey]);
        var qty = intents[itemKey];
        if (qty !== undefined && navigator.sendBeacon) {
          navigator.sendBeacon('/cart/change.js', new URLSearchParams({ id: itemKey, quantity: String(qty) }));
        }
        delete intents[itemKey];
      });
    },

    _updateCartQuantity: function (itemKey, quantity, seq) {
      var self = this;
      var $wrapper = $('[data-item-key="' + itemKey + '"]');
      $wrapper.addClass('is-loading');
      $wrapper.find('.js-qtyBtn:not(.js-bagQtyBtn)').prop('disabled', true).addClass('is-disabled');
      $wrapper.find('.qty__input').not('.js-bagQtyInput').prop('disabled', true);
      var needsReconcile = false;
      // Capture pre-request item identity for Shopify automatic-discount re-key detection.
      // After a quantity POST, the Cart API may return the same line under a new key.
      // We use variant_id + properties + selling_plan as stable identity to distinguish
      // a genuine deletion from a re-key event.
      var _preReqItem = self._getCartItemByKey(itemKey);
      var _findReKeyedItem = function(items) {
        if (!_preReqItem) return null;
        var vid = _preReqItem.variant_id;
        var props = _preReqItem.properties || {};
        var spId = _preReqItem.selling_plan_allocation ? _preReqItem.selling_plan_allocation.selling_plan.id : null;
        var pKeys = Object.keys(props);
        return (items || []).find(function(i) {
          if (i.key === itemKey) return false;
          if (i.variant_id !== vid) return false;
          var iSpId = i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : null;
          if (iSpId !== spId) return false;
          var iProps = i.properties || {};
          if (pKeys.length !== Object.keys(iProps).length) return false;
          return pKeys.every(function(k) { return String(iProps[k]) === String(props[k]); });
        }) || null;
      };

      var _qtyAjax = $.ajax({
        url: '/cart/change.js',
        type: 'POST',
        dataType: 'json',
        data: { id: itemKey, quantity: quantity }
      });
      if (!self._pendingMutation) self._pendingMutation = {};
      self._pendingMutation[itemKey] = _qtyAjax;
      _qtyAjax.always(function() {
        if (self._pendingMutation && self._pendingMutation[itemKey] === _qtyAjax) {
          delete self._pendingMutation[itemKey];
        }
      });
      _qtyAjax.done(function (cart) {
        if (seq !== undefined && self._quantitySeq && self._quantitySeq[itemKey] !== seq) {
          // Shopify may have already applied the mutation. Fetch a fresh cart to reconcile
          // client state so that UI and server quantities stay in sync.
          needsReconcile = true;
          var reconcileSeq = self._quantitySeq[itemKey];
          // Wait for any newer pending write to settle before reading authoritative cart state.
          var _pendingMut = self._pendingMutation && self._pendingMutation[itemKey];
          var _afterMut = _pendingMut ? $.when(_pendingMut) : $.when();
          _afterMut.always(function() {
            if (self._quantitySeq[itemKey] !== reconcileSeq) return;
            $.getJSON('/cart.js')
              .done(function(freshCart) {
                if (self._quantitySeq[itemKey] !== reconcileSeq) return;
                state.cart = freshCart;
                var freshItem = (freshCart.items || []).find(function(i) { return i.key === itemKey; });
                if (!freshItem) {
                  var _reKeyedFresh = _findReKeyedItem(freshCart.items);
                  if (_reKeyedFresh) {
                    self._migrateItemKey(itemKey, _reKeyedFresh.key);
                    itemKey = _reKeyedFresh.key;
                    freshItem = _reKeyedFresh;
                  }
                }
                if (freshItem) {
                  var freshQty = freshItem.quantity;
                  var $w = $('[data-item-key="' + itemKey + '"]');
                  var freshOrigUnit = (freshItem.original_price != null ? freshItem.original_price : freshItem.price) / 100;
                  var freshFinalUnit = (freshItem.final_price != null ? freshItem.final_price : freshItem.price) / 100;
                  var _freshHasDisc = freshFinalUnit < freshOrigUnit || (freshItem.original_line_price != null && freshItem.original_line_price > freshItem.final_line_price);
                  $w.find('.cart-item__unit')
                    .attr('data-unit', freshOrigUnit)
                    .attr('data-discounted-unit', freshFinalUnit < freshOrigUnit ? freshFinalUnit : '')
                    .attr('data-has-discount', _freshHasDisc ? 'true' : '');
                  self._updateCartItemUI(itemKey, freshQty);
                  $w.find('.qty__input').not('.js-bagQtyInput').first().val(freshQty).attr('value', freshQty);
                  var isDecreaseDisabled = freshQty <= 1;
                  $w.find('.js-qtyBtn[data-step="-1"]').not('.js-bagQtyBtn').prop('disabled', isDecreaseDisabled).toggleClass('is-disabled', isDecreaseDisabled);
                  var suggestMax = self._getCartSuggestMaxQty(itemKey);
                  var inventoryMax = parseInt($w.data('max-qty'), 10);
                  var pcsRemaining = self._getMaxCartPcsRemainingForItem ? self._getMaxCartPcsRemainingForItem(itemKey) : null;
                  var effectiveMax = suggestMax;
                  if (isFinite(inventoryMax) && inventoryMax > 0) effectiveMax = (effectiveMax === null) ? inventoryMax : Math.min(effectiveMax, inventoryMax);
                  if (pcsRemaining !== null) effectiveMax = (effectiveMax === null) ? pcsRemaining : Math.min(effectiveMax, pcsRemaining);
                  var isIncreaseDisabled = effectiveMax !== null && freshQty >= effectiveMax;
                  $w.find('.js-qtyBtn[data-step="1"]').not('.js-bagQtyBtn').prop('disabled', isIncreaseDisabled).toggleClass('is-disabled', isIncreaseDisabled);
                  self._syncUnsplitGiftCount(itemKey, freshQty);
                } else {
                  // Genuinely removed — clear data and redirect to cart
                  self._clearAllEgiftData();
                  window.location.replace('/cart');
                  return;
                }
                self._updateOrderSummary();
                self._calculateEgiftShippingRate();
                $wrapper.removeClass('is-loading');
                $wrapper.find('.qty__input').not('.js-bagQtyInput').prop('disabled', false);
              })
              .fail(function() {
                if (self._quantitySeq[itemKey] !== reconcileSeq) return;
                window.location.reload();
              });
          });
          return;
        }

        if (self._qtyIntent) delete self._qtyIntent[itemKey];
        state.cart = cart;

        var updatedItem = null;
        var items = cart.items || [];
        for (var i = 0; i < items.length; i++) {
          if (items[i].key === itemKey) { updatedItem = items[i]; break; }
        }
        if (!updatedItem) {
          var _reKeyedItem = _findReKeyedItem(items);
          if (_reKeyedItem) {
            self._migrateItemKey(itemKey, _reKeyedItem.key);
            itemKey = _reKeyedItem.key;
            $wrapper = $('[data-item-key="' + itemKey + '"]');
            updatedItem = _reKeyedItem;
          }
        }

        if (updatedItem) {
          var actualQty = updatedItem.quantity;

          // Refresh data-unit/data-discounted-unit from POST response before updating UI,
          // so tier-pricing or discount changes after qty update are reflected correctly.
          var $unitEl = $('[data-item-key="' + itemKey + '"]').find('.cart-item__unit').first();
          var updatedOriginalUnit = (updatedItem.original_price != null ? updatedItem.original_price : updatedItem.price) / 100;
          var updatedFinalUnit = (updatedItem.final_price != null ? updatedItem.final_price : updatedItem.price) / 100;
          var _updatedHasDisc = updatedFinalUnit < updatedOriginalUnit || (updatedItem.original_line_price != null && updatedItem.original_line_price > updatedItem.final_line_price);
          $unitEl.attr('data-unit', updatedOriginalUnit);
          $unitEl.attr('data-discounted-unit', updatedFinalUnit < updatedOriginalUnit ? updatedFinalUnit : '');
          $unitEl.attr('data-has-discount', _updatedHasDisc ? 'true' : '');

          self._updateCartItemUI(itemKey, actualQty);
          $wrapper.find('.qty__input').not('.js-bagQtyInput').first().val(actualQty);

          var isDecreaseDisabled = actualQty <= 1;
          $wrapper.find('.js-qtyBtn[data-step="-1"]').not('.js-bagQtyBtn').prop('disabled', isDecreaseDisabled).toggleClass('is-disabled', isDecreaseDisabled);

          // カートサジェスト商品の数量上限チェック
          var suggestMax = self._getCartSuggestMaxQty(itemKey);
          var inventoryMax = parseInt($wrapper.data('max-qty'), 10);
          var isIncreaseDisabled = (suggestMax !== null && actualQty >= suggestMax) ||
                                   (isFinite(inventoryMax) && inventoryMax > 0 && actualQty >= inventoryMax);
          $wrapper.find('.js-qtyBtn[data-step="1"]').not('.js-bagQtyBtn').prop('disabled', isIncreaseDisabled).toggleClass('is-disabled', isIncreaseDisabled);

          var _ffRule = self._getBagRuleConfig(itemKey);
          var _ffFree = _ffRule.forceFree ? self._getFreeHandbagVariantForItem(itemKey) : null;
          var _ffVid = _ffFree ? String(_ffFree.shopifyProductVariantId) : null;

          // Clamp bag qty if it exceeds the new product qty
          var $bagQtyInput = $wrapper.find('.js-bagQtyInput');
          if ($bagQtyInput.length && !$bagQtyInput.prop('disabled')) {
            var displayedBagQty = parseInt($bagQtyInput.val(), 10) || 0;
            if (displayedBagQty > actualQty) {
              $bagQtyInput.val(actualQty);
              $bagQtyInput.closest('.qty').find('[data-step="1"]').prop('disabled', true);
              var settings = self._getBagSettings(itemKey, true);
              var $freeCb = $wrapper.find('[data-bag-type="free"]');
              var variantId = String($freeCb.attr('data-bag-variant-id') || '');
              if (variantId && settings.bags) settings.bags[variantId] = actualQty;
              $wrapper.find('[data-bag-status]').html(self._renderBagStatusSummary(itemKey));
              self._saveData();
            }
          }

          // forceFree（必ず付ける）: qty UI を非表示にしているため上の sync は走らない。
          // 商品数の増減に追従して bag settings を更新する。
          if (_ffRule.forceFree && _ffVid) {
            var ffSettings = self._getBagSettings(itemKey, true);
            ffSettings.freeBagEnabled = true;
            if (!ffSettings.bags) ffSettings.bags = {};
            ffSettings.bags[_ffVid] = actualQty;
            ffSettings.bagSelection = 'on';
            $wrapper.find('[data-bag-status]').html(self._renderBagStatusSummary(itemKey));
            self._saveData();
          }

          self._syncUnsplitGiftCount(itemKey, actualQty);
        } else {
          // Item genuinely removed — clear data and redirect to cart
          self._clearAllEgiftData();
          window.location.replace('/cart');
          return;
        }

        self._updateOrderSummary();
        self._calculateEgiftShippingRate();
      })
      .fail(function () {
        if (seq !== undefined && self._quantitySeq && self._quantitySeq[itemKey] !== seq) return;
        if (self._qtyIntent) delete self._qtyIntent[itemKey];
        console.error('Failed to update cart quantity for item: ' + itemKey);
        var cartItem = self._getCartItemByKey(itemKey);
        if (cartItem) {
          $wrapper.find('.qty__input').not('.js-bagQtyInput').first().val(cartItem.quantity);
          var isDecreaseDisabled = cartItem.quantity <= 1;
          $wrapper.find('.js-qtyBtn[data-step="-1"]').not('.js-bagQtyBtn').prop('disabled', isDecreaseDisabled).toggleClass('is-disabled', isDecreaseDisabled);
          var suggestMax = self._getCartSuggestMaxQty(itemKey);
          var inventoryMax = parseInt($wrapper.data('max-qty'), 10);
          var isIncreaseDisabled = (suggestMax !== null && cartItem.quantity >= suggestMax) ||
                                   (isFinite(inventoryMax) && inventoryMax > 0 && cartItem.quantity >= inventoryMax);
          $wrapper.find('.js-qtyBtn[data-step="1"]').not('.js-bagQtyBtn').prop('disabled', isIncreaseDisabled).toggleClass('is-disabled', isIncreaseDisabled);
        }
      })
      .always(function () {
        // Skip if reconciliation GET is in flight — it will handle unlock when it settles.
        if (needsReconcile) return;
        $wrapper.removeClass('is-loading');
        $wrapper.find('.qty__input').not('.js-bagQtyInput').prop('disabled', false);
      });
    },

    _toBoolean: function (value) {
      return value === true || value === 'true' || value === 1 || value === '1';
    }
  };

  // Expose static helpers for use in event handlers
  EgiftShippingApp = app;
  return app;

})();

// ---------------------------------------------------------------------------
// Boot
// ---------------------------------------------------------------------------

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    EgiftShippingApp.init();
  });
} else {
  EgiftShippingApp.init();
}

// ---------------------------------------------------------------------------
// Modal close handlers (delegated — same pattern as shipping-common.js)
// ---------------------------------------------------------------------------

$(document).on('click', '.js-close', function (e) {
  if ($(e.target).hasClass('js-close') || $(e.target).closest('.js-close').length) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var $modal = $(this).closest('.p-modal');
    if (!$modal.length) $modal = $('.p-modal.active');
    $modal.each(function () {
      EgiftShippingApp.closeModal($(this).attr('id'));
    });
  }
});

// Noshi/sticker count ＋− buttons
$(document).on('click', '.js-noshiCountBtn, .js-stickerCountBtn', function (e) {
  e.preventDefault();
  if ($(this).prop('disabled') || $(this).hasClass('is-disabled')) return;
  var $input = $(this).siblings('[data-noshi-count-input], [data-sticker-count-input]').first();
  var current = EgiftShippingApp.syncGiftSettingCountControl($input);
  $input.val(current + (parseInt($(this).data('step'), 10) || 0));
  EgiftShippingApp.syncGiftSettingCountControl($input);
});

$(document).on('input change', '[data-noshi-count-input], [data-sticker-count-input]', function (event) {
  var $input = $(this);
  if (String($input.val() || '').trim() === '') {
    // input イベント（入力中）は空のまま許可（入力継続のため）
    // change イベント（フォーカスアウト）はカートと同じ挙動：エラー表示 + 値を復元
    if (event.type === 'change') {
      var max = EgiftShippingApp._getGiftSettingCountMax($input);
      $input[0].setCustomValidity('数量を入力してください');
      $input[0].reportValidity();
      $input[0].setCustomValidity('');
      $input.val(max);
      EgiftShippingApp.syncGiftSettingCountControl($input);
      $input[0].select();
    }
    return;
  }
  EgiftShippingApp.syncGiftSettingCountControl($(this));
});

// Split card qty buttons
$(document).on('click', '.js-splitQtyBtn', function (e) {
  e.preventDefault();
  if ($(this).prop('disabled') || $(this).hasClass('is-disabled')) return;
  var $input = $(this).siblings('.js-splitQtyInput');
  var step = parseInt($(this).data('step'), 10) || 0;
  var val = parseInt($input.val(), 10) || 1;
  var max = parseInt($input.attr('max'), 10) || 999;
  var newVal = Math.max(1, Math.min(val + step, max));
  $input.val(newVal);
  var $wrapper = $(this).closest('[data-item-key]');
  var splitLineKey = $wrapper.data('item-key');
  var sourceItemKey = $wrapper.data('source-item-key');
  if (splitLineKey && sourceItemKey) {
    EgiftShippingApp.updateSingleSplitLineQty(splitLineKey, newVal);
  }
});

// Open noshi modal from summary 変更 link
$(document).on('click', '[data-open-noshi]', function (e) {
  e.preventDefault();
  var itemKey = $(this).attr('data-open-noshi');
  var splitLineKey = $(this).attr('data-split-line-key') || null;
  EgiftShippingApp.openNoshiModal(itemKey, splitLineKey);
});

// Open sticker modal from summary 変更 link
$(document).on('click', '[data-open-sticker]', function (e) {
  e.preventDefault();
  var itemKey = $(this).attr('data-open-sticker');
  var splitLineKey = $(this).attr('data-split-line-key') || null;
  EgiftShippingApp.openStickerModal(itemKey, splitLineKey);
});

// Save noshi
$(document).on('click', '[data-save-noshi]', function (e) {
  e.preventDefault();
  EgiftShippingApp.saveNoshi();
});

// Show alert when save button is clicked while disabled
$(document).on('click', '.js-noshi-save-area', function () {
  if ($('#modalGift [data-save-noshi]').prop('disabled')) {
    window.alert('のしプレビューをご確認ください。');
  }
});

// Save sticker/ribbon
$(document).on('click', '[data-save-sticker]', function () {
  EgiftShippingApp.saveStickerSelection();
});

// Save bag modal
$(document).on('click', '[data-save-bag]', function (e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  EgiftShippingApp._saveBagSelection();
});

// Paid bag modal quantity controls
$(document).on('click', '[data-bag-qty-btn]', function (e) {
  e.preventDefault();
  var maxQty = 500;
  var $btn = $(this);
  var $row = $btn.closest('.optionRow');
  var $input = $row.find('[data-bag-qty-input]');
  var step = parseInt($btn.attr('data-step'), 10) || 0;
  var current = parseInt($input.val(), 10) || 0;
  var next = Math.max(0, Math.min(maxQty, current + step));
  $input.val(next);
  EgiftShippingApp._updateBagModalSubtotal();
});

$(document).on('change', '[data-bag-qty-input]', function () {
  var maxQty = 500;
  var $input = $(this);
  var val = parseInt($input.val(), 10) || 0;
  $input.val(Math.max(0, Math.min(maxQty, val)));
  EgiftShippingApp._updateBagModalSubtotal();
});

$(document).on('change', '#sticker-unified-select', function () {
  $('[data-save-sticker]').prop('disabled', !$(this).val());
});

// Noshi purpose filtering
$(document).on('change', '#noshi-purpose-select', function () {
  var purpose = $(this).val() || '';
  EgiftShippingApp.handleNoshiPurposeChange(purpose);
});

// Noshi card select
$(document).on('click', '#modalGift .p-gift-item', function (e) {
  e.preventDefault();
  EgiftShippingApp.handleNoshiCardSelect($(this));
});

// Noshi preview input updates
$(document).on('input', '#noshi-line1, #noshi-line2, #noshi-uchiiwai-name, #noshi-uchiiwai-furigana, #corpCompany, #corpTitle, #corpName', function () {
  if (window.NoshiDialogCommon && ($(this).is('#noshi-line1') || $(this).is('#noshi-line2'))) {
    window.NoshiDialogCommon.sanitizeNormalNoshiNameInput(this);
  }
  if (window.NoshiDialogCommon && ($(this).is('#noshi-uchiiwai-name') || $(this).is('#noshi-uchiiwai-furigana'))) {
    window.NoshiDialogCommon.sanitizeUchiiwaiNoshiInput(this);
  }
  if (window.NoshiDialogCommon && $(this).is('#corpName')) {
    window.NoshiDialogCommon.sanitizeCorporateNoshiNameInput(this);
  }
  if (window.NoshiDialogCommon && $(this).is('#corpCompany')) {
    window.NoshiDialogCommon.sanitizeCorporateNoshiCompanyInput(this);
  }
  if (window.NoshiDialogCommon && $(this).is('#corpTitle')) {
    window.NoshiDialogCommon.sanitizeCorporateNoshiTitleInput(this);
  }
  EgiftShippingApp.updateNoshiPreview();
});

// Noshi preview button
$(document).on('click', '[data-noshi-preview-btn]', function (e) {
  e.preventDefault();
  EgiftShippingApp.handleNoshiPreviewClick();
});

// Noshi corporate fields toggle
$(document).on('change', '#modalGift .js-corpToggle', function () {
  EgiftShippingApp.handleCorpToggle();
});
